
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("XHGTv", function(module, exports) {

$parcel$export(module.exports, "setBooleanFeatureFlagResolver", () => $a4140a252773f712$export$ba05d765b8392e5e);
$parcel$export(module.exports, "getBooleanFF", () => $a4140a252773f712$export$470e5c2be1411c89);
$parcel$export(module.exports, "fg", () => $a4140a252773f712$export$b40ec24ac8275656);

var $jJ8fN = parcelRequire("jJ8fN");
function $a4140a252773f712$export$ba05d765b8392e5e(flagResolver) {
    (0, $jJ8fN.setBooleanResolver)(flagResolver);
}
function $a4140a252773f712$export$470e5c2be1411c89(name) {
    return (0, $jJ8fN.resolveBooleanFlag)(name);
}
function $a4140a252773f712$export$b40ec24ac8275656(name) {
    return (0, $jJ8fN.resolveBooleanFlag)(name);
}

});
parcelRegister("jJ8fN", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", () => $519f2419059718c8$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $519f2419059718c8$export$6333b6aff9fc6275);

var $g0bIE = parcelRequire("g0bIE");

var $2fFJv = parcelRequire("2fFJv");
const $519f2419059718c8$var$pkgName = '@atlaskit/platform-feature-flags';
const $519f2419059718c8$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
const $519f2419059718c8$var$hasProcessEnv = typeof $2fFJv !== 'undefined' && typeof $2fFJv.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
const $519f2419059718c8$var$ENV_ENABLE_PLATFORM_FF = $519f2419059718c8$var$hasProcessEnv ? false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
const $519f2419059718c8$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $519f2419059718c8$var$hasProcessEnv ? false : false;
const $519f2419059718c8$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $519f2419059718c8$var$ENV_ENABLE_PLATFORM_FF || $519f2419059718c8$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
const $519f2419059718c8$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function(flagKey) {
        return false;
    }
};
const $519f2419059718c8$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$519f2419059718c8$var$globalVar[$519f2419059718c8$export$7e41b1b2bdee3f98] = $519f2419059718c8$var$globalVar[$519f2419059718c8$export$7e41b1b2bdee3f98] || $519f2419059718c8$var$DEFAULT_PFF_GLOBAL;
function $519f2419059718c8$export$f2b591175b3e424c(resolver) {
    $519f2419059718c8$var$globalVar[$519f2419059718c8$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $519f2419059718c8$export$6333b6aff9fc6275(flagKey) {
    if ($519f2419059718c8$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $g0bIE.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $519f2419059718c8$var$pkgName, flagKey);
        return true;
    }
    try {
        const result = $519f2419059718c8$var$globalVar[$519f2419059718c8$export$7e41b1b2bdee3f98]?.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn(`${flagKey} resolved to a non-boolean value, returning false for safety`);
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("g0bIE", function(module, exports) {

$parcel$export(module.exports, "debug", () => $0e7ebf480c2d1329$export$1c9f709888824e05);
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
const $0e7ebf480c2d1329$var$TESTS_MODE = (globalThis?.process?.env?.JEST_WORKER_ID !== undefined) ?? false;
const $0e7ebf480c2d1329$var$DEBUG_MODE = !$0e7ebf480c2d1329$var$TESTS_MODE && globalThis?.process?.env?.NODE_ENV !== 'production';
const $0e7ebf480c2d1329$export$1c9f709888824e05 = (...args)=>{
    if (!$0e7ebf480c2d1329$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    console.debug(...args);
};

});



parcelRegister("jsCXU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea8496fca0ecbd01$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $ea8496fca0ecbd01$export$2e2bcd8739ae039 = (0, $eUqFw.createContext)(null);

});

parcelRegister("8tM2T", function(module, exports) {

$parcel$export(module.exports, "default", () => $850ad113b2f8306c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FeatureGateEnvironment", () => (parcelRequire("g4RkH")).FeatureGateEnvironment);

var $avKkz = parcelRequire("avKkz");

var $97SU4 = parcelRequire("97SU4");

var $g4RkH = parcelRequire("g4RkH");

var $kzNT7 = parcelRequire("kzNT7");
const $850ad113b2f8306c$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// the default event logging api is the Atlassian proxy rather than Statsig's domain, to avoid ad blockers
const $850ad113b2f8306c$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/';
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ class $850ad113b2f8306c$var$FeatureGates {
    static{
        this.initPromise = null;
    }
    static{
        this.initCompleted = false;
    }
    static{
        this.hasGetExperimentErrorOccurred = false;
    }
    static{
        this.hasGetExperimentValueErrorOccurred = false;
    }
    static{
        this.hasGetLayerErrorOccurred = false;
    }
    static{
        this.hasGetLayerValueErrorOccurred = false;
    }
    static{
        this.hasCheckGateErrorOccurred = false;
    }
    /**
	 * @description
	 * This method initializes the client using a network call to fetch the bootstrap values.
	 * If the client is inialized with an `analyticsWebClient`, it will send an operational event
	 * to GASv3 with the following attributes:
	 * - targetApp: the target app of the client
	 * - clientVersion: the version of the client
	 * - success: whether the initialization was successful
	 * - startTime: the time when the initialization started
	 * - totalTime: the total time it took to initialize the client
	 * - apiKey: the api key used to initialize the client
	 * @param clientOptions {ClientOptions}
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 * @returns {Promise<void>}
	 */ static async initialize(clientOptions, identifiers, customAttributes) {
        if ($850ad113b2f8306c$var$FeatureGates.initPromise) {
            if (!$850ad113b2f8306c$var$FeatureGates.shallowEquals(clientOptions, $850ad113b2f8306c$var$FeatureGates.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return $850ad113b2f8306c$var$FeatureGates.initPromise;
        }
        const startTime = performance.now();
        $850ad113b2f8306c$var$FeatureGates.initOptions = clientOptions;
        $850ad113b2f8306c$var$FeatureGates.initPromise = $850ad113b2f8306c$var$FeatureGates.init(clientOptions, identifiers, customAttributes).then(()=>{
            $850ad113b2f8306c$var$FeatureGates.initCompleted = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            $850ad113b2f8306c$var$FeatureGates.fireClientEvent(startTime, totalTime, 'initialize', $850ad113b2f8306c$var$FeatureGates.initCompleted, clientOptions.apiKey);
        });
        return $850ad113b2f8306c$var$FeatureGates.initPromise;
    }
    static fireClientEvent(startTime, totalTime, action, success, apiKey) {
        $850ad113b2f8306c$var$FeatureGates.initOptions.analyticsWebClient?.then((analyticsWebClient)=>{
            const attributes = {
                targetApp: $850ad113b2f8306c$var$FeatureGates.initOptions.targetApp,
                clientVersion: (0, $kzNT7.CLIENT_VERSION),
                success: success,
                startTime: startTime,
                totalTime: totalTime,
                ...apiKey && {
                    apiKey: apiKey
                }
            };
            analyticsWebClient.sendOperationalEvent({
                action: action,
                actionSubject: 'featureGatesClient',
                attributes: attributes,
                tags: [
                    'measurement'
                ],
                source: '@atlaskit/feature-gate-js-client'
            });
        }).catch((err)=>{
            if ($850ad113b2f8306c$var$FeatureGates.initOptions.environment !== (0, $g4RkH.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
            console.error('Analytics web client promise did not resolve', err);
        });
    }
    static async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        if ($850ad113b2f8306c$var$FeatureGates.initPromise) {
            if (!$850ad113b2f8306c$var$FeatureGates.shallowEquals(clientOptions, $850ad113b2f8306c$var$FeatureGates.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return $850ad113b2f8306c$var$FeatureGates.initPromise;
        }
        const startTime = performance.now();
        $850ad113b2f8306c$var$FeatureGates.initOptions = clientOptions;
        $850ad113b2f8306c$var$FeatureGates.initPromise = $850ad113b2f8306c$var$FeatureGates.initFromValues(clientOptions, identifiers, customAttributes, initializeValues).then(()=>{
            $850ad113b2f8306c$var$FeatureGates.initCompleted = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            $850ad113b2f8306c$var$FeatureGates.fireClientEvent(startTime, totalTime, 'initializeFromValues', $850ad113b2f8306c$var$FeatureGates.initCompleted);
        });
        return $850ad113b2f8306c$var$FeatureGates.initPromise;
    }
    /**
	 * This method updates the user using a network call to fetch the new set of values.
	 * @param fetchOptions {FetcherOptions}
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 */ static async updateUser(fetchOptions, identifiers, customAttributes) {
        const initializeValuesProducer = ()=>(0, $97SU4.default).fetchExperimentValues(fetchOptions, identifiers, customAttributes).then(({ experimentValues: experimentValues, customAttributes: customAttributes })=>({
                    experimentValues: experimentValues,
                    customAttributesFromFetch: customAttributes
                }));
        await $850ad113b2f8306c$var$FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    /**
	 * This method updates the user given a new set of bootstrap values obtained from one of the server-side SDKs.
	 *
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 * @param initializeValues {Record<string,unknown>}
	 */ static async updateUserWithValues(identifiers, customAttributes, initializeValues = {}) {
        const initializeValuesProducer = ()=>Promise.resolve({
                experimentValues: initializeValues,
                customAttributesFromFetch: customAttributes
            });
        await $850ad113b2f8306c$var$FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    static initializeCalled() {
        return $850ad113b2f8306c$var$FeatureGates.initPromise != null;
    }
    static initializeCompleted() {
        return $850ad113b2f8306c$var$FeatureGates.initCompleted;
    }
    /**
	 * Returns the value for a feature gate. Returns false if there are errors.
	 * @param {string} gateName - The name of the feature gate.
	 * @param {Object} options
	 * @param {boolean} options.fireGateExposure
	 *        Whether or not to fire the exposure event for the gate. Defaults to true.
	 *        To log an exposure event manually at a later time, use {@link FeatureGates.manuallyLogGateExposure}
	 *        (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 */ static checkGate(gateName, options = {}) {
        try {
            const { fireGateExposure: fireGateExposure = true } = options;
            const evalMethod = fireGateExposure ? (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).checkGate.bind((0, (/*@__PURE__*/$parcel$interopDefault($avKkz)))) : (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).checkGateWithExposureLoggingDisabled.bind((0, (/*@__PURE__*/$parcel$interopDefault($avKkz))));
            return evalMethod(gateName);
        } catch (error) {
            // Log the first occurrence of the error
            if (!$850ad113b2f8306c$var$FeatureGates.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                $850ad113b2f8306c$var$FeatureGates.hasCheckGateErrorOccurred = true;
            }
            return false;
        }
    }
    /**
	 * Manually log a gate exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated a gate earlier via {@link FeatureGates.checkGate} where <code>options.fireGateExposure</code> is false.
	 * @param gateName
	 */ static manuallyLogGateExposure(gateName) {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).manuallyLogGateExposure(gateName);
    }
    /**
	 * Returns the entire config for a given experiment.
	 *
	 * @param {string} experimentName - The name of the experiment
	 * @param {Object} options
	 * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event for the experiment. Defaults to true. To log an exposure event manually at a later time, use {@link FeatureGates.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * @returns The config for an experiment
	 * @example
	 * ```ts
	 * const experimentConfig = FeatureGates.getExperiment('example-experiment-name');
	 * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
	 * ```
	 */ static getExperiment(experimentName, options = {}) {
        try {
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            const evalMethod = fireExperimentExposure ? (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).getExperiment.bind((0, (/*@__PURE__*/$parcel$interopDefault($avKkz)))) : (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).getExperimentWithExposureLoggingDisabled.bind((0, (/*@__PURE__*/$parcel$interopDefault($avKkz))));
            return evalMethod(experimentName);
        } catch (error) {
            // Log the first occurrence of the error
            if (!$850ad113b2f8306c$var$FeatureGates.hasGetExperimentErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    error: error
                });
                $850ad113b2f8306c$var$FeatureGates.hasGetExperimentErrorOccurred = true;
            }
            // Return a default value
            return new (0, $avKkz.DynamicConfig)(experimentName, {}, '', {
                time: Date.now(),
                reason: (0, $avKkz.EvaluationReason).Error
            });
        }
    }
    /**
   * Returns the value of a given parameter in an experiment config.
   *
   * @template T
   * @param {string} experimentName - The name of the experiment
   * @param {string} parameterName - The name of the parameter to fetch from the experiment config
   * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or if the returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event for the experiment. Defaults to true. To log an exposure event manually at a later time, use {@link FeatureGates.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
   * @returns The value of the parameter if the experiment and parameter both exist, otherwise the default value.
   * @example
   ``` ts
   type ValidColor = 'blue' | 'red' | 'yellow';
   type ValidColorTypeCheck = (value: unknown) => value is ValidColor;

   const isValidColor: ValidColorTypeCheck =
      (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);

   const buttonColor: ValidColor = FeatureGates.getExperimentValue(
      'example-experiment-name',
      'backgroundColor',
      'yellow',
      {
          typeGuard: isValidColor
      }
   );
   ```
  */ static getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
        const experiment = $850ad113b2f8306c$var$FeatureGates.getExperiment(experimentName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return experiment.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!$850ad113b2f8306c$var$FeatureGates.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                $850ad113b2f8306c$var$FeatureGates.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    /**
	 * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated an experiment earlier via {@link FeatureGates.getExperimentValue} or
	 * {@link FeatureGates.getExperiment} where <code>options.fireExperimentExposure</code> is false.
	 * @param experimentName
	 */ static manuallyLogExperimentExposure(experimentName) {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).manuallyLogExperimentExposure(experimentName);
    }
    /**
	 * Manually log a layer exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated a layer earlier via {@link FeatureGates.getLayerValue} where <code>options.fireExperimentExposure</code> is false.
	 * @param layerName
	 * @param parameterName
	 */ static manuallyLogLayerExposure(layerName, parameterName) {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).manuallyLogLayerParameterExposure(layerName, parameterName);
    }
    static shutdownStatsig() {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).shutdown();
    }
    /**
	 * Adds a new override for the given gate.
	 *
	 * This method is additive, meaning you can call it multiple times with different gate names to build
	 * your full set of overrides.
	 *
	 * Overrides are persisted to the `STATSIG_JS_LITE_LOCAL_OVERRIDES` key in localStorage, so they will
	 * continue to affect every client that is initialized on the same domain after this method is called.
	 * If you are using this API for testing purposes, you should call ${@link FeatureGates.clearGateOverride} after
	 * your tests are completed to remove this localStorage entry.
	 *
	 * @param {string} gateName
	 * @param {boolean} value
	 */ static overrideGate(gateName, value) {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).overrideGate(gateName, value);
    }
    /**
	 * Removes any overrides that have been set for the given gate.
	 * @param {string} gateName
	 */ static clearGateOverride(gateName) {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).overrideGate(gateName, null);
    }
    /**
	 * Adds a new override for the given config (or experiment).
	 *
	 * This method is additive, meaning you can call it multiple times with different experiment names to build
	 * your full set of overrides.
	 *
	 * Overrides are persisted to the `STATSIG_JS_LITE_LOCAL_OVERRIDES` key in localStorage, so they will
	 * continue to affect every client that is initialized on the same domain after this method is called.
	 * If you are using this API for testing purposes, you should call ${@link FeatureGates.clearConfigOverride} after
	 * your tests are completed to remove this localStorage entry.
	 *
	 * @param {string} experimentName
	 * @param {object} values
	 */ static overrideConfig(experimentName, values) {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).overrideConfig(experimentName, values);
    }
    /**
	 * Removes any overrides that have been set for the given experiment.
	 * @param {string} experimentName
	 */ static clearConfigOverride(experimentName) {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).overrideConfig(experimentName, null);
    }
    /**
	 * Set overrides for gates, experiments and layers in batch.
	 *
	 * Note that these overrides are **not** additive and will completely replace any that have been added
	 * via prior calls to {@link FeatureGates.overrideConfig} or {@link FeatureGates.overrideGate}.
	 *
	 * Overrides are persisted to the `STATSIG_JS_LITE_LOCAL_OVERRIDES` key in localStorage, so they will
	 * continue to affect every client that is initialized on the same domain after this method is called.
	 * If you are using this API for testing purposes, you should call ${@link FeatureGates.clearAllOverrides} after
	 * your tests are completed to remove this localStorage entry.
	 *
	 * @param {object} overrides
	 */ static setOverrides(overrides) {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).setOverrides({
            gates: {},
            configs: {},
            layers: {},
            ...overrides
        });
    }
    /**
	 * @returns The current overrides for gates, configs (including experiments) and layers.
	 */ static getOverrides() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).getOverrides();
    }
    /**
	 * Clears overrides for all gates, configs (including experiments) and layers.
	 */ static clearAllOverrides() {
        (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).setOverrides(null);
    }
    /**
	 * Returns whether the given identifiers and customAttributes align with the current
	 * set that is being used by the client.
	 *
	 * If this method returns false, then the {@link FeatureGates.updateUser} or {@link FeatureGates.updateUserWithValues}
	 * methods can be used to re-align these values.
	 *
	 * @param identifiers
	 * @param customAttributes
	 * @returns a flag indicating whether the clients current configuration aligns with the given values
	 */ static isCurrentUser(identifiers, customAttributes) {
        return $850ad113b2f8306c$var$FeatureGates.shallowEquals($850ad113b2f8306c$var$FeatureGates.currentIdentifiers, identifiers) && $850ad113b2f8306c$var$FeatureGates.shallowEquals($850ad113b2f8306c$var$FeatureGates.currentAttributes, customAttributes);
    }
    /**
	 * This method initializes the client using a network call to fetch the bootstrap values for the given user.
	 *
	 * @param clientOptions
	 * @param identifiers
	 * @param customAttributes
	 * @private
	 */ static async init(clientOptions, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...clientOptions,
            disableCurrentPageLogging: true
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for the experiment
            // values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = (0, $97SU4.default).fetchClientSdk(clientOptions).then((value)=>fromValuesClientOptions.sdkKey = value.clientSdkKey);
            const experimentValuesPromise = (0, $97SU4.default).fetchExperimentValues(clientOptions, identifiers, customAttributes);
            // Only wait for the experiment values request to finish and try to initialise the client with experiment
            // values if both requests are successful. Else an error would be thrown and handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributes;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await $850ad113b2f8306c$var$FeatureGates.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        await this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    /**
	 * This method initializes the client using a set of boostrap values obtained from one of the server-side SDKs.
	 *
	 * @param clientOptions
	 * @param identifiers
	 * @param customAttributes
	 * @param initializeValues
	 * @private
	 */ static async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        const user = this.toStatsigUser(identifiers, customAttributes);
        $850ad113b2f8306c$var$FeatureGates.currentIdentifiers = identifiers;
        $850ad113b2f8306c$var$FeatureGates.currentAttributes = customAttributes;
        if (!clientOptions.sdkKey) clientOptions.sdkKey = $850ad113b2f8306c$var$DEFAULT_CLIENT_KEY;
        if (!clientOptions.eventLoggingApi) clientOptions.eventLoggingApi = $850ad113b2f8306c$var$DEFAULT_EVENT_LOGGING_API;
        if (clientOptions.perimeter === (0, $g4RkH.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
        clientOptions.disableAllLogging = true;
        const { sdkKey: sdkKey } = clientOptions;
        const statsigOptions = this.toStatsigOptions(clientOptions, initializeValues);
        try {
            await (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).initialize(sdkKey, user, statsigOptions);
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to initialise the Statsig client, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client with default sdk key and without values`);
            await (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).initialize($850ad113b2f8306c$var$DEFAULT_CLIENT_KEY, user, {
                ...statsigOptions,
                initializeValues: {}
            });
            throw error;
        }
    }
    /**
	 * This method creates an instance of StatsigUser from the given set of identifiers and attributes.
	 *
	 * @param identifiers
	 * @param customAttributes
	 * @private
	 */ static toStatsigUser(identifiers, customAttributes) {
        const user = {
            customIDs: identifiers,
            custom: customAttributes
        };
        if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
        return user;
    }
    /**
	 * This method updates the user for this client with the bootstrap values returned from a given Promise.
	 * It uses the customAttributes from fetching experiment values to update the Statsig user but
	 * uses the customAttributes from given input to check if the user has changed.
	 *
	 * @param {Identifiers} identifiers
	 * @param {CustomAttributes} customAttributes
	 * @param {Promise<InitializeValues>} getInitializeValues
	 * @private
	 */ static async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
        if (!$850ad113b2f8306c$var$FeatureGates.initPromise) throw new Error('The FeatureGates client must be initialized before you can update the user.');
        // If the user isn't changing at all, then exit immediately
        if ($850ad113b2f8306c$var$FeatureGates.isCurrentUser(identifiers, customAttributes)) return $850ad113b2f8306c$var$FeatureGates.initPromise;
        // Wait for the current initialize/update to finish
        const originalInitPromise = $850ad113b2f8306c$var$FeatureGates.initPromise;
        try {
            await $850ad113b2f8306c$var$FeatureGates.initPromise;
        } catch (err) {
        // Proceed with the user update even if the init failed, since this update
        // may put the client back into a valid state.
        }
        const initializeValuesPromise = getInitializeValues();
        const updateUserPromise = $850ad113b2f8306c$var$FeatureGates.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
        // We replace the init promise here since we are essentially re-initializing the client at this point.
        // Any subsequent calls to await FeatureGates.initialize() or FeatureGates.updateUser() will now also await this user update.
        $850ad113b2f8306c$var$FeatureGates.initPromise = updateUserPromise.catch(()=>{
            // If the update failed then it changed nothing, so revert back to the original promise.
            $850ad113b2f8306c$var$FeatureGates.initPromise = originalInitPromise;
        });
        return updateUserPromise;
    }
    /**
	 * This method updates the user on the nested Statsig client
	 *
	 * @param identifiers
	 * @param customAttributes
	 * @param initializeValuesPromise
	 * @private
	 */ static async updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
        let initializeValues, user;
        try {
            initializeValues = await initializeValuesPromise;
            user = $850ad113b2f8306c$var$FeatureGates.toStatsigUser(identifiers, initializeValues.customAttributesFromFetch);
        } catch (err) {
            // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
            // This is not necessary for the updateUserWithValues call, because the Statsig client will already invoke the callback itself.
            const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
            $850ad113b2f8306c$var$FeatureGates.initOptions.updateUserCompletionCallback?.(false, errMsg);
            throw err;
        }
        const success = (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).updateUserWithValues(user, initializeValues.experimentValues);
        if (success) {
            $850ad113b2f8306c$var$FeatureGates.currentIdentifiers = identifiers;
            $850ad113b2f8306c$var$FeatureGates.currentAttributes = customAttributes;
        } else throw new Error('Failed to update user. An unexpected error occured.');
    }
    /**
	 * This method transforms the options given by the user into the format accepted by the Statsig client.
	 *
	 * @param options
	 * @param {Record<string, unknown>} initializeValues
	 * @private
	 */ static toStatsigOptions(options, initializeValues) {
        const { sdkKey: // De-structured to remove from restClientOptions
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        sdkKey, updateUserCompletionCallback: // De-structured to remove from restClientOptions
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        updateUserCompletionCallback, perimeter: // De-structured to remove from restClientOptions
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        perimeter, ...restClientOptions } = options;
        return {
            ...restClientOptions,
            initializeValues: initializeValues,
            environment: {
                tier: options.environment
            },
            disableCurrentPageLogging: true,
            ...options.updateUserCompletionCallback && {
                updateUserCompletionCallback: $850ad113b2f8306c$var$FeatureGates.toStatsigUpdateUserCompletionCallback(options.updateUserCompletionCallback)
            }
        };
    }
    /**
	 * This method transforms an UpdateUserCompletionCallback in our own format into the format accepted by the Statsig client.
	 *
	 * @param callback
	 * @private
	 */ static toStatsigUpdateUserCompletionCallback(callback) {
        /**
		 * The duration passed to the callback indicates how long the update took, but it is deceptive since it only times the
		 * Statsig code and doesn't account for all of the extra custom work we do to obtain the bootstrap values.
		 * As a result, we just suppress this parameter in our own callback rather than trying to keep it accurate.
		 */ return (_duration, success, message)=>{
            callback(success, message);
        };
    }
    static shallowEquals(objectA, objectB) {
        if (!objectA && !objectB) return true;
        if (!objectA || !objectB) return false;
        const aEntries = Object.entries(objectA);
        const bEntries = Object.entries(objectB);
        if (aEntries.length !== bEntries.length) return false;
        const ascendingKeyOrder = ([key1], [key2])=>key1.localeCompare(key2);
        aEntries.sort(ascendingKeyOrder);
        bEntries.sort(ascendingKeyOrder);
        for(let i = 0; i < aEntries.length; i++){
            const [, aValue] = aEntries[i];
            const [, bValue] = bEntries[i];
            if (aValue !== bValue) return false;
        }
        return true;
    }
    /**
	 * @returns string version of the current package in semver style.
	 */ static getPackageVersion() {
        return 0, $kzNT7.CLIENT_VERSION;
    }
    /**
	 * Returns a specified layer otherwise returns an empty layer as a default value if the layer doesn't exist.
	 *
	 * @param {string} layerName - The name of the layer
	 * @param {Object} options
	 * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the layer. Defaults to true. To log an exposure event manually at a later time, use {@link FeatureGates.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * @returns A layer
	 * @example
	 * ```ts
	 * const layer = FeatureGates.getLayer('example-layer-name');
	 * const exampletitle: string = layer.get("title", "Welcome to Statsig!");
	 * ```
	 */ static getLayer(layerName, options = {}) {
        try {
            const { fireLayerExposure: fireLayerExposure = true } = options;
            const evalMethod = fireLayerExposure ? (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).getLayer.bind((0, (/*@__PURE__*/$parcel$interopDefault($avKkz)))) : (0, (/*@__PURE__*/$parcel$interopDefault($avKkz))).getLayerWithExposureLoggingDisabled.bind((0, (/*@__PURE__*/$parcel$interopDefault($avKkz))));
            return evalMethod(layerName);
        } catch (error) {
            // Log the first occurrence of the error
            if (!$850ad113b2f8306c$var$FeatureGates.hasGetLayerErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    error: error
                });
                $850ad113b2f8306c$var$FeatureGates.hasGetLayerErrorOccurred = true;
            }
            // Return a default value
            return (0, $avKkz.Layer)._create(layerName, {}, '', {
                time: Date.now(),
                reason: (0, $avKkz.EvaluationReason).Error
            });
        }
    }
    /**
   * Returns the value of a given parameter in a layer config.
   *
   * @template T
   * @param {string} layerName - The name of the layer
   * @param {string} parameterName - The name of the parameter to fetch from the layer config
   * @param {T} defaultValue - The value to serve if the layer or parameter do not exist, or if the returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the layer. Defaults to true. To log an exposure event manually at a later time, use {@link FeatureGates.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
   * @returns The value of the parameter if the layer and parameter both exist, otherwise the default value.
   * @example
   ``` ts
   type ValidColor = 'blue' | 'red' | 'yellow';
   type ValidColorTypeCheck = (value: unknown) => value is ValidColor;

   const isValidColor: ValidColorTypeCheck =
      (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);

   const buttonColor: ValidColor = FeatureGates.getLayerValue(
      'example-layer-name',
      'backgroundColor',
      'yellow',
      {
          typeGuard: isValidColor
      }
   );
   ```
  */ static getLayerValue(layerName, parameterName, defaultValue, options = {}) {
        const layer = $850ad113b2f8306c$var$FeatureGates.getLayer(layerName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return layer.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!$850ad113b2f8306c$var$FeatureGates.hasGetLayerValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                $850ad113b2f8306c$var$FeatureGates.hasGetLayerValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
}
let $850ad113b2f8306c$var$boundFGJS = $850ad113b2f8306c$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cyprus tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $850ad113b2f8306c$var$FeatureGates;
    else {
        $850ad113b2f8306c$var$boundFGJS = window.__FEATUREGATES_JS__;
        const boundVersion = $850ad113b2f8306c$var$boundFGJS?.getPackageVersion?.() || '4.10.0 or earlier';
        if (boundVersion !== (0, $kzNT7.CLIENT_VERSION)) {
            const message = `Multiple versions of FeatureGateClients found on the current page.
      The currently bound version is ${boundVersion} when module version ${(0, $kzNT7.CLIENT_VERSION)} was loading.`;
            // eslint-disable-next-line no-console
            console.warn(message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $850ad113b2f8306c$export$2e2bcd8739ae039 = $850ad113b2f8306c$var$boundFGJS;

});
parcelRegister("97SU4", function(module, exports) {

$parcel$export(module.exports, "default", () => $9eda5b2b4f9d7454$export$2e2bcd8739ae039);

var $g4RkH = parcelRequire("g4RkH");

var $kzNT7 = parcelRequire("kzNT7");

var $51GqF = parcelRequire("51GqF");
const $9eda5b2b4f9d7454$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const $9eda5b2b4f9d7454$var$PROD_BASE_URL = 'https://api.atlassian.com/flags';
const $9eda5b2b4f9d7454$var$STAGING_BASE_URL = 'https://api.stg.atlassian.com/flags';
const $9eda5b2b4f9d7454$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
const $9eda5b2b4f9d7454$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $9eda5b2b4f9d7454$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
const $9eda5b2b4f9d7454$export$450bd8fb2a6d7ace = '/gateway/api/flags';
class $9eda5b2b4f9d7454$export$2e2bcd8739ae039 {
    static async fetchClientSdk(fetcherOptions) {
        const { targetApp: targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $51GqF.ResponseError)(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
        }
        if (response.status === 204) throw new (0, $51GqF.ResponseError)('Unexpected 204 response');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter = (0, $g4RkH.PerimeterType).COMMERCIAL) {
        if (useGatewayUrl) return $9eda5b2b4f9d7454$export$450bd8fb2a6d7ace;
        if (perimeter === (0, $g4RkH.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, $g4RkH.FeatureGateEnvironment).Production:
                return $9eda5b2b4f9d7454$export$18c93900db9358a4;
            case (0, $g4RkH.FeatureGateEnvironment).Staging:
                return $9eda5b2b4f9d7454$export$1a401a0da8da3565;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, $g4RkH.PerimeterType).COMMERCIAL) switch(serviceEnv){
            case (0, $g4RkH.FeatureGateEnvironment).Development:
                return $9eda5b2b4f9d7454$export$f058dbf75c3bc647;
            case (0, $g4RkH.FeatureGateEnvironment).Staging:
                return $9eda5b2b4f9d7454$var$STAGING_BASE_URL;
            default:
                return $9eda5b2b4f9d7454$var$PROD_BASE_URL;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(path, method, fetcherOptions, body) {
        const baseUrl = $9eda5b2b4f9d7454$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || $9eda5b2b4f9d7454$var$DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': (0, $kzNT7.CLIENT_VERSION),
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal,
            ...body && {
                body: JSON.stringify(body)
            }
        });
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
}

});
parcelRegister("g4RkH", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", () => $e143d1492fd4f620$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $e143d1492fd4f620$export$c42b7bbc5e7ba555);
var $e143d1492fd4f620$export$479e7351a733299;
(function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
})($e143d1492fd4f620$export$479e7351a733299 || ($e143d1492fd4f620$export$479e7351a733299 = {}));
var $e143d1492fd4f620$export$c42b7bbc5e7ba555;
(function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
})($e143d1492fd4f620$export$c42b7bbc5e7ba555 || ($e143d1492fd4f620$export$c42b7bbc5e7ba555 = {}));

});

parcelRegister("kzNT7", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", () => $68e01af1ecb1b710$export$a59f8d67326bd1cb);
const $68e01af1ecb1b710$export$a59f8d67326bd1cb = undefined;

});

parcelRegister("51GqF", function(module, exports) {

$parcel$export(module.exports, "ResponseError", () => $099f2968e2d30ac2$export$286baf652d0b1206);
class $099f2968e2d30ac2$export$286baf652d0b1206 extends Error {
    constructor(message){
        super(message);
    }
}

});



parcelRegister("3WQZN", function(module, exports) {

$parcel$export(module.exports, "allFeatureFlagsAccessed", () => $c823d99a41cf7947$export$5b78c989c8db2561);
$parcel$export(module.exports, "currentFeatureFlagsAccessed", () => $c823d99a41cf7947$export$2a5c8df26bb89760);
$parcel$export(module.exports, "addFeatureFlagAccessed", () => $c823d99a41cf7947$export$47fade9662f71000);

var $jy7Jn = parcelRequire("jy7Jn");
const $c823d99a41cf7947$export$5b78c989c8db2561 = new Map();
const $c823d99a41cf7947$export$2a5c8df26bb89760 = new Map();
const $c823d99a41cf7947$export$47fade9662f71000 = (featureFlagName, featureFlagValue)=>{
    const value = (0, $jy7Jn.redactValue)(featureFlagValue);
    $c823d99a41cf7947$export$5b78c989c8db2561.set(featureFlagName, value);
    $c823d99a41cf7947$export$2a5c8df26bb89760.set(featureFlagName, value);
};

});
parcelRegister("jy7Jn", function(module, exports) {

$parcel$export(module.exports, "redactValue", () => $a90faa9668b3736b$export$fcc03ee4c944962f);

const $a90faa9668b3736b$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
const $a90faa9668b3736b$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
const $a90faa9668b3736b$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $a90faa9668b3736b$export$7b4abba432e57989 = (value)=>$a90faa9668b3736b$var$isString(value) && $a90faa9668b3736b$var$startsAsObject(value) || $a90faa9668b3736b$var$isObject(value);
const $a90faa9668b3736b$export$fcc03ee4c944962f = (featureFlagValue)=>$a90faa9668b3736b$export$7b4abba432e57989(featureFlagValue) ? (0, $28470208e5f4eca0$export$42f4885608027d0c) : featureFlagValue;

});
const $28470208e5f4eca0$export$42f4885608027d0c = 'non_boolean';



parcelRegister("6DrxJ", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("6zdMY")).default);

var $6zdMY = parcelRequire("6zdMY");

var $irT3s = parcelRequire("irT3s");

});
parcelRegister("6zdMY", function(module, exports) {

$parcel$export(module.exports, "default", () => $658e94b9cf0c2590$export$2e2bcd8739ae039);

var $irT3s = parcelRequire("irT3s");

var $5YjqH = parcelRequire("5YjqH");

var $ftRND = parcelRequire("ftRND");

var $kpFez = parcelRequire("kpFez");
class $658e94b9cf0c2590$export$2e2bcd8739ae039 {
    constructor(options){
        (0, $5YjqH.enforceAttributes)(options, [
            'analyticsHandler'
        ], 'Feature Flag Client');
        const { flags: flags, analyticsHandler: analyticsHandler, isAutomaticExposuresEnabled: isAutomaticExposuresEnabled, isMissingFlagEventsDisabled: isMissingFlagEventsDisabled, ignoreTypes: ignoreTypes } = options;
        this.flags = new Map();
        this.flagWrapperCache = new Map();
        this.customAttributesExposuresCache = new Set();
        this.trackedFlags = new Set();
        this.isAutomaticExposuresEnabled = isAutomaticExposuresEnabled || false;
        this.isMissingFlagEventsDisabled = isMissingFlagEventsDisabled ?? false;
        this.ignoreTypes = ignoreTypes || false;
        this.setFlags(flags || {});
        this.setAnalyticsHandler(analyticsHandler);
    }
    setFlags(flags) {
        if (!(0, $5YjqH.isObject)(flags)) return;
        Object.entries(flags).forEach(([flagKey, flag])=>{
            this.flags.set(flagKey, flag);
        });
        // Clear any cached data for flags that have been passed in again,
        // in case they have different values or explanations
        for (const flagKey of this.flagWrapperCache.keys())if (flags.hasOwnProperty(flagKey)) this.flagWrapperCache.delete(flagKey);
    }
    setAnalyticsHandler(analyticsHandler) {
        this.analyticsHandler = analyticsHandler;
    }
    setIsAutomaticExposuresEnabled(isEnabled) {
        this.isAutomaticExposuresEnabled = isEnabled;
    }
    /**
	 * This method returns the wrapper object for the given flag key.
	 * If the flag does not exist, this will return a stubbed flag following the null-object pattern,
	 * so it is always guaranteed to return an object.
	 */ getFlagWrapper(flagKey) {
        let wrapper = this.flagWrapperCache.get(flagKey);
        if (wrapper !== undefined) return wrapper;
        const flag = this.flags.get(flagKey);
        if (flag) wrapper = new (0, $kpFez.default)(flagKey, flag, this._trackExposure.bind(this), this.sendAutomaticExposure.bind(this), this.ignoreTypes);
        else wrapper = new (0, $ftRND.default)(flagKey, this.shouldSendMissingFlagAutomaticExposure(flagKey) ? this.sendAutomaticExposure.bind(this) : null);
        this.flagWrapperCache.set(flagKey, wrapper);
        return wrapper;
    }
    shouldSendMissingFlagAutomaticExposure(flagKey) {
        // Skip sending automatic exposure for platform flags as they are often released to a single product,
        // and registering them for all products that consume platform components is costly.
        const isPlatform = flagKey.startsWith('platform.');
        return !this.isMissingFlagEventsDisabled && !isPlatform;
    }
    clear() {
        this.flags.clear();
        this.flagWrapperCache.clear();
        this.trackedFlags.clear();
    }
    getBooleanValue(flagKey, options) {
        (0, $5YjqH.enforceAttributes)(options, [
            'default'
        ], 'getBooleanValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getBooleanValue(options);
    }
    getVariantValue(flagKey, options) {
        (0, $5YjqH.enforceAttributes)(options, [
            'default',
            'oneOf'
        ], 'getVariantValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getVariantValue(options);
    }
    getJSONValue(flagKey) {
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getJSONValue();
    }
    getRawValue(flagKey, options) {
        (0, $5YjqH.enforceAttributes)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getRawValue(options);
    }
    getFlagEvaluation(flagKey, options) {
        (0, $5YjqH.enforceAttributes)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getFlagEvaluation(options);
    }
    /**
	 * This method combines both the trackExposure and sendAutomaticExposure flows into
	 * one endpoint. Depending on the passed in trigger reason a manual or automatic exposure
	 * is sent.
	 **/ trackFeatureFlag(flagKey, options = {}) {
        const triggerReason = options?.triggerReason ? options.triggerReason : (0, $irT3s.ExposureTriggerReason).Manual;
        const isValueSet = this.flags.has(flagKey) || 'value' in options;
        if (!isValueSet) {
            // eslint-disable-next-line no-console
            console.warn(`No value associated with the flagKey: ${flagKey} with an exposure trigger reason of: ${triggerReason}`);
            return;
        }
        // if no values for flagValue and explanation supplied then retrieve them from the flags map
        const flagValue = 'value' in options ? options.value : this.flags.get(flagKey)?.value;
        const flagExplanation = options?.explanation ? options.explanation : this.flags.get(flagKey)?.explanation;
        if (triggerReason === (0, $irT3s.ExposureTriggerReason).AutoExposure) this.sendAutomaticExposure(flagKey, flagValue, flagExplanation);
        else // default to fire a manual track exposure
        this._trackExposure(flagKey, {
            value: flagValue,
            explanation: flagExplanation
        }, triggerReason);
    }
    trackExposure(flagKey, flag, exposureData = {}) {
        return this._trackExposure(flagKey, flag, (0, $irT3s.ExposureTriggerReason).Manual, exposureData);
    }
    _trackExposure(flagKey, flag, exposureTriggerReason, exposureData) {
        if (!(flag && flag.explanation && this.shouldSendEvent(flagKey, exposureData))) return;
        (0, $5YjqH.checkForReservedAttributes)(exposureData);
        const flagAttributes = {
            flagKey: flagKey,
            reason: flag.explanation.kind,
            ruleId: flag.explanation.ruleId,
            value: flag.value
        };
        this.sendExposureEvent(flagAttributes, exposureTriggerReason, exposureData);
    }
    shouldSendEvent(flagKey, customAttributes) {
        return this.analyticsHandler !== undefined && (!this.trackedFlags.has(flagKey) || !(0, $5YjqH.isObjectEmptyOrUndefined)(customAttributes) && !this.customAttributesExposuresCache.has(flagKey));
    }
    sendAutomaticExposure(flagKey, value, flagExplanation) {
        if (!(flagExplanation && this.isAutomaticExposuresEnabled && this.shouldSendEvent(flagKey))) return;
        const flagAttributes = {
            flagKey: flagKey,
            value: value,
            reason: flagExplanation.kind || 'SIMPLE_EVAL',
            ruleId: flagExplanation.ruleId,
            errorKind: flagExplanation.errorKind
        };
        this.sendExposureEvent(flagAttributes, (0, $irT3s.ExposureTriggerReason).AutoExposure);
    }
    sendExposureEvent(attributes, exposureTriggerReason, customAttributes) {
        if (!this.trackedFlags.has(attributes.flagKey)) {
            const exposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: attributes,
                tags: [
                    'measurement',
                    exposureTriggerReason
                ],
                highPriority: false,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(exposureEvent);
            this.trackedFlags.add(attributes.flagKey);
        }
        // Due to the way we've simplified our pipeline, custom attributes are dropped from exposure
        // events. In order not to break existing users of this feature immediately, we're sending an
        // extra event that won't be consumed by our pipeline, but will end up in the `cloud.*` tables.
        // See: https://hello.atlassian.net/wiki/spaces/MEASURE/pages/1838596497/AtlasKit+TAC
        if (!(0, $5YjqH.isObjectEmptyOrUndefined)(customAttributes)) {
            const customeAttributesExposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: Object.assign({}, attributes, customAttributes),
                tags: [
                    'measurement',
                    (0, $irT3s.ExposureTriggerReason).hasCustomAttributes,
                    exposureTriggerReason
                ],
                highPriority: true,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(customeAttributesExposureEvent);
            this.customAttributesExposuresCache.add(attributes.flagKey);
        }
    }
    getFlagStats() {
        const flagStats = {};
        for (const [flagKey, wrapper] of this.flagWrapperCache){
            const { evaluationCount: evaluationCount } = wrapper;
            flagStats[flagKey] = {
                evaluationCount: evaluationCount
            };
        }
        return flagStats;
    }
}

});
parcelRegister("irT3s", function(module, exports) {

$parcel$export(module.exports, "ExposureTriggerReason", () => $a2c845ee01fb5160$export$2c20ffeba7dbc068);
var $a2c845ee01fb5160$export$2c20ffeba7dbc068;
(function(ExposureTriggerReason) {
    ExposureTriggerReason["OptIn"] = "optInExposure";
    ExposureTriggerReason["Manual"] = "manualExposure";
    ExposureTriggerReason["Default"] = "defaultExposure";
    ExposureTriggerReason["AutoExposure"] = "autoExposure";
    ExposureTriggerReason["hasCustomAttributes"] = "hasCustomAttributes";
})($a2c845ee01fb5160$export$2c20ffeba7dbc068 || ($a2c845ee01fb5160$export$2c20ffeba7dbc068 = {}));

});

parcelRegister("5YjqH", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $792d60d4620cd575$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isObjectEmptyOrUndefined", () => $792d60d4620cd575$export$8ed1df9dbe2e9a7d);
$parcel$export(module.exports, "enforceAttributes", () => $792d60d4620cd575$export$c7d37910dd25ecbf);
$parcel$export(module.exports, "checkForReservedAttributes", () => $792d60d4620cd575$export$891630e169ca14a4);
const $792d60d4620cd575$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object';
const $792d60d4620cd575$export$8ed1df9dbe2e9a7d = (obj)=>{
    return obj ? Object.keys(obj).length === 0 : true;
};
const $792d60d4620cd575$export$c7d37910dd25ecbf = (obj, attributes, identifier)=>{
    attributes.forEach((attribute)=>{
        if (!(attribute in obj)) {
            const title = identifier ? `${identifier}: ` : '';
            throw new Error(`${title}Missing ${attribute}`);
        }
    });
};
const $792d60d4620cd575$export$891630e169ca14a4 = (customAttributes)=>{
    const reservedAttributes = [
        'flagKey',
        'ruleId',
        'reason',
        'value',
        'errorKind'
    ];
    const keys = customAttributes ? Object.keys(customAttributes) : [];
    if (reservedAttributes.some((attribute)=>keys.includes(attribute))) throw new TypeError(`exposureData contains a reserved attribute. Reserved attributes are: ${reservedAttributes.join(', ')}`);
};
const $792d60d4620cd575$var$validateFlag = (flagKey, flag)=>{
    if ($792d60d4620cd575$export$a6cdc56e425d0d0a(flag) && 'value' in flag) return true;
};
const $792d60d4620cd575$export$410eec87ab950965 = (flags)=>{
    Object.keys(flags).forEach((key)=>$792d60d4620cd575$var$validateFlag(key, flags[key]));
};

});

parcelRegister("ftRND", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a879b0e4efeff43$export$2e2bcd8739ae039);
const $9a879b0e4efeff43$export$933245d8afcc8872 = {
    kind: 'ERROR',
    errorKind: 'FLAG_NOT_FOUND'
};
class $9a879b0e4efeff43$export$2e2bcd8739ae039 {
    constructor(flagKey, sendAutomaticExposure){
        this.flagKey = flagKey;
        this.sendAutomaticExposure = sendAutomaticExposure;
        this.evaluationCount = 0;
    }
    evaluate(defaultValue) {
        this.sendAutomaticExposure != null && this.sendAutomaticExposure(this.flagKey, defaultValue, $9a879b0e4efeff43$export$933245d8afcc8872);
        this.evaluationCount++;
        return defaultValue;
    }
    getBooleanValue(options) {
        return this.evaluate(options.default);
    }
    getVariantValue(options) {
        return this.evaluate(options.default);
    }
    getJSONValue() {
        return this.evaluate({});
    }
    getRawValue(options) {
        return this.evaluate(options.default);
    }
    getFlagEvaluation(options) {
        const value = this.evaluate(options.default);
        return {
            value: value,
            explanation: $9a879b0e4efeff43$export$933245d8afcc8872
        };
    }
}

});

parcelRegister("kpFez", function(module, exports) {

$parcel$export(module.exports, "default", () => $aabb0911f82ec35f$export$2e2bcd8739ae039);

var $irT3s = parcelRequire("irT3s");
class $aabb0911f82ec35f$export$2e2bcd8739ae039 {
    constructor(flagKey, flag, trackExposure, sendAutomaticExposure, ignoreTypes){
        this.flagKey = flagKey;
        this.flag = flag;
        this.evaluationCount = 0;
        this.trackExposure = trackExposure;
        this.sendAutomaticExposure = sendAutomaticExposure;
        this.ignoreTypes = ignoreTypes;
    }
    getCachedResultOrCompute(defaultValue, { shouldTrackExposureEvent: shouldTrackExposureEvent, exposureData: exposureData, oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let exposureTriggerReason = (0, $irT3s.ExposureTriggerReason).OptIn;
        if (shouldTrackExposureEvent === undefined) {
            shouldTrackExposureEvent = true;
            exposureTriggerReason = (0, $irT3s.ExposureTriggerReason).Default;
        }
        // It is very common for products to call this method many times for the same flag key,
        // as flag evaluations are often done inside action callbacks and/or inside components with many instances.
        // We can cache the result of the first evaluation to avoid doing the same validation checks on every call.
        if (this.evaluationResult === undefined) this.evaluationResult = this.computeWithValidation(defaultValue, {
            oneOf: oneOf,
            ignoreTypes: ignoreTypes
        });
        let value = this.evaluationResult.value;
        if (this.evaluationResult.didFallbackToDefaultValue) // Use the default that was passed in, just in case it's different to what it was in the initial evaluation
        value = defaultValue;
        else if (shouldTrackExposureEvent) // For backwards compability, only fire the opt-in exposure event in valid evaluations.
        this.trackExposure(this.flagKey, this.flag, exposureTriggerReason, exposureData);
        this.sendAutomaticExposure(this.flagKey, value, this.evaluationResult.explanation);
        this.evaluationCount++;
        return {
            value: value,
            explanation: this.evaluationResult.explanation
        };
    }
    computeWithValidation(defaultValue, { oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let result = {
            value: this.flag.value,
            explanation: this.flag.explanation,
            didFallbackToDefaultValue: false
        };
        if (!ignoreTypes && typeof this.flag.value !== typeof defaultValue) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'WRONG_TYPE'
            };
        } else if (oneOf !== undefined && !oneOf.includes(this.flag.value)) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'VALIDATION_ERROR'
            };
        }
        return result;
    }
    getBooleanValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: undefined,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getVariantValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: options.oneOf,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getJSONValue() {
        return this.getCachedResultOrCompute({}, {
            shouldTrackExposureEvent: false,
            ignoreTypes: this.ignoreTypes
        }).value;
    }
    getRawValue(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            oneOf: undefined,
            ignoreTypes: true
        }).value;
    }
    getFlagEvaluation(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            ignoreTypes: this.ignoreTypes || false
        });
    }
}

});



parcelRegister("dfBCt", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $d894616e84a6e11a$export$64d6499adf9b2e51);

function $d894616e84a6e11a$export$64d6499adf9b2e51() {
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $80f8efc879637eec$export$ce553301d55c2fd8);
    const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
const $80f8efc879637eec$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $80f8efc879637eec$export$f005e2e9f707cb5f = 'commercial';
const $80f8efc879637eec$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $80f8efc879637eec$export$a739cd5aac835909 = 'stg';
const $80f8efc879637eec$export$42dd0cdd351a4a9 = 'prod';
const $80f8efc879637eec$export$404582bc18fe4d9e = 'dev';


parcelRegister("jkH4Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a2a863f2e540a7d$export$2e2bcd8739ae039);

var $dFBS3 = parcelRequire("dFBS3");

var $eTnTn = parcelRequire("eTnTn");

var $dnilo = parcelRequire("dnilo");
const $0a2a863f2e540a7d$var$packageVersion = '';
const $0a2a863f2e540a7d$var$originParamName = 'atlOrigin';
const $0a2a863f2e540a7d$var$originVersioningAttributes = {
    originLibrary: `origin-tracing.js@${$0a2a863f2e540a7d$var$packageVersion}`
};
class $0a2a863f2e540a7d$export$2e2bcd8739ae039 {
    constructor({ id: id = $0a2a863f2e540a7d$export$2e2bcd8739ae039.generateId(), product: product, dangerouslySkipValidation: dangerouslySkipValidation = false }){
        this.id = id;
        this.product = product;
        if (!dangerouslySkipValidation) this.validate();
    }
    static isValidId(value) {
        return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,36}$/.test(value);
    }
    static isValidProduct(value) {
        return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,20}$/.test(value);
    }
    static generateId() {
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
        // Dash positions are fixed so they don't add to uniqueness.
        // Remove them to save space in the encoded form.
        return id.replace(/-/g, '');
    }
    static createEmpty() {
        return new $0a2a863f2e540a7d$var$EmptyOriginTracer();
    }
    static createMalformed() {
        return new $0a2a863f2e540a7d$var$MalformedOriginTracer();
    }
    static fromUrl(url) {
        let params = new ((0, $dnilo.getEnv)()).URLSearchParams();
        $0a2a863f2e540a7d$var$replaceQuery(url, (queryString)=>{
            params = new ((0, $dnilo.getEnv)()).URLSearchParams(queryString);
        });
        return $0a2a863f2e540a7d$export$2e2bcd8739ae039.fromEncoded(params.get($0a2a863f2e540a7d$var$originParamName));
    }
    static fromEncoded(encoded) {
        if (!encoded) return $0a2a863f2e540a7d$export$2e2bcd8739ae039.createEmpty();
        try {
            return $0a2a863f2e540a7d$export$2e2bcd8739ae039.decode(encoded);
        } catch (e) {
            return $0a2a863f2e540a7d$export$2e2bcd8739ae039.createMalformed();
        }
    }
    static removeFromUrl(url) {
        return $0a2a863f2e540a7d$var$replaceQuery(url, (queryString)=>{
            const params = new ((0, $dnilo.getEnv)()).URLSearchParams(queryString);
            params.delete($0a2a863f2e540a7d$var$originParamName);
            return params.toString();
        });
    }
    static decode(encodedOrigin) {
        const originData = (0, $eTnTn.decode)(encodedOrigin);
        return new $0a2a863f2e540a7d$export$2e2bcd8739ae039(originData);
    }
    encode() {
        return (0, $eTnTn.encode)({
            id: this.id,
            product: this.product
        });
    }
    addToUrl(url) {
        return $0a2a863f2e540a7d$var$replaceQuery(url, (originalQueryString)=>{
            const params = new ((0, $dnilo.getEnv)()).URLSearchParams(originalQueryString);
            params.set($0a2a863f2e540a7d$var$originParamName, this.encode());
            return params.toString();
        });
    }
    isEmpty() {
        return false;
    }
    isMalformed() {
        return !this.isEmpty() && !this.isValid();
    }
    isValid() {
        return true;
    }
    toAnalyticsAttributes({ transformValue: transformValue = (v)=>v === null ? undefined : v, hasGeneratedId: hasGeneratedId = false } = {}) {
        // `originIdGenerated` should be used in analytic events that generated this originId.
        // Subsequent events should use `originId`.
        // No two events should have the same value of originIdGenerated.
        const originIdProp = hasGeneratedId ? 'originIdGenerated' : 'originId';
        return {
            [originIdProp]: transformValue(this.id),
            originProduct: transformValue(this.product),
            ...$0a2a863f2e540a7d$var$originVersioningAttributes
        };
    }
    validate() {
        if (!$0a2a863f2e540a7d$export$2e2bcd8739ae039.isValidId(this.id)) throw new TypeError('Invalid Origin id');
        if (!$0a2a863f2e540a7d$export$2e2bcd8739ae039.isValidProduct(this.product)) throw new TypeError('Missing/invalid Origin product');
    }
}
class $0a2a863f2e540a7d$var$EmptyOriginTracer extends $0a2a863f2e540a7d$export$2e2bcd8739ae039 {
    constructor(){
        super({
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
    isValid() {
        return false;
    }
    isEmpty() {
        return true;
    }
    toAnalyticsAttributes() {
        return {
            ...$0a2a863f2e540a7d$var$originVersioningAttributes
        };
    }
}
class $0a2a863f2e540a7d$var$MalformedOriginTracer extends $0a2a863f2e540a7d$export$2e2bcd8739ae039 {
    constructor(){
        super({
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
    isValid() {
        return false;
    }
    isEmpty() {
        return false;
    }
    toAnalyticsAttributes() {
        return {
            originMalformed: true,
            ...$0a2a863f2e540a7d$var$originVersioningAttributes
        };
    }
}
function $0a2a863f2e540a7d$var$replaceQuery(url, replacer) {
    const urlWithQueryStringRegex = /(^[^?#]*)(?:\?)?([^#]*?)(#.*|$)$/;
    // If we get passed window.location, we don't want to call window.location.replace()
    const urlString = String(url);
    return urlString.replace(urlWithQueryStringRegex, (_wholeMatch, beforeQuery, queryString, afterQuery)=>{
        let newQueryString = replacer(queryString);
        if (newQueryString) newQueryString = `?${newQueryString}`;
        return `${beforeQuery}${newQueryString}${afterQuery}`;
    });
}

});
parcelRegister("eTnTn", function(module, exports) {

$parcel$export(module.exports, "encode", () => $54ce22662f5b8d1a$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $54ce22662f5b8d1a$export$2f872c0f2117be69);

var $64p9r = parcelRequire("64p9r");

var $dnilo = parcelRequire("dnilo");
const $54ce22662f5b8d1a$var$productShorthands = {
    confluence: 'c',
    jira: 'j',
    stride: 's',
    bitbucket: 'b',
    trello: 't'
};
function $54ce22662f5b8d1a$export$c564cdbbe6da493(originData) {
    const json = JSON.stringify($54ce22662f5b8d1a$export$4bc4b533a565aabe(originData));
    const base64 = (0, $dnilo.getEnv)().btoa(json);
    return (0, $64p9r.base64ToBase64Url)(base64);
}
function $54ce22662f5b8d1a$export$2f872c0f2117be69(encodedOriginString) {
    const base64 = (0, $64p9r.base64UrlToBase64)(encodedOriginString);
    const json = (0, $dnilo.getEnv)().atob(base64);
    return $54ce22662f5b8d1a$export$46d5cda6b884b7ab(JSON.parse(json));
}
function $54ce22662f5b8d1a$export$4bc4b533a565aabe({ id: id, product: product }) {
    return {
        i: id,
        p: product && product in $54ce22662f5b8d1a$var$productShorthands ? $54ce22662f5b8d1a$var$productShorthands[product] : product
    };
}
function $54ce22662f5b8d1a$export$46d5cda6b884b7ab(originJSONObject) {
    const originData = {};
    if (originJSONObject.i) originData.id = originJSONObject.i;
    if (originJSONObject.p) originData.product = $54ce22662f5b8d1a$var$expandProductShorthand(originJSONObject.p);
    return originData;
}
function $54ce22662f5b8d1a$var$expandProductShorthand(maybeShorthand) {
    const products = Object.keys($54ce22662f5b8d1a$var$productShorthands);
    for(let i = 0; i < products.length; i++){
        const product = products[i];
        const shorthand = $54ce22662f5b8d1a$var$productShorthands[product];
        if (maybeShorthand === shorthand) return product;
    }
    return maybeShorthand;
}

});
parcelRegister("64p9r", function(module, exports) {

$parcel$export(module.exports, "base64ToBase64Url", () => $32dc8b35d1fe6a64$export$3b91e21dac1023c6);
$parcel$export(module.exports, "base64UrlToBase64", () => $32dc8b35d1fe6a64$export$47c5265a25535d02);
/**
 * This file converts between Base64 and Base 64 Encoding with URL and Filename Safe Alphabet,
 * the latter of which has URL-safe characters only (drops =, + and /).
 *
 * Why not use a library? The popular libs use Buffer to be able to
 * encode any data to base64. We don't need this capability, and it causes
 * Webpack to include 30KB of a Buffer polyfill.
 * Webpack's/UglifyJS's Tree Shaking seems to be unable to drop it.
 *
 * See: RFC 4648 section 5 (https://tools.ietf.org/html/rfc4648#section-5)
 */ function $32dc8b35d1fe6a64$export$3b91e21dac1023c6(base64) {
    if (base64 == null) return '';
    return String(base64).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
function $32dc8b35d1fe6a64$export$47c5265a25535d02(base64url) {
    if (base64url == null) return '';
    const base64 = String(base64url).replace(/-/g, '+').replace(/_/g, '/');
    const padLength = (4 - base64url.length % 4) % 4;
    const pad = '==='.slice(0, padLength);
    return base64 + pad;
}

});

parcelRegister("dnilo", function(module, exports) {

$parcel$export(module.exports, "getEnv", () => $98dc00e14286a4e1$export$4bd44a2aa29d3d6e);

var $aul3P = parcelRequire("aul3P");

const $98dc00e14286a4e1$export$d3cd91e0fdbfdbc0 = ()=>({
        atob: // atob/btoa need to be bound because they throw an illegal invocation error when called as a method (obj.atob())
        typeof atob === 'function' && atob.bind(undefined) || typeof (0, $aul3P.Buffer) !== 'undefined' && ((encoded)=>(0, $aul3P.Buffer).from(encoded, 'base64').toString()),
        btoa: typeof btoa === 'function' && btoa.bind(undefined) || typeof (0, $aul3P.Buffer) !== 'undefined' && ((str)=>(0, $aul3P.Buffer).from(str).toString('base64')),
        URLSearchParams: typeof URLSearchParams === 'function' && URLSearchParams || (0, (parcelRequire("78Ywx")).URLSearchParams)
    });
let $98dc00e14286a4e1$var$env;
const $98dc00e14286a4e1$export$4bd44a2aa29d3d6e = ()=>$98dc00e14286a4e1$var$env || ($98dc00e14286a4e1$var$env = $98dc00e14286a4e1$var$validateEnv($98dc00e14286a4e1$export$d3cd91e0fdbfdbc0()));
const $98dc00e14286a4e1$var$validateEnv = (env)=>{
    if (!(env.atob && env.btoa && env.URLSearchParams)) throw new TypeError(`Origin-Tracing: missing environment APIs. Required: btoa(), atob(), URLSearchParams() (or in Node: Buffer, require('url').URLSearchParams).`);
    return env;
};

});



parcelRegister("gmPP3", function(module, exports) {

$parcel$export(module.exports, "CompressionRule", () => $bea6e64535f0ed78$export$89b3253ddfd2e6e8);

var $5zQU9 = parcelRequire("5zQU9");

var $49KuO = parcelRequire("49KuO");

var $eaJEm = parcelRequire("eaJEm");
class $bea6e64535f0ed78$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        /**
     * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
     * @param event
     * @returns {boolean}
     */ (0, $5zQU9.default)(this, "canCompress", (event)=>{
            try {
                return event && (0, $49KuO.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        });
        /**
     * This function compresses as many events in the given collection as possible.<p>
     * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
     * appended to the end of the resulting array.
     *
     * @param events A collection of analytic events to compress
     * @returns {Array.<Object>} The action fields for the resulting compressed events
     */ (0, $5zQU9.default)(this, "compress", (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $eaJEm.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, $49KuO.validateActionEventType)(event.eventType);
                (0, $49KuO.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        });
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("49KuO", function(module, exports) {

$parcel$export(module.exports, "validateContainers", () => $306c11cbf75d8605$export$e63ea5d8477971d3);
$parcel$export(module.exports, "isActionEventType", () => $306c11cbf75d8605$export$d19cebda16f7579a);
$parcel$export(module.exports, "validateActionEventType", () => $306c11cbf75d8605$export$4a8d7476662aebcc);
$parcel$export(module.exports, "validateActionEvent", () => $306c11cbf75d8605$export$e0c121325c66ed4c);
$parcel$export(module.exports, "validateScreenEvent", () => $306c11cbf75d8605$export$dc993432a592dc27);
$parcel$export(module.exports, "validateTrackEvent", () => $306c11cbf75d8605$export$8c014fd74b0c8b99);
$parcel$export(module.exports, "validateDwellBaseEvent", () => $306c11cbf75d8605$export$39d6334da9a44984);
$parcel$export(module.exports, "validateUIEvent", () => $306c11cbf75d8605$export$e5bac0930c812e90);
$parcel$export(module.exports, "validateOperationalEvent", () => $306c11cbf75d8605$export$1e561554275607ef);
$parcel$export(module.exports, "validateIdentifyEvent", () => $306c11cbf75d8605$export$c16a4e16aa4026c0);
$parcel$export(module.exports, "validatePlatform", () => $306c11cbf75d8605$export$801b46c35394d316);

var $hRleJ = parcelRequire("hRleJ");

var $f6ddt = parcelRequire("f6ddt");
const $306c11cbf75d8605$var$actionEventTypes = Object.freeze([
    (0, $hRleJ.eventType).OPERATIONAL,
    (0, $hRleJ.eventType).TRACK,
    (0, $hRleJ.eventType).UI
]);
function $306c11cbf75d8605$export$df8ff30e3c960006(container) {
    if (!(0, $f6ddt.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}
function $306c11cbf75d8605$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>$306c11cbf75d8605$export$df8ff30e3c960006(container));
}
function $306c11cbf75d8605$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $hRleJ.eventType).OPERATIONAL:
        case (0, $hRleJ.eventType).TRACK:
        case (0, $hRleJ.eventType).UI:
            return true;
        default:
            return false;
    }
}
function $306c11cbf75d8605$export$4a8d7476662aebcc(type) {
    if (!$306c11cbf75d8605$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$306c11cbf75d8605$var$actionEventTypes}]`);
    return true;
}
function $306c11cbf75d8605$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    $306c11cbf75d8605$export$e63ea5d8477971d3(event.containers);
}
function $306c11cbf75d8605$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}
function $306c11cbf75d8605$export$8c014fd74b0c8b99(event) {
    $306c11cbf75d8605$export$e0c121325c66ed4c(event);
}
function $306c11cbf75d8605$export$39d6334da9a44984(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
}
function $306c11cbf75d8605$export$e5bac0930c812e90(event) {
    $306c11cbf75d8605$export$e0c121325c66ed4c(event);
}
function $306c11cbf75d8605$export$1e561554275607ef(event) {
    $306c11cbf75d8605$export$e0c121325c66ed4c(event);
}
function $306c11cbf75d8605$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $hRleJ.isType)((0, $hRleJ.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $hRleJ.objectValues)((0, $hRleJ.userType))}]`);
}
function $306c11cbf75d8605$export$801b46c35394d316(productInfo) {
    if (!(0, $hRleJ.isType)((0, $hRleJ.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $hRleJ.objectValues)((0, $hRleJ.platformType))}]`);
    if (productInfo.origin === (0, $hRleJ.originType).DESKTOP && !(0, $hRleJ.isType)((0, $hRleJ.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $hRleJ.originType).WEB && !(0, $hRleJ.isType)((0, $hRleJ.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});
parcelRegister("hRleJ", function(module, exports) {

$parcel$export(module.exports, "envType", () => $d007dc097fcc9a53$export$56ac8ebc9870b1b9);
$parcel$export(module.exports, "eventType", () => $d007dc097fcc9a53$export$4c045e605d532c98);
$parcel$export(module.exports, "platformType", () => $d007dc097fcc9a53$export$6b4f396210e539f3);
$parcel$export(module.exports, "originType", () => $d007dc097fcc9a53$export$f73e9fcd368bb695);
$parcel$export(module.exports, "tenantType", () => $d007dc097fcc9a53$export$496f06ac2a964da2);
$parcel$export(module.exports, "userType", () => $d007dc097fcc9a53$export$1827adfd178b4870);
$parcel$export(module.exports, "apdexType", () => $d007dc097fcc9a53$export$99b37380a464d794);
$parcel$export(module.exports, "desktopPlatforms", () => $d007dc097fcc9a53$export$809831be6c4c6227);
$parcel$export(module.exports, "webPlatforms", () => $d007dc097fcc9a53$export$19c579398ad213e7);
$parcel$export(module.exports, "originTracingType", () => $d007dc097fcc9a53$export$62a500c02dc63ee);
$parcel$export(module.exports, "objectValues", () => $d007dc097fcc9a53$export$ad1854f4a08c15f8);
$parcel$export(module.exports, "isType", () => $d007dc097fcc9a53$export$26b9f946b448f23e);
$parcel$export(module.exports, "perimeterType", () => $d007dc097fcc9a53$export$bdd41749d2096e4b);
$parcel$export(module.exports, "aliasType", () => $d007dc097fcc9a53$export$a8c99e46b781d936);
$parcel$export(module.exports, "groupType", () => $d007dc097fcc9a53$export$e73680b18d9b7c6e);
$parcel$export(module.exports, "envOverrides", () => $d007dc097fcc9a53$export$12b75c708da5a04b);
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
let $d007dc097fcc9a53$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
let $d007dc097fcc9a53$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
let $d007dc097fcc9a53$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
let $d007dc097fcc9a53$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
let $d007dc097fcc9a53$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
let $d007dc097fcc9a53$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["HALP"] = "halp";
    return userType;
}({});
let $d007dc097fcc9a53$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $d007dc097fcc9a53$export$809831be6c4c6227 = Object.freeze([
    $d007dc097fcc9a53$export$6b4f396210e539f3.DESKTOP,
    $d007dc097fcc9a53$export$6b4f396210e539f3.MAC,
    $d007dc097fcc9a53$export$6b4f396210e539f3.LINUX,
    $d007dc097fcc9a53$export$6b4f396210e539f3.WINDOWS
]);
const $d007dc097fcc9a53$export$19c579398ad213e7 = Object.freeze([
    $d007dc097fcc9a53$export$6b4f396210e539f3.WEB,
    $d007dc097fcc9a53$export$6b4f396210e539f3.MOBILE_WEB
]);
let $d007dc097fcc9a53$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $d007dc097fcc9a53$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $d007dc097fcc9a53$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
let $d007dc097fcc9a53$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
let $d007dc097fcc9a53$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
let $d007dc097fcc9a53$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
let $d007dc097fcc9a53$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    envOverrides["FEDRAMP_MODERATE_SANDBOX"] = "fedramp-moderate-sandbox";
    return envOverrides;
}({});

});

parcelRegister("f6ddt", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $afe1ab03c0a4d913$export$53b83ca8eaab0383);
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $afe1ab03c0a4d913$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $afe1ab03c0a4d913$var$isObjectObject(o) {
    return $afe1ab03c0a4d913$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $afe1ab03c0a4d913$export$53b83ca8eaab0383(o) {
    if ($afe1ab03c0a4d913$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($afe1ab03c0a4d913$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

});


parcelRegister("eaJEm", function(module, exports) {

$parcel$export(module.exports, "mapKeys", () => $a51568fdd98844ab$export$781522908e4e76a1);
$parcel$export(module.exports, "pick", () => $a51568fdd98844ab$export$357523c63a2253b9);
$parcel$export(module.exports, "omitBy", () => $a51568fdd98844ab$export$d7a617dda645b4e3);
$parcel$export(module.exports, "pickBy", () => $a51568fdd98844ab$export$b460b275d6c6aa0);
$parcel$export(module.exports, "omit", () => $a51568fdd98844ab$export$30a06c8d3562193f);
$parcel$export(module.exports, "equals", () => $a51568fdd98844ab$export$e9bab7fafb253603);
$parcel$export(module.exports, "partition", () => $a51568fdd98844ab$export$b29f828819edca8d);
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $a51568fdd98844ab$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $a51568fdd98844ab$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $a51568fdd98844ab$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $a51568fdd98844ab$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $a51568fdd98844ab$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $a51568fdd98844ab$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$a51568fdd98844ab$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $a51568fdd98844ab$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});


parcelRegister("aYU4Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $7feb02305b222732$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $dFBS3 = parcelRequire("dFBS3");

var $hRleJ = parcelRequire("hRleJ");

var $9dEp1 = parcelRequire("9dEp1");

var $eIGW7 = parcelRequire("eIGW7");

var $bVXPQ = parcelRequire("bVXPQ");

var $ez3h7 = parcelRequire("ez3h7");

var $49KuO = parcelRequire("49KuO");

var $54lSA = parcelRequire("54lSA");

var $b88ir = parcelRequire("b88ir");

var $b5Bi3 = parcelRequire("b5Bi3");

var $hrLBB = parcelRequire("hrLBB");

var $1t0DP = parcelRequire("1t0DP");

var $cxp5h = parcelRequire("cxp5h");

var $kzV7m = parcelRequire("kzV7m");

var $6L92I = parcelRequire("6L92I");

var $8Pilt = parcelRequire("8Pilt");

var $fBPLq = parcelRequire("fBPLq");

var $8TuVU = parcelRequire("8TuVU");

var $1ZcVH = parcelRequire("1ZcVH");

var $l4WDe = parcelRequire("l4WDe");
function $7feb02305b222732$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7feb02305b222732$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7feb02305b222732$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7feb02305b222732$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $7feb02305b222732$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
const $7feb02305b222732$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $7feb02305b222732$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        (0, $5zQU9.default)(this, "_useStargate", (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        });
        (0, $5zQU9.default)(this, "_endsWith", (str, suffix)=>str.indexOf(suffix, str.length - suffix.length) !== -1);
        (0, $5zQU9.default)(this, "_changeInternalUserId", (userId, anonymousId)=>{
            this.eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this.eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this.eventProcessor.getUser().setAnonymousId(anonymousId);
        });
        (0, $5zQU9.default)(this, "_createSubproductGetter", (subproduct)=>(0, $eIGW7.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.'));
        (0, $5zQU9.default)(this, "_createEmbeddedProductGetter", (embeddedProduct)=>(0, $eIGW7.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.'));
        (0, $5zQU9.default)(this, "_getLastScreenEvent", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($7feb02305b222732$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch (err) {
                this._safeSessionStorage.removeItem($7feb02305b222732$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        });
        (0, $5zQU9.default)(this, "_setLastScreenEvent", (event)=>{
            this._safeSessionStorage.setItem($7feb02305b222732$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        });
        (0, $5zQU9.default)(this, "_shouldEventBeDelayed", (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this.eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        });
        (0, $5zQU9.default)(this, "_fireEvent", (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $hRleJ.eventType).UI:
                case (0, $hRleJ.eventType).OPERATIONAL:
                case (0, $hRleJ.eventType).TRACK:
                    return this.eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $hRleJ.eventType).SCREEN:
                    return this.eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $hRleJ.eventType).IDENTIFY:
                    return this.eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        });
        (0, $5zQU9.default)(this, "_fireDelayedEvent", (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        });
        (0, $5zQU9.default)(this, "_delayEvent", (identifier, builtEvent, context, userInfo, callback)=>{
            this.eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        });
        (0, $5zQU9.default)(this, "_processEvent", (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        });
        (0, $5zQU9.default)(this, "setEmbeddedProduct", (embeddedProduct)=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        });
        (0, $5zQU9.default)(this, "clearEmbeddedProduct", ()=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        });
        (0, $5zQU9.default)(this, "setSubproduct", (subproduct)=>{
            this._productInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        });
        /**
     * Calling this function in the intialisation of the client in product
     * captures specified 'origin tracing' URL params and fires a single origin landed event
     * <p>
     * This function expects a mapping between the keys for any URL parameters
     *  that should be captured and removed for origin tracing
     * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
     * Each handler function should return an object with two items
     * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
     * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
     *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
     * </p>
     * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
     * e.g. from a share or email
     *
     * An example calling this function using an external decoding library, with taskSessionId specified to persist
     * analyticsWebClient.setOriginTracingHandlers({
          atlOrigin: encodedOrigin => {
              const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
              return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
          },
      });
     *
     * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
     * @this {AnalyticsWebClient}
     */ (0, $5zQU9.default)(this, "setOriginTracingHandlers", (originParamHandlerMapping)=>{
            const capturedOriginTraces = this.originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this.task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (Object.keys(capturedOriginTraces).length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        });
        (0, $5zQU9.default)(this, "setTenantInfo", (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $hRleJ.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $hRleJ.isType)((0, $hRleJ.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $hRleJ.objectValues)((0, $hRleJ.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
        });
        (0, $5zQU9.default)(this, "clearTenantInfo", ()=>{
            this._tenantInfo = {};
        });
        (0, $5zQU9.default)(this, "setOrgInfo", (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId: orgId
            };
        });
        (0, $5zQU9.default)(this, "clearOrgInfo", ()=>{
            this._orgInfo = {};
        });
        (0, $5zQU9.default)(this, "setWorkspaceInfo", (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        });
        (0, $5zQU9.default)(this, "clearWorkspaceInfo", ()=>{
            this._workspaceInfo = {};
        });
        (0, $5zQU9.default)(this, "setUserInfo", (userIdType, userId)=>{
            (0, $49KuO.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, $5zQU9.default)(this, "clearUserInfo", ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, $5zQU9.default)(this, "setAlias", (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $hRleJ.isType)((0, $hRleJ.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $hRleJ.objectValues)((0, $hRleJ.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        });
        (0, $5zQU9.default)(this, "clearAlias", ()=>{
            this._aliases = {};
        });
        (0, $5zQU9.default)(this, "setGroup", (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $hRleJ.isType)((0, $hRleJ.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $hRleJ.objectValues)((0, $hRleJ.groupType))}]`);
            this._groups[groupsKeyType] = group;
        });
        (0, $5zQU9.default)(this, "clearGroup", ()=>{
            this._groups = {};
        });
        (0, $5zQU9.default)(this, "getAnonymousId", ()=>this._userInfo.anonymousId);
        (0, $5zQU9.default)(this, "setUIViewedAttributes", (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = $7feb02305b222732$var$_objectSpread({}, uiViewedAttributes);
        });
        (0, $5zQU9.default)(this, "getUIViewedAttributes", ()=>{
            return this._uiViewedAttributes;
        });
        (0, $5zQU9.default)(this, "clearUIViewedAttributes", ()=>{
            this._uiViewedAttributes = {};
        });
        (0, $5zQU9.default)(this, "sendIdentifyEvent", (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $hRleJ.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        });
        /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ (0, $5zQU9.default)(this, "sendPageEvent", (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        });
        /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ (0, $5zQU9.default)(this, "sendScreenEvent", (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $49KuO.validateScreenEvent)(screenName);
            (0, $49KuO.validateContainers)(screenContainers);
            const builtEvent = (0, $bVXPQ.buildScreenEvent)(this._productInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = $7feb02305b222732$var$_objectSpread({
                name: screenName
            }, builtEvent);
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $1ZcVH.default)(callback, builtEventWithName));
        });
        (0, $5zQU9.default)(this, "sendTrackEvent", (event, callback)=>{
            (0, $49KuO.validateTrackEvent)(event);
            const builtEvent = (0, $bVXPQ.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $hRleJ.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $bVXPQ.buildActionName)(event), builtEvent, this._context, (0, $1ZcVH.default)(callback, builtEvent));
        });
        (0, $5zQU9.default)(this, "sendUIEvent", (event, callback)=>{
            (0, $49KuO.validateUIEvent)(event);
            const builtEvent = (0, $bVXPQ.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $hRleJ.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $bVXPQ.buildActionName)(event), builtEvent, this._context, (0, $1ZcVH.default)(callback, builtEvent));
        });
        (0, $5zQU9.default)(this, "sendOperationalEvent", (event, callback)=>{
            (0, $49KuO.validateOperationalEvent)(event);
            const builtEvent = (0, $bVXPQ.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $hRleJ.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $bVXPQ.buildActionName)(event), builtEvent, this._context, (0, $1ZcVH.default)(callback, builtEvent));
        });
        (0, $5zQU9.default)(this, "startUIViewedEvent", (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = new (0, $fBPLq.default)(this._productInfo, ()=>({
                    embeddedProduct: this._productInfo.embeddedProduct(),
                    subproduct: this._productInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
            this._uiViewedEvent.start();
        });
        (0, $5zQU9.default)(this, "stopUIViewedEvent", ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        });
        (0, $5zQU9.default)(this, "resetUIViewedTimers", ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        });
        (0, $5zQU9.default)(this, "startApdexEvent", (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        });
        (0, $5zQU9.default)(this, "getApdexStart", (apdexEvent)=>this._apdexEvent.getStart(apdexEvent));
        (0, $5zQU9.default)(this, "stopApdexEvent", (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        });
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        (0, $5zQU9.default)(this, "startLowPriorityEventDelay", (timeout, callback)=>{
            this.eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        });
        (0, $5zQU9.default)(this, "stopLowPriorityEventDelay", ()=>{
            this.eventDelayQueue.stopLowPriorityEventDelay();
        });
        (0, $5zQU9.default)(this, "onEvent", (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $hRleJ.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $hRleJ.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $hRleJ.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $hRleJ.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $hRleJ.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $hRleJ.objectValues)((0, $hRleJ.eventType))}]`);
        });
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $hRleJ.isType)((0, $hRleJ.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $hRleJ.objectValues)((0, $hRleJ.envType))}]`);
        if (productInfo.perimeter && !(0, $hRleJ.isType)((0, $hRleJ.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be an perimeterType: [${(0, $hRleJ.objectValues)((0, $hRleJ.perimeterType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $hRleJ.originType).WEB;
        else if (!(0, $hRleJ.isType)((0, $hRleJ.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $hRleJ.objectValues)((0, $hRleJ.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $hRleJ.originType).WEB ? (0, $hRleJ.platformType).WEB : (0, $hRleJ.platformType).DESKTOP;
        else (0, $49KuO.validatePlatform)(productInfo);
        this.logger = settings.logger || console;
        this._productInfo = $7feb02305b222732$var$_objectSpread($7feb02305b222732$var$_objectSpread({}, productInfo), {}, {
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        });
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        this._context = (0, $bVXPQ.buildContext)(this._productInfo);
        this._safeSessionStorage = new (0, $cxp5h.default)();
        const _useStargate = this._useStargate(settings.useStargate);
        const apiHost = settings.apiHost || (0, $hrLBB.selectHost)({
            useStargate: _useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            envOverride: productInfo.envOverride
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $l4WDe.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        this.eventProcessor = new (0, $54lSA.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this.logger,
            disableCookiePersistence: disableCookiePersistence
        });
        this._userInfo = {
            anonymousId: this.eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $b5Bi3.default)();
        this._tabTracking = new (0, $kzV7m.default)();
        this._sessionTracking = new (0, $1t0DP.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this.task = new (0, $6L92I.default)();
        this.originTracing = new (0, $b88ir.default)();
        // Init Apdex
        this._apdexEvent = new (0, $9dEp1.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $8TuVU.defaultHistoryReplaceFn);
        this.eventDelayQueue = new (0, $ez3h7.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $8Pilt.default)();
        this._pageLoadId = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
        this._workspaceInfo = {};
        this._aliases = {};
        this._groups = {};
    }
}

});
parcelRegister("9dEp1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b64ab0f5348f583$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $hRleJ = parcelRequire("hRleJ");

var $b5Bi3 = parcelRequire("b5Bi3");

var $hTk3G = parcelRequire("hTk3G");
function $6b64ab0f5348f583$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6b64ab0f5348f583$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6b64ab0f5348f583$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6b64ab0f5348f583$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $6b64ab0f5348f583$export$2e2bcd8739ae039 {
    constructor(onEvent, pageVisibility){
        (0, $5zQU9.default)(this, "_getEventKey", ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task);
        (0, $5zQU9.default)(this, "_getEventTimingByName", (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        });
        (0, $5zQU9.default)(this, "_getApdexFields", (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return $6b64ab0f5348f583$var$_objectSpread($6b64ab0f5348f583$var$_objectSpread({}, apdexTimings), {}, {
                apdex: apdexScore
            });
        });
        (0, $5zQU9.default)(this, "_getApdexTimings", (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        });
        (0, $5zQU9.default)(this, "_getStartTime", (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $hRleJ.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        });
        (0, $5zQU9.default)(this, "_getStopTime", ()=>this._performance.getTimeOrigin() + this._performance.now());
        (0, $5zQU9.default)(this, "_cleanApdexState", (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        });
        (0, $5zQU9.default)(this, "_getVisibilityFields", (event)=>{
            let isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $hRleJ.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $hRleJ.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        });
        (0, $5zQU9.default)(this, "_calculateApdex", ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        });
        (0, $5zQU9.default)(this, "_validateStartEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        });
        (0, $5zQU9.default)(this, "_validateStopEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $hRleJ.isType)((0, $hRleJ.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $hRleJ.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        });
        (0, $5zQU9.default)(this, "_shouldSendEvent", (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        });
        (0, $5zQU9.default)(this, "_sendEvent", (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: $6b64ab0f5348f583$var$_objectSpread($6b64ab0f5348f583$var$_objectSpread({}, event.additionalAttributes), {}, {
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                })
            }, callback);
        });
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $b5Bi3.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $hTk3G.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent($6b64ab0f5348f583$var$_objectSpread($6b64ab0f5348f583$var$_objectSpread($6b64ab0f5348f583$var$_objectSpread({}, event), apdexFields), visibilityFields), callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
}

});
parcelRegister("b5Bi3", function(module, exports) {

$parcel$export(module.exports, "default", () => $812d1663338fa68e$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
class $812d1663338fa68e$export$2e2bcd8739ae039 {
    constructor(){
        (0, $5zQU9.default)(this, "_bindEventListeners", ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        });
        (0, $5zQU9.default)(this, "_handleVisibilityChange", ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        });
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
}

});

parcelRegister("hTk3G", function(module, exports) {

$parcel$export(module.exports, "default", () => $d06721e2727b6d45$export$2e2bcd8739ae039);
class $d06721e2727b6d45$export$2e2bcd8739ae039 {
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}

});


parcelRegister("eIGW7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab767b01b3be79aa$export$2e2bcd8739ae039);
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $ab767b01b3be79aa$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $ab767b01b3be79aa$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($ab767b01b3be79aa$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("bVXPQ", function(module, exports) {

$parcel$export(module.exports, "buildActionFields", () => $8b036e99dd4c03a4$export$655ecf7241feac42);
$parcel$export(module.exports, "buildScreenEvent", () => $8b036e99dd4c03a4$export$c7d9a5f56acc4b19);
$parcel$export(module.exports, "buildActionName", () => $8b036e99dd4c03a4$export$9c5623a792efc9b0);
$parcel$export(module.exports, "buildContext", () => $8b036e99dd4c03a4$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "buildActionEvent", () => $8b036e99dd4c03a4$export$7bf451af4a8e3dd9);

var $5zQU9 = parcelRequire("5zQU9");

var $hRleJ = parcelRequire("hRleJ");

var $f6ddt = parcelRequire("f6ddt");
function $8b036e99dd4c03a4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8b036e99dd4c03a4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8b036e99dd4c03a4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8b036e99dd4c03a4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $8b036e99dd4c03a4$var$libraryVersion = "4.23.0";
function $8b036e99dd4c03a4$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $8b036e99dd4c03a4$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $8b036e99dd4c03a4$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $8b036e99dd4c03a4$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $8b036e99dd4c03a4$var$buildAliases(aliases) {
    if ($8b036e99dd4c03a4$var$isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function $8b036e99dd4c03a4$var$buildGroups(groups) {
    if ($8b036e99dd4c03a4$var$isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function $8b036e99dd4c03a4$var$buildEventOverrides(event) {
    if (event.anonymousId) return {
        anonymousId: event.anonymousId
    };
    return {};
}
function $8b036e99dd4c03a4$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $8b036e99dd4c03a4$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $8b036e99dd4c03a4$var$getProductField(productInfo.env, overrides.env);
    const product = $8b036e99dd4c03a4$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $8b036e99dd4c03a4$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $8b036e99dd4c03a4$var$getProductField(productInfo.version, overrides.version);
    const origin = $8b036e99dd4c03a4$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $8b036e99dd4c03a4$var$getProductField(productInfo.platform, overrides.platform);
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $8b036e99dd4c03a4$var$isNotEmptyObject(obj) {
    return (0, $f6ddt.isPlainObject)(obj) && Object.keys(obj).length > 0;
}
function $8b036e99dd4c03a4$var$buildAttributesWithName(name, attrObject) {
    return $8b036e99dd4c03a4$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $8b036e99dd4c03a4$var$buildAttributes(attributes) {
    return $8b036e99dd4c03a4$var$buildAttributesWithName('attributes', attributes);
}
function $8b036e99dd4c03a4$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $8b036e99dd4c03a4$export$f045f238d77c002a(containers) {
    if ($8b036e99dd4c03a4$var$isNotEmptyObject(containers)) {
        const validContainers = $8b036e99dd4c03a4$export$3f5115a568819c1a(containers);
        return $8b036e99dd4c03a4$var$buildAttributesWithName('containers', validContainers);
    }
    return undefined;
}
function $8b036e99dd4c03a4$export$655ecf7241feac42(event, actionEventType) {
    return $8b036e99dd4c03a4$var$_objectSpread({
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType
    }, $8b036e99dd4c03a4$export$f045f238d77c002a(event.containers));
}
function $8b036e99dd4c03a4$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $8b036e99dd4c03a4$var$buildAttributesWithName('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $8b036e99dd4c03a4$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, event, containers, aliases, groups) {
    const productFields = $8b036e99dd4c03a4$var$buildProductFields(productInfo);
    const tenantFields = $8b036e99dd4c03a4$var$buildTenantFields(tenantInfo);
    const userFields = $8b036e99dd4c03a4$var$buildUserFields(userInfo);
    const orgFields = $8b036e99dd4c03a4$var$buildOrgFields(orgInfo);
    const workspaceFields = $8b036e99dd4c03a4$var$buildWorkspaceFields(workspaceInfo);
    const overrides = {
        title: '',
        path: '',
        url: '',
        referrer: '',
        search: '',
        eventType: (0, $hRleJ.eventType).SCREEN
    };
    return $8b036e99dd4c03a4$var$_objectSpread($8b036e99dd4c03a4$var$_objectSpread($8b036e99dd4c03a4$var$_objectSpread($8b036e99dd4c03a4$var$_objectSpread($8b036e99dd4c03a4$var$_objectSpread($8b036e99dd4c03a4$var$_objectSpread($8b036e99dd4c03a4$var$_objectSpread($8b036e99dd4c03a4$var$_objectSpread($8b036e99dd4c03a4$var$_objectSpread($8b036e99dd4c03a4$var$_objectSpread($8b036e99dd4c03a4$var$_objectSpread($8b036e99dd4c03a4$var$_objectSpread({}, productFields), tenantFields), userFields), orgFields), overrides), $8b036e99dd4c03a4$var$buildAttributes(attributes)), $8b036e99dd4c03a4$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes)), $8b036e99dd4c03a4$export$f045f238d77c002a(containers)), $8b036e99dd4c03a4$var$buildEventOverrides(event)), {}, {
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields), $8b036e99dd4c03a4$var$buildAliases(aliases)), $8b036e99dd4c03a4$var$buildGroups(groups));
}
function $8b036e99dd4c03a4$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
function $8b036e99dd4c03a4$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $8b036e99dd4c03a4$var$libraryVersion
            }
        }
    };
}
function $8b036e99dd4c03a4$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $8b036e99dd4c03a4$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, aliases, groups) {
    const productFields = $8b036e99dd4c03a4$var$buildProductFields(productInfo, $8b036e99dd4c03a4$export$e3d99b4bfec06f6e(event));
    const tenantFields = $8b036e99dd4c03a4$var$buildTenantFields(tenantInfo);
    const orgFields = $8b036e99dd4c03a4$var$buildOrgFields(orgInfo);
    const workspaceFields = $8b036e99dd4c03a4$var$buildWorkspaceFields(workspaceInfo);
    const userFields = $8b036e99dd4c03a4$var$buildUserFields(userInfo);
    const actionFields = $8b036e99dd4c03a4$export$655ecf7241feac42(event, actionEventType);
    return $8b036e99dd4c03a4$var$_objectSpread($8b036e99dd4c03a4$var$_objectSpread($8b036e99dd4c03a4$var$_objectSpread($8b036e99dd4c03a4$var$_objectSpread($8b036e99dd4c03a4$var$_objectSpread($8b036e99dd4c03a4$var$_objectSpread($8b036e99dd4c03a4$var$_objectSpread($8b036e99dd4c03a4$var$_objectSpread($8b036e99dd4c03a4$var$_objectSpread({}, productFields), tenantFields), orgFields), userFields), actionFields), $8b036e99dd4c03a4$var$buildEventOverrides(event)), {}, {
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields), $8b036e99dd4c03a4$var$buildAliases(aliases)), $8b036e99dd4c03a4$var$buildGroups(groups));
}

});

parcelRegister("ez3h7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9a6dff75ecb682a$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");


var $2PfP0 = parcelRequire("2PfP0");

var $38XXT = parcelRequire("38XXT");
class $a9a6dff75ecb682a$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        (0, $5zQU9.default)(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        });
        (0, $5zQU9.default)(this, "startLowPriorityEventDelay", (timeout = (0, $12cf9be4d8e6252f$export$cf090d5281b5ae06), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $12cf9be4d8e6252f$export$8575e30be0feb909)) : (0, $12cf9be4d8e6252f$export$8575e30be0feb909);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $38XXT.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        });
        (0, $5zQU9.default)(this, "stopLowPriorityEventDelay", (reason = (0, $38XXT.StopLowPriorityEventDelayReason).MANUAL)=>{
            var _this$delayCallback;
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            (_this$delayCallback = this.delayCallback) === null || _this$delayCallback === void 0 || _this$delayCallback.call(this, reason);
            this.delayCallback = undefined;
        });
        (0, $5zQU9.default)(this, "isDelayingLowPriorityEvents", ()=>this.isDelaying);
        this.isDelaying = false;
        this.delayQueue = new (0, $2PfP0.default)(fireDelayedEvent, compressors);
    }
}

});
const $12cf9be4d8e6252f$export$cf090d5281b5ae06 = 10000;
const $12cf9be4d8e6252f$export$8575e30be0feb909 = 30000;

parcelRegister("2PfP0", function(module, exports) {

$parcel$export(module.exports, "default", () => $20ec9e0b6a80e3d9$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $bVXPQ = parcelRequire("bVXPQ");

var $eaJEm = parcelRequire("eaJEm");

var $jvSgy = parcelRequire("jvSgy");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $20ec9e0b6a80e3d9$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $20ec9e0b6a80e3d9$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $20ec9e0b6a80e3d9$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        (0, $5zQU9.default)(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        });
        (0, $5zQU9.default)(this, "size", ()=>this.eventArgs.length);
        (0, $5zQU9.default)(this, "startFlush", ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        });
        (0, $5zQU9.default)(this, "cancelFlush", ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        });
        (0, $5zQU9.default)(this, "flushNextBatch", ()=>{
            const batch = this.eventArgs.splice(0, $20ec9e0b6a80e3d9$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $20ec9e0b6a80e3d9$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        });
        (0, $5zQU9.default)(this, "compressEventArgs", (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $eaJEm.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $eaJEm.equals)(group.userInfo, args.userInfo) && (0, $eaJEm.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $bVXPQ.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        });
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $jvSgy.default)(compressionRules);
    }
}

});
parcelRegister("jvSgy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e34b01acc151dac3$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $bVXPQ = parcelRequire("bVXPQ");

var $eaJEm = parcelRequire("eaJEm");

var $gmPP3 = parcelRequire("gmPP3");
function $e34b01acc151dac3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e34b01acc151dac3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e34b01acc151dac3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e34b01acc151dac3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $e34b01acc151dac3$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        (0, $5zQU9.default)(this, "canCompress", (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event)));
        (0, $5zQU9.default)(this, "compress", (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        });
        (0, $5zQU9.default)(this, "createGroups", (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $bVXPQ.buildActionFields)(event, event.eventType);
                    contextFields = (0, $eaJEm.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $eaJEm.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []));
        (0, $5zQU9.default)(this, "compressGroup", (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>$e34b01acc151dac3$var$_objectSpread($e34b01acc151dac3$var$_objectSpread({}, actionFields), group.contextFields));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.events.length} uncompressed events instead`);
                return group.events;
            }
        });
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $gmPP3.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}

});


parcelRegister("38XXT", function(module, exports) {

$parcel$export(module.exports, "StopLowPriorityEventDelayReason", () => $24a0a2457231c494$export$fa6e3729c21cb8f);
let $24a0a2457231c494$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("54lSA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b0e4c483d0ce0e8$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $dFBS3 = parcelRequire("dFBS3");

var $6WYmo = parcelRequire("6WYmo");

var $j1fnp = parcelRequire("j1fnp");

var $buuYU = parcelRequire("buuYU");

var $dhCt2 = parcelRequire("dhCt2");

var $bpctN = parcelRequire("bpctN");

var $6gNKz = parcelRequire("6gNKz");

var $5UpLh = parcelRequire("5UpLh");

var $kPI67 = parcelRequire("kPI67");
function $3b0e4c483d0ce0e8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3b0e4c483d0ce0e8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3b0e4c483d0ce0e8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3b0e4c483d0ce0e8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $3b0e4c483d0ce0e8$export$2e2bcd8739ae039 {
    constructor(options){
        var _this$options;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        (0, $5zQU9.default)(this, "sendEvents", async (items, callback)=>{
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const metadata = $3b0e4c483d0ce0e8$var$_objectSpread($3b0e4c483d0ce0e8$var$_objectSpread({}, metricsPayload), {}, {
                httpRetryCount: httpRetryCount
            });
            for(let key in metadata)// @ts-ignore Some keys maybe a string, but these will never equal 0
            if (metadata[key] === 0) // @ts-ignore Save space in requests by removing metrics with no impact
            delete metadata[key];
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const unpackagedEvents = eventsWithXID.map((item)=>{
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                const response = await (0, $bpctN.sendEvents)({
                    url: this.gasv3BatchUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
            } catch (error) {
                callback(error, null);
            }
        });
        this.options = $3b0e4c483d0ce0e8$var$_objectSpread($3b0e4c483d0ce0e8$var$_objectSpread({}, options), {}, {
            requestTimeout: options.requestTimeout || (0, $dhCt2.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false
        });
        this.user = new (0, $5UpLh.default)((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $j1fnp.default)();
        this.resilienceQueue = (0, $6WYmo.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $6gNKz.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = $3b0e4c483d0ce0e8$var$_objectSpread($3b0e4c483d0ce0e8$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $6gNKz.SegmentEventTypes).TRACK,
            properties: (0, $kPI67.prepareEventProperties)(builtEvent),
            event: eventName
        });
        const event = $3b0e4c483d0ce0e8$var$_objectSpread($3b0e4c483d0ce0e8$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $6gNKz.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = $3b0e4c483d0ce0e8$var$_objectSpread($3b0e4c483d0ce0e8$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $6gNKz.SegmentEventTypes).PAGE,
            properties: (0, $kPI67.prepareEventProperties)(builtEvent),
            name: eventName
        });
        const event = $3b0e4c483d0ce0e8$var$_objectSpread($3b0e4c483d0ce0e8$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $6gNKz.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = $3b0e4c483d0ce0e8$var$_objectSpread($3b0e4c483d0ce0e8$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $6gNKz.SegmentEventTypes).IDENTIFY,
            traits: (0, $kPI67.prepareEventProperties)(builtEvent)
        });
        const event = $3b0e4c483d0ce0e8$var$_objectSpread($3b0e4c483d0ce0e8$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $kPI67.prepareEventProperties)(context);
        const segmentContext = (0, $kPI67.buildContext)(clonedContext);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $buuYU.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
}

});
parcelRegister("6WYmo", function(module, exports) {

$parcel$export(module.exports, "default", () => $50f6fb219ade5c6a$export$2e2bcd8739ae039);

var $iIK97 = parcelRequire("iIK97");

var $50f6fb219ade5c6a$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $iIK97.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("iIK97", function(module, exports) {

$parcel$export(module.exports, "default", () => $da1021b74e16cb43$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $bR5nb = parcelRequire("bR5nb");
var $beet7 = parcelRequire("beet7");

var $dJ5oQ = parcelRequire("dJ5oQ");
var $IlgzD = parcelRequire("IlgzD");
var $gKFhB = parcelRequire("gKFhB");

var $j1fnp = parcelRequire("j1fnp");

var $4g0Nt = parcelRequire("4g0Nt");

var $9XgvA = parcelRequire("9XgvA");
var $feAgz = parcelRequire("feAgz");

var $hObqm = parcelRequire("hObqm");
function $da1021b74e16cb43$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $da1021b74e16cb43$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $da1021b74e16cb43$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $da1021b74e16cb43$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $da1021b74e16cb43$var$ONE_MINUTE = 60000;
const $da1021b74e16cb43$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $da1021b74e16cb43$var$ONE_MINUTE,
    minRetryDelay: $da1021b74e16cb43$var$ONE_MINUTE,
    maxRetryDelay: $da1021b74e16cb43$var$ONE_MINUTE
};
const $da1021b74e16cb43$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // TODO figure out this number. For indexeddb we are sharing the queue with all tabs
    maxItems: 1000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $da1021b74e16cb43$export$2e2bcd8739ae039 {
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $IlgzD.default)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: options === null || options === void 0 ? void 0 : options.maxItems
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $9XgvA.default)($da1021b74e16cb43$var$_objectSpread($da1021b74e16cb43$var$_objectSpread({}, this.options), {}, {
            waitInterval: options !== null && options !== void 0 && options.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }), this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $9XgvA.default)($da1021b74e16cb43$var$_objectSpread($da1021b74e16cb43$var$_objectSpread({}, $da1021b74e16cb43$var$LONG_POLLING_OPTIONS), {}, {
            waitInterval: $da1021b74e16cb43$var$LONG_POLLING_OPTIONS.flushWaitMs
        }), this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $j1fnp.default)();
        this.networkStatus = new (0, $4g0Nt.default)((status)=>{
            if (status === (0, $hObqm.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $gKFhB.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $hObqm.NetworkStatusEnum).OFFLINE) {
            done((0, $feAgz.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $dJ5oQ.CallbackProcessingErrorName)) {
                done((0, $feAgz.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $bR5nb.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $beet7.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $gKFhB.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $feAgz.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $feAgz.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $feAgz.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || $da1021b74e16cb43$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : $da1021b74e16cb43$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || $da1021b74e16cb43$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || $da1021b74e16cb43$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || $da1021b74e16cb43$export$d219df4fe04c04a7.flushWaitMs,
            maxItems: (options === null || options === void 0 ? void 0 : options.maxItems) || $da1021b74e16cb43$export$d219df4fe04c04a7.maxItems,
            maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || $da1021b74e16cb43$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || $da1021b74e16cb43$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || $da1021b74e16cb43$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}

});
parcelRegister("bR5nb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a18cfe42bfcbb9a$export$2e2bcd8739ae039);

var $4RWKr = parcelRequire("4RWKr");

var $eACNI = parcelRequire("eACNI");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $8a18cfe42bfcbb9a$var$validSuffixs = Object.values((0, $4RWKr.LocalStorageKeySuffix));
var $8a18cfe42bfcbb9a$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $8a18cfe42bfcbb9a$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $4RWKr.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $eACNI.createLocalStorageKeys)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("4RWKr", function(module, exports) {

$parcel$export(module.exports, "LocalStorageKeySuffix", () => $38b9aec810ecd745$export$ecfa71cbc9b28241);
$parcel$export(module.exports, "Timers", () => $38b9aec810ecd745$export$8bb2c1fb2b1765a9);
let $38b9aec810ecd745$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
let $38b9aec810ecd745$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("eACNI", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageKeys", () => $a9f2868cebc0a395$export$8433d54f767cbec5);

var $4RWKr = parcelRequire("4RWKr");
const $a9f2868cebc0a395$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $4RWKr.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $4RWKr.LocalStorageKeySuffix).ACK}`,
        [(0, $4RWKr.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $4RWKr.LocalStorageKeySuffix).QUEUE}`,
        [(0, $4RWKr.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $4RWKr.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $4RWKr.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $4RWKr.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $4RWKr.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $4RWKr.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("beet7", function(module, exports) {

$parcel$export(module.exports, "default", () => $82cc39ae49fb1d6d$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $dFBS3 = parcelRequire("dFBS3");

var $4RWKr = parcelRequire("4RWKr");

var $eACNI = parcelRequire("eACNI");
function $82cc39ae49fb1d6d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $82cc39ae49fb1d6d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $82cc39ae49fb1d6d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $82cc39ae49fb1d6d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Code we need to mimic:
// https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L262-L357
// Note we do not want to run this library due to the performance, duplication and memory leak issues.
const $82cc39ae49fb1d6d$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $82cc39ae49fb1d6d$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $4RWKr.LocalStorageKeySuffix).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $4RWKr.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (error) {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch (_error) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $82cc39ae49fb1d6d$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $82cc39ae49fb1d6d$var$promisedSetTimeout((0, $4RWKr.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $4RWKr.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $82cc39ae49fb1d6d$var$promisedSetTimeout((0, $4RWKr.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $4RWKr.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $82cc39ae49fb1d6d$var$reclaim(options, callback);
};
const $82cc39ae49fb1d6d$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = $82cc39ae49fb1d6d$var$_objectSpread($82cc39ae49fb1d6d$var$_objectSpread({}, item), {}, {
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        });
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $82cc39ae49fb1d6d$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $82cc39ae49fb1d6d$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $82cc39ae49fb1d6d$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $82cc39ae49fb1d6d$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
    const queuesToReclaim = $82cc39ae49fb1d6d$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$82cc39ae49fb1d6d$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $eACNI.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});

parcelRegister("dJ5oQ", function(module, exports) {

$parcel$export(module.exports, "CallbackProcessingErrorName", () => $9fe3aa9b816bb2dc$export$a409c8de90e11e14);
$parcel$export(module.exports, "default", () => $9fe3aa9b816bb2dc$export$2e2bcd8739ae039);
const $9fe3aa9b816bb2dc$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $9fe3aa9b816bb2dc$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $9fe3aa9b816bb2dc$export$2e2bcd8739ae039.prototype);
        this.name = $9fe3aa9b816bb2dc$export$a409c8de90e11e14;
    }
}

});

parcelRegister("IlgzD", function(module, exports) {

$parcel$export(module.exports, "default", () => $08549b3948e8bb33$export$2e2bcd8739ae039);

var $kI8Xv = parcelRequire("kI8Xv");

var $gKFhB = parcelRequire("gKFhB");

var $dJ5oQ = parcelRequire("dJ5oQ");
var $08549b3948e8bb33$export$2e2bcd8739ae039 = (0, $kI8Xv.default);

});
parcelRegister("kI8Xv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f13eddc24535fa1e$export$2e2bcd8739ae039);

var $gKFhB = parcelRequire("gKFhB");

var $8i80Y = parcelRequire("8i80Y");
var $aI6sO = parcelRequire("aI6sO");

var $eY6Jo = parcelRequire("eY6Jo");

var $9vF9y = parcelRequire("9vF9y");

var $20tEp = parcelRequire("20tEp");
class $f13eddc24535fa1e$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $20tEp.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $eY6Jo.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $8i80Y.default))) {
                var _options$logger;
                (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
            }
        }
        return new (0, $9vF9y.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $gKFhB.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $gKFhB.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $aI6sO.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $gKFhB.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $9vF9y.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $gKFhB.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
}

});
parcelRegister("gKFhB", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", () => $c320f72330845785$export$d21fbb25eb37b5bf);
$parcel$export(module.exports, "RESILIENCE_DB_NAME", () => $c320f72330845785$export$8cad224051643259);
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", () => $c320f72330845785$export$3d8420be07b276ab);
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", () => $c320f72330845785$export$a512a65455fce2a6);
$parcel$export(module.exports, "TIME_ADDED_INDEX", () => $c320f72330845785$export$89d9c1ff8ac91862);
$parcel$export(module.exports, "RETRY_INDEX", () => $c320f72330845785$export$a37d385bcd713809);
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", () => $c320f72330845785$export$6d8635fed0e4b14d);
$parcel$export(module.exports, "StoreType", () => $c320f72330845785$export$39337ab5872e9457);
$parcel$export(module.exports, "GuardPolicy", () => $c320f72330845785$export$7710d69e6f450f20);
const $c320f72330845785$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $c320f72330845785$export$8cad224051643259 = 'analytics-web-client';
const $c320f72330845785$export$3d8420be07b276ab = 'analytics-resilience';
const $c320f72330845785$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $c320f72330845785$export$89d9c1ff8ac91862 = 'timeAdded';
const $c320f72330845785$export$a37d385bcd713809 = 'retryAttempts';
const $c320f72330845785$export$6d8635fed0e4b14d = 15000;
let $c320f72330845785$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
let $c320f72330845785$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    GuardPolicy["IGNORE"] = "ignore";
    GuardPolicy["ABANDON"] = "abandon";
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("8i80Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $609638b34d365ee0$export$2e2bcd8739ae039);
const $609638b34d365ee0$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $609638b34d365ee0$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $609638b34d365ee0$export$2e2bcd8739ae039.prototype);
        this.name = $609638b34d365ee0$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("aI6sO", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreResilienceDbError", () => $7cc30701a0b7dba4$export$74101021e0969375);

var $cjuzB = parcelRequire("cjuzB");

var $dJ5oQ = parcelRequire("dJ5oQ");

var $fFUMz = parcelRequire("fFUMz");
const $7cc30701a0b7dba4$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $cjuzB.AbandonWriteErrorName) || errorWithName.name === (0, $dJ5oQ.CallbackProcessingErrorName) || errorWithName.name === (0, $fFUMz.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("cjuzB", function(module, exports) {

$parcel$export(module.exports, "AbandonWriteErrorName", () => $8f6ef99431fcffa5$export$ba95206613c96b28);
$parcel$export(module.exports, "default", () => $8f6ef99431fcffa5$export$2e2bcd8739ae039);
const $8f6ef99431fcffa5$export$ba95206613c96b28 = 'AbandonWriteError';
class $8f6ef99431fcffa5$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $8f6ef99431fcffa5$export$2e2bcd8739ae039.prototype);
        this.name = $8f6ef99431fcffa5$export$ba95206613c96b28;
    }
}

});

parcelRegister("fFUMz", function(module, exports) {

$parcel$export(module.exports, "InvalidPolicyErrorName", () => $b696bb2853f3ff9e$export$7e7aee9a953465ec);
$parcel$export(module.exports, "default", () => $b696bb2853f3ff9e$export$2e2bcd8739ae039);
const $b696bb2853f3ff9e$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $b696bb2853f3ff9e$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $b696bb2853f3ff9e$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("eY6Jo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae5be3f26922738f$export$2e2bcd8739ae039);

var $bwPfh = parcelRequire("bwPfh");

var $5zQU9 = parcelRequire("5zQU9");

var $gKFhB = parcelRequire("gKFhB");

var $1vRDG = parcelRequire("1vRDG");

var $dJ5oQ = parcelRequire("dJ5oQ");
var $fFUMz = parcelRequire("fFUMz");
var $8i80Y = parcelRequire("8i80Y");
var $aI6sO = parcelRequire("aI6sO");

var $iyV9N = parcelRequire("iyV9N");

var $20tEp = parcelRequire("20tEp");
const $ae5be3f26922738f$var$_excluded = [
    "item"
], $ae5be3f26922738f$var$_excluded2 = [
    "items"
];
function $ae5be3f26922738f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ae5be3f26922738f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ae5be3f26922738f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ae5be3f26922738f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $ae5be3f26922738f$export$2e2bcd8739ae039 {
    constructor(_namespace, _options = {}){
        (0, $5zQU9.default)(this, "startDB", async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, $8i80Y.default)());
                    }, (0, $gKFhB.INDEXEDDB_TIMEOUT));
                    /*
           * The database version number can never change.
           * An upgrade transaction is limited to only one connection to the database.
           * Once this is done, we cannot open any connections with older versions of the schema.
           * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
           *
           * Due to the nature of how AWC is used (multiple tabs that are very long lived),
           * we will not be able to run version upgrades via indexeddb.
           *
           * This does not mean we cant change what is stored in the tables,
           * this limitation just prevents us from:
           *   - Creating new ObjectStores in this database connection, and
           *   - Creating new indexes on our ObjectStores
           *
           * Any upgrades we wish to run in the future will have to create a new database,
           * and migrate all the data from older databases.
           *
           * This also means any migrations we make will have to be supported until we have evidence
           * that no events are coming from old versions of the database.
           * This may take a long time.
           */ const request = window.indexedDB.open((0, $gKFhB.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, $gKFhB.RESILIENCE_STORE_NAME), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, $gKFhB.TIME_TO_PROCESS_AFTER_INDEX), (0, $gKFhB.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $gKFhB.RETRY_INDEX), (0, $gKFhB.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $gKFhB.TIME_ADDED_INDEX), (0, $gKFhB.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $gKFhB.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    try {
                        await (0, $20tEp.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, $8i80Y.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $8i80Y.default)());
                }
            });
        });
        (0, $5zQU9.default)(this, "addItem", async (item, options = {}, policy = (0, $gKFhB.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $20tEp.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, $gKFhB.GuardPolicy).IGNORE) throw new (0, $fFUMz.default)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $aI6sO.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        });
        (0, $5zQU9.default)(this, "bulkAddItem", async (itemOptions, policy = (0, $gKFhB.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map((_ref)=>{
                let { item: item } = _ref, options = (0, $bwPfh.default)(_ref, $ae5be3f26922738f$var$_excluded);
                return (0, $20tEp.convertToItemWrapper)(item, namespace, options);
            });
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $aI6sO.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        });
        (0, $5zQU9.default)(this, "getItems", async (count = (0, $1vRDG.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $1vRDG.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, $gKFhB.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = $ae5be3f26922738f$var$_objectSpread({}, cursor.value);
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $1vRDG.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $20tEp.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $20tEp.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $20tEp.commitTransaction)(transaction, this.logger);
            return getResult;
        });
        (0, $5zQU9.default)(this, "deleteItems", async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $20tEp.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        });
        (0, $5zQU9.default)(this, "getItemCount", async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, $gKFhB.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $20tEp.requestToPromise)(request);
            await (0, $20tEp.commitTransaction)(transaction, this.logger);
            return event.target.result;
        });
        (0, $5zQU9.default)(this, "processItems", async (processFn, count = (0, $1vRDG.GET_ITEM_COUNT))=>{
            const _await$this$getItems = await this.getItems(count), { items: items } = _await$this$getItems, partialResult = (0, $bwPfh.default)(_await$this$getItems, $ae5be3f26922738f$var$_excluded2);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $dJ5oQ.default)(error);
            }
        });
        (0, $5zQU9.default)(this, "deleteItem", async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $20tEp.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        });
        (0, $5zQU9.default)(this, "getObjectStoreAndTransaction", async (mode)=>{
            const transaction = (await this.db).transaction((0, $gKFhB.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $gKFhB.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        });
        this.options = (0, $20tEp.createOptionsWithDefaults)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $8i80Y.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $iyV9N.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    storeType() {
        return (0, $gKFhB.StoreType).INDEXEDDB;
    }
}

});
parcelRegister("1vRDG", function(module, exports) {

$parcel$export(module.exports, "GET_ITEM_COUNT", () => $11a24b50998e6f4d$export$b6df3d334cec060f);
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", () => $11a24b50998e6f4d$export$14ef152a03a4b6ee);
$parcel$export(module.exports, "MAX_ATTEMPTS", () => $11a24b50998e6f4d$export$da9ab7b2fd5998e8);
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", () => $11a24b50998e6f4d$export$1188664dfff364c8);
const $11a24b50998e6f4d$export$b6df3d334cec060f = 7;
const $11a24b50998e6f4d$export$14ef152a03a4b6ee = 60000;
const $11a24b50998e6f4d$export$da9ab7b2fd5998e8 = 10;
const $11a24b50998e6f4d$export$1188664dfff364c8 = 5000;

});

parcelRegister("iyV9N", function(module, exports) {

$parcel$export(module.exports, "default", () => $d837bd24a3479a33$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $gKFhB = parcelRequire("gKFhB");

var $cjuzB = parcelRequire("cjuzB");

var $20tEp = parcelRequire("20tEp");
class $d837bd24a3479a33$export$2e2bcd8739ae039 {
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ (0, $5zQU9.default)(this, "deleteOldestNEvents", async (objectStore, count)=>{
            var _target;
            const productTimeAddedIndex = objectStore.index((0, $gKFhB.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $20tEp.requestToPromise)(getAllRequest);
            const result = event === null || event === void 0 ? void 0 : (_target = event.target) === null || _target === void 0 ? void 0 : _target.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $gKFhB.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $gKFhB.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $gKFhB.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $gKFhB.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $20tEp.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $20tEp.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $cjuzB.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $gKFhB.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $20tEp.requestToPromise)(request);
        return event.target.result;
    }
}

});
parcelRegister("20tEp", function(module, exports) {

$parcel$export(module.exports, "convertToItemWrapper", () => $176294df69783d0f$export$aec476f33d77be11);
$parcel$export(module.exports, "createOptionsWithDefaults", () => $176294df69783d0f$export$ddc6718318090f71);
$parcel$export(module.exports, "requestToPromise", () => $176294df69783d0f$export$85ceed0783e42041);
$parcel$export(module.exports, "commitTransaction", () => $176294df69783d0f$export$feab8418f018df89);
$parcel$export(module.exports, "monitorErrorsOnRequest", () => $176294df69783d0f$export$342d941b6f724995);

var $dFBS3 = parcelRequire("dFBS3");

var $1vRDG = parcelRequire("1vRDG");
const $176294df69783d0f$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $176294df69783d0f$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $1vRDG.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $1vRDG.EVENT_COUNT_LIMIT)
    });
const $176294df69783d0f$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $176294df69783d0f$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $176294df69783d0f$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return $176294df69783d0f$export$2a5213bce1720b42(transaction);
};
const $176294df69783d0f$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};

});



parcelRegister("9vF9y", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ec6ee728f0cbb49$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $gKFhB = parcelRequire("gKFhB");

var $1vRDG = parcelRequire("1vRDG");

var $dJ5oQ = parcelRequire("dJ5oQ");
var $fFUMz = parcelRequire("fFUMz");

var $d2F6m = parcelRequire("d2F6m");

var $20tEp = parcelRequire("20tEp");
const $6ec6ee728f0cbb49$var$_excluded = [
    "item"
], $6ec6ee728f0cbb49$var$_excluded2 = [
    "items"
];
function $6ec6ee728f0cbb49$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6ec6ee728f0cbb49$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6ec6ee728f0cbb49$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6ec6ee728f0cbb49$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $6ec6ee728f0cbb49$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $20tEp.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $d2F6m.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $gKFhB.GuardPolicy).ABANDON) {
        if (policy === (0, $gKFhB.GuardPolicy).IGNORE) throw new (0, $fFUMz.default)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $20tEp.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $gKFhB.GuardPolicy).ABANDON) {
        const items = itemOptions.map((_ref)=>{
            let { item: item } = _ref, addOptions = (0, $bwPfh.default)(_ref, $6ec6ee728f0cbb49$var$_excluded);
            return (0, $20tEp.convertToItemWrapper)(item, this.namespace, addOptions);
        });
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $gKFhB.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $1vRDG.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $1vRDG.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $1vRDG.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push($6ec6ee728f0cbb49$var$_objectSpread({}, wrappedItem));
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $1vRDG.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const _this$synchronousGetI = this.synchronousGetItems(count), { items: items } = _this$synchronousGetI, partialGetResult = (0, $bwPfh.default)(_this$synchronousGetI, $6ec6ee728f0cbb49$var$_excluded2);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $dJ5oQ.default)(error);
        }
    }
    storeType() {
        return (0, $gKFhB.StoreType).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}

});
parcelRegister("d2F6m", function(module, exports) {

$parcel$export(module.exports, "default", () => $97eb5829f3d69a74$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $gKFhB = parcelRequire("gKFhB");

var $cjuzB = parcelRequire("cjuzB");
class $97eb5829f3d69a74$export$2e2bcd8739ae039 {
    constructor(eventLimit, memoryItemHandlers){
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ (0, $5zQU9.default)(this, "insertItemsToMemoryStore", (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $gKFhB.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $gKFhB.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $gKFhB.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $cjuzB.default)((0, $gKFhB.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}

});




parcelRegister("j1fnp", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd8a09ce5a749645$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $hObqm = parcelRequire("hObqm");
class $dd8a09ce5a749645$export$4b62ee5120ab50a8 {
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        (0, $5zQU9.default)(this, "itemsDiscardedByRetry", 0);
        // Number of events created by the product in current tab.
        (0, $5zQU9.default)(this, "eventCount", 0);
        // Number of events discarded due to reaching queue max size.
        (0, $5zQU9.default)(this, "itemsDiscardedByOverflow", 0);
        // Will be used in the future when we get more resilience mechanisms
        (0, $5zQU9.default)(this, "resilienceMechanism", (0, $hObqm.ResilienceMechanism).INDEXEDDB);
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        (0, $5zQU9.default)(this, "localstorageNumberOfQueuesPurged", 0);
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        (0, $5zQU9.default)(this, "localstorageNumberOfFullReclaims", 0);
        // Queue was found but not all events were able to be put into resilienceDb.
        (0, $5zQU9.default)(this, "localstorageNumberOfPartialReclaims", 0);
        // Reclaim failed for a queue and reclaim was abandonded.
        (0, $5zQU9.default)(this, "localstorageNumberOfFailedReclaims", 0);
    }
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
}
let $dd8a09ce5a749645$var$cachedMetricsClient = null;
var $dd8a09ce5a749645$export$2e2bcd8739ae039 = ()=>{
    if (!$dd8a09ce5a749645$var$cachedMetricsClient) $dd8a09ce5a749645$var$cachedMetricsClient = new $dd8a09ce5a749645$export$4b62ee5120ab50a8();
    return $dd8a09ce5a749645$var$cachedMetricsClient;
};

});
parcelRegister("hObqm", function(module, exports) {

$parcel$export(module.exports, "ResilienceMechanism", () => $cf6ff7c982c71cc0$export$c75161629e3ec34e);
$parcel$export(module.exports, "NetworkStatusEnum", () => $cf6ff7c982c71cc0$export$ee138fa712d11b84);
let $cf6ff7c982c71cc0$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
let $cf6ff7c982c71cc0$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});


parcelRegister("4g0Nt", function(module, exports) {

$parcel$export(module.exports, "default", () => $31994652d33c089b$export$2e2bcd8739ae039);

var $hObqm = parcelRequire("hObqm");
class $31994652d33c089b$export$2e2bcd8739ae039 {
    constructor(networkChangeCallback){
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>networkChangeCallback((0, $hObqm.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>networkChangeCallback((0, $hObqm.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $hObqm.NetworkStatusEnum).ONLINE;
        return (0, $hObqm.NetworkStatusEnum).OFFLINE;
    }
}

});

parcelRegister("9XgvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $73f66dff2a111329$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3LYuU = parcelRequire("3LYuU");

var $feAgz = parcelRequire("feAgz");
const $73f66dff2a111329$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
let $73f66dff2a111329$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $73f66dff2a111329$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        (0, $5zQU9.default)(this, "schedule", ({ immediate: immediate } = {
            immediate: false
        })=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = $73f66dff2a111329$export$8bb92baee001fc60.IMMEDIATE;
                else if (this.queuedSchedule !== $73f66dff2a111329$export$8bb92baee001fc60.IMMEDIATE) this.queuedSchedule = $73f66dff2a111329$export$8bb92baee001fc60.WAIT;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Backoff
            } else if (this.failureCount > 0 && this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
            else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.options.waitInterval);
        });
        (0, $5zQU9.default)(this, "stop", ()=>{
            this.clearTimeout();
            this.queuedSchedule = $73f66dff2a111329$export$8bb92baee001fc60.NONE;
        });
        (0, $5zQU9.default)(this, "getFailureCount", ()=>this.failureCount);
        (0, $5zQU9.default)(this, "getCallbackStatus", ()=>{
            return this.callbackTimer.getCallbackStatus();
        });
        (0, $5zQU9.default)(this, "clearTimeout", ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        });
        (0, $5zQU9.default)(this, "run", ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $feAgz.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        });
        (0, $5zQU9.default)(this, "done", (state)=>{
            this.operationInFlight = false;
            if (state === (0, $feAgz.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $3LYuU.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $feAgz.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        });
        (0, $5zQU9.default)(this, "processQueuedSchedule", ()=>{
            if (this.queuedSchedule !== $73f66dff2a111329$export$8bb92baee001fc60.NONE) {
                const immediate = this.queuedSchedule === $73f66dff2a111329$export$8bb92baee001fc60.IMMEDIATE;
                this.queuedSchedule = $73f66dff2a111329$export$8bb92baee001fc60.NONE;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        });
        (0, $5zQU9.default)(this, "calculateBackoff", ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage } = this.options;
            let ms = minRetryDelay * backoffFactor ** this.failureCount;
            if (backoffJitterPercentage) {
                const rand = Math.random();
                const deviation = Math.floor(rand * backoffJitterPercentage * ms);
                if (Math.floor(rand * 10) < 5) ms -= deviation;
                else ms += deviation;
            }
            return Number(Math.min(ms, maxRetryDelay).toPrecision(1));
        });
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $73f66dff2a111329$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $73f66dff2a111329$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $73f66dff2a111329$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $73f66dff2a111329$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $73f66dff2a111329$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $73f66dff2a111329$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = $73f66dff2a111329$export$8bb92baee001fc60.NONE;
        this.callbackTimer = new (0, $3LYuU.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("3LYuU", function(module, exports) {

$parcel$export(module.exports, "CallbackStatus", () => $2bf4b075719a90eb$export$ef3353088fca369c);
$parcel$export(module.exports, "CallbackWithTimeout", () => $2bf4b075719a90eb$export$590a718599f8f8b3);

var $5zQU9 = parcelRequire("5zQU9");
let $2bf4b075719a90eb$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
let $2bf4b075719a90eb$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $2bf4b075719a90eb$export$590a718599f8f8b3 {
    constructor(timeoutPeriod){
        // Milliseconds to wait
        // Tracks the settimeout; so that we can clear the timeout
        (0, $5zQU9.default)(this, "timeoutHandle", undefined);
        (0, $5zQU9.default)(this, "callbackStatus", $2bf4b075719a90eb$export$ef3353088fca369c.IDLE);
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case $2bf4b075719a90eb$export$ef3353088fca369c.IDLE:
            case $2bf4b075719a90eb$export$ef3353088fca369c.TIMED_OUT:
            case $2bf4b075719a90eb$export$ef3353088fca369c.COMPLETED:
                if (event === $2bf4b075719a90eb$export$def7d978353eaa0.EXECUTE) this.callbackStatus = $2bf4b075719a90eb$export$ef3353088fca369c.RUNNING;
                break;
            case $2bf4b075719a90eb$export$ef3353088fca369c.RUNNING:
                switch(event){
                    case $2bf4b075719a90eb$export$def7d978353eaa0.COMPLETE:
                        this.callbackStatus = $2bf4b075719a90eb$export$ef3353088fca369c.COMPLETED;
                        break;
                    case $2bf4b075719a90eb$export$def7d978353eaa0.TIMEOUT:
                        this.callbackStatus = $2bf4b075719a90eb$export$ef3353088fca369c.TIMED_OUT;
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, $2bf4b075719a90eb$export$def7d978353eaa0.EXECUTE);
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, $2bf4b075719a90eb$export$def7d978353eaa0.TIMEOUT);
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== $2bf4b075719a90eb$export$ef3353088fca369c.TIMED_OUT) {
                this.transitionCallbackStatus(this.callbackStatus, $2bf4b075719a90eb$export$def7d978353eaa0.COMPLETE);
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}

});

parcelRegister("feAgz", function(module, exports) {

$parcel$export(module.exports, "DoneState", () => $b1744b8edb2db019$export$f93c40fda808dd0c);
// Clients can optionally provide the callbackTimeoutPeriod parameter
let $b1744b8edb2db019$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("buuYU", function(module, exports) {

$parcel$export(module.exports, "attachXidToMultipleEvents", () => $85da874b1477825c$export$c21270cab66ab290);

var $5zQU9 = parcelRequire("5zQU9");

var $6gNKz = parcelRequire("6gNKz");
function $85da874b1477825c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $85da874b1477825c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $85da874b1477825c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $85da874b1477825c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $85da874b1477825c$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $6gNKz.SegmentEventTypes).PAGE || item.msg.type === (0, $6gNKz.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = $85da874b1477825c$var$_objectSpread($85da874b1477825c$var$_objectSpread({}, item.msg.properties), {}, {
            xid: xid
        });
    } else if (item.msg.traits && item.msg.type === (0, $6gNKz.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = $85da874b1477825c$var$_objectSpread($85da874b1477825c$var$_objectSpread({}, item.msg.traits), {}, {
            xid: xid
        });
    }
    return item;
}
async function $85da874b1477825c$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$85da874b1477825c$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("6gNKz", function(module, exports) {

$parcel$export(module.exports, "SegmentEventTypes", () => $490ad4108fd97437$export$ddf929981dc6feb3);
// Segment event types copied from our backend
// https://bitbucket.org/atlassian/analytics-service/src/master/api/src/main/java/com/atlassian/dataservices/analytics/service/api/segment/
let $490ad4108fd97437$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
let $490ad4108fd97437$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
let $490ad4108fd97437$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});

});


parcelRegister("dhCt2", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", () => $9abab3ba49a282b5$export$9175ce0e1c95daf2);
const $9abab3ba49a282b5$export$9175ce0e1c95daf2 = 10000; // 10 seconds

});

parcelRegister("bpctN", function(module, exports) {

$parcel$export(module.exports, "sendEvents", () => $84dbb5abf381814a$export$8e8f0180c1b41fad);

var $5zQU9 = parcelRequire("5zQU9");

var $5iWql = parcelRequire("5iWql");
function $84dbb5abf381814a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $84dbb5abf381814a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $84dbb5abf381814a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $84dbb5abf381814a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $84dbb5abf381814a$export$8e8f0180c1b41fad = async (options)=>{
    var _createOrGetAbortCont;
    const signal = (_createOrGetAbortCont = $84dbb5abf381814a$var$createOrGetAbortController(options)) === null || _createOrGetAbortCont === void 0 ? void 0 : _createOrGetAbortCont.signal;
    const corsOptions = $84dbb5abf381814a$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, $84dbb5abf381814a$var$_objectSpread({
        method: 'POST',
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            'Content-Type': 'text/plain'
        },
        body: JSON.stringify(options.batch),
        signal: signal
    }, corsOptions));
    if (response.status === 429 || response.status >= 500 && response.status < 600) throw new Error(`HTTP Error ${response.status} (${response.statusText})`);
    return response;
};
const $84dbb5abf381814a$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $84dbb5abf381814a$var$getCorsForUrl = (0, $5iWql.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});

parcelRegister("5UpLh", function(module, exports) {

$parcel$export(module.exports, "default", () => $44d62a739a3714ba$export$2e2bcd8739ae039);

var $d2wNG = parcelRequire("d2wNG");

var $dFBS3 = parcelRequire("dFBS3");

var $eSBJq = parcelRequire("eSBJq");
var $iUe7A = parcelRequire("iUe7A");

var $empVP = parcelRequire("empVP");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $44d62a739a3714ba$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $44d62a739a3714ba$var$SAFE = 'SAFE';
const $44d62a739a3714ba$var$UNSAFE = 'UNSAFE';
const $44d62a739a3714ba$var$NOT_FOUND = 'NOT_FOUND';
const $44d62a739a3714ba$var$COOKIE = 'COOKIE';
const $44d62a739a3714ba$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $44d62a739a3714ba$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.store = new (0, $empVP.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $iUe7A.default)(disableCookiePersistence);
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $eSBJq.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $eSBJq.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $44d62a739a3714ba$var$LOCAL_STORAGE ? this.store.getItem((0, $eSBJq.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $eSBJq.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $44d62a739a3714ba$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $44d62a739a3714ba$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch (err) {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $44d62a739a3714ba$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($44d62a739a3714ba$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $d2wNG.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $44d62a739a3714ba$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $44d62a739a3714ba$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $44d62a739a3714ba$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $44d62a739a3714ba$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($44d62a739a3714ba$var$COOKIE);
        switch(cookieValue.type){
            case $44d62a739a3714ba$var$SAFE:
            case $44d62a739a3714ba$var$UNSAFE:
                this.store.setItem((0, $eSBJq.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $44d62a739a3714ba$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))) {
        const newAnonId = customAnonymousIdGenerator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}

});
parcelRegister("eSBJq", function(module, exports) {

$parcel$export(module.exports, "AWCCookiesKeys", () => $ad53608aa2c8d2c4$export$202d555a5dbfd90c);
$parcel$export(module.exports, "AllAnalyticsCookies", () => $ad53608aa2c8d2c4$export$d4cb17942ea57c95);
let $ad53608aa2c8d2c4$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $ad53608aa2c8d2c4$var$CookieSchema {
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
}
const $ad53608aa2c8d2c4$export$d4cb17942ea57c95 = {
    [$ad53608aa2c8d2c4$export$202d555a5dbfd90c.AWC_TLD_TEST]: new $ad53608aa2c8d2c4$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: window.location.protocol === 'https:',
        path: '/'
    }),
    [$ad53608aa2c8d2c4$export$202d555a5dbfd90c.AWC_ANALYTICS_DEBUG]: new $ad53608aa2c8d2c4$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: window.location.protocol === 'https:',
        path: '/'
    }),
    [$ad53608aa2c8d2c4$export$202d555a5dbfd90c.AJS_ANONYMOUS_ID]: new $ad53608aa2c8d2c4$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: window.location.protocol === 'https:',
        path: '/'
    })
};

});

parcelRegister("iUe7A", function(module, exports) {

$parcel$export(module.exports, "default", () => $038d4c04d0a58836$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $M2DFp = parcelRequire("M2DFp");

var $eSBJq = parcelRequire("eSBJq");

var $3GvaU = parcelRequire("3GvaU");

var $4ieaT = parcelRequire("4ieaT");
function $038d4c04d0a58836$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $038d4c04d0a58836$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $038d4c04d0a58836$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $038d4c04d0a58836$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $038d4c04d0a58836$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $4ieaT.canUseCookie)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($M2DFp))) : new (0, $3GvaU.default)();
    }
    set(name, value, options) {
        // no-op
        if (!(0, $eSBJq.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $eSBJq.AllAnalyticsCookies)[name].getKey(), value, $038d4c04d0a58836$var$_objectSpread($038d4c04d0a58836$var$_objectSpread({}, (0, $eSBJq.AllAnalyticsCookies)[name].getAttributes()), {}, {
            // Function is memoized so we only calculate this once per page load
            domain: (0, $4ieaT.getTld)()
        }, options));
    }
    get(name) {
        if (!(0, $eSBJq.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $eSBJq.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $eSBJq.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $eSBJq.AllAnalyticsCookies)[name].getKey(), $038d4c04d0a58836$var$_objectSpread({}, options));
    }
}

});
parcelRegister("3GvaU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aed7a08d5eda0a4$export$2e2bcd8739ae039);

var $empVP = parcelRequire("empVP");
class $2aed7a08d5eda0a4$export$2e2bcd8739ae039 {
    constructor(){
        this.safeStorage = new (0, $empVP.default)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}

});
parcelRegister("empVP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7473c437f68f2e8$export$2e2bcd8739ae039);

var $6PZgF = parcelRequire("6PZgF");

var $asdds = parcelRequire("asdds");
class $a7473c437f68f2e8$export$2e2bcd8739ae039 extends (0, $asdds.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.localStorage || (0, $6PZgF.default);
        } catch (err) {
            storageToUse = (0, $6PZgF.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("6PZgF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fa7080871561512$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
class $4fa7080871561512$export$90e3e001bcac59c7 {
    constructor(){
        (0, $5zQU9.default)(this, "_data", {});
        (0, $5zQU9.default)(this, "length", 0);
        (0, $5zQU9.default)(this, "setItem", (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        });
        (0, $5zQU9.default)(this, "getItem", (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        });
        (0, $5zQU9.default)(this, "removeItem", (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        });
        (0, $5zQU9.default)(this, "clear", ()=>{
            this._data = {};
            this.length = 0;
        });
        (0, $5zQU9.default)(this, "key", (index)=>Object.keys(this._data)[index]);
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$4fa7080871561512$export$2e2bcd8739ae039 = new $4fa7080871561512$export$90e3e001bcac59c7();

});

parcelRegister("asdds", function(module, exports) {

$parcel$export(module.exports, "default", () => $79c6c5552c2919f3$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $hRleJ = parcelRequire("hRleJ");

var $6PZgF = parcelRequire("6PZgF");
const $79c6c5552c2919f3$export$41c06fdd37b7e9a5 = 'awc';
const $79c6c5552c2919f3$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
function $79c6c5552c2919f3$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
function $79c6c5552c2919f3$export$6325979d1c67607f(e) {
    let quotaExceeded = false;
    if (e.code) switch(e.code){
        case 22:
            quotaExceeded = true;
            break;
        case 1014:
            // Firefox
            if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') quotaExceeded = true;
            break;
        default:
            break;
    }
    else if (e.number === -2147024882) // Internet Explorer 8
    quotaExceeded = true;
    return quotaExceeded;
}
class $79c6c5552c2919f3$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        (0, $5zQU9.default)(this, "getStore", ()=>this._store);
        (0, $5zQU9.default)(this, "getItem", (key)=>this._store.getItem(this.createKey(key)));
        (0, $5zQU9.default)(this, "removeItem", (key)=>this._store.removeItem(this.createKey(key)));
        (0, $5zQU9.default)(this, "setItem", (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                if ($79c6c5552c2919f3$export$6325979d1c67607f(err)) {
                    this.swapToInMemory();
                    this._store.setItem(this.createKey(key), value);
                }
            }
        });
        (0, $5zQU9.default)(this, "swapToInMemory", ()=>{
            if (this._store === (0, $6PZgF.default) || typeof window === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($79c6c5552c2919f3$export$48c17662a6902497(window[$79c6c5552c2919f3$export$770aa8bc07b3de03])) inMemoryStorage = window[$79c6c5552c2919f3$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $6PZgF.default);
                if (!window[$79c6c5552c2919f3$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$79c6c5552c2919f3$export$770aa8bc07b3de03] = (0, $6PZgF.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        });
        (0, $5zQU9.default)(this, "clear", ()=>this._store.clear());
        (0, $5zQU9.default)(this, "key", (index)=>this._store.key(index));
        (0, $5zQU9.default)(this, "getPrefix", ()=>this._prefix);
        (0, $5zQU9.default)(this, "createKey", (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        });
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($79c6c5552c2919f3$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $hRleJ.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ($79c6c5552c2919f3$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});



parcelRegister("4ieaT", function(module, exports) {

$parcel$export(module.exports, "canUseCookie", () => $3203d6a39c36d77b$export$a9330601ee8f4d95);
$parcel$export(module.exports, "getTld", () => $3203d6a39c36d77b$export$de6821eed3d5f32d);

var $M2DFp = parcelRequire("M2DFp");

var $5iWql = parcelRequire("5iWql");

var $eSBJq = parcelRequire("eSBJq");
const $3203d6a39c36d77b$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $3203d6a39c36d77b$export$eb80e1beaa8dacf8 = (0, $eSBJq.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $3203d6a39c36d77b$export$19164982d36535d8 = 'tld_test';
const $3203d6a39c36d77b$export$de6821eed3d5f32d = (0, $5iWql.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($M2DFp))).set($3203d6a39c36d77b$export$eb80e1beaa8dacf8, $3203d6a39c36d77b$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($M2DFp))).get($3203d6a39c36d77b$export$eb80e1beaa8dacf8) === $3203d6a39c36d77b$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($M2DFp))).remove($3203d6a39c36d77b$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});



parcelRegister("kPI67", function(module, exports) {

$parcel$export(module.exports, "buildContext", () => $f2aac6f7cb0eb511$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "prepareEventProperties", () => $f2aac6f7cb0eb511$export$44d22e5fb02cc68e);

var $5zQU9 = parcelRequire("5zQU9");

var $kpOtk = parcelRequire("kpOtk");
function $f2aac6f7cb0eb511$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f2aac6f7cb0eb511$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f2aac6f7cb0eb511$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f2aac6f7cb0eb511$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $f2aac6f7cb0eb511$export$3a7fe28f9bf4f3d9 = (context)=>{
    return $f2aac6f7cb0eb511$var$_objectSpread($f2aac6f7cb0eb511$var$_objectSpread({}, context.context), {}, {
        userAgent: navigator.userAgent
    });
};
const $f2aac6f7cb0eb511$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $f2aac6f7cb0eb511$export$2250ccecd1e040fd(properties);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kpOtk)))(propertiesWithoutUndefined);
};
const $f2aac6f7cb0eb511$export$2250ccecd1e040fd = (obj)=>{
    if (obj === null || typeof obj !== 'object') return obj;
    const clone = {};
    Object.keys(obj).forEach((key)=>{
        const value = $f2aac6f7cb0eb511$var$getValueOfObject(obj, key);
        if (value !== undefined) {
            if (Array.isArray(value)) clone[key] = value.map((i)=>$f2aac6f7cb0eb511$export$2250ccecd1e040fd(i));
            else if (typeof value === 'object' && value !== null) clone[key] = $f2aac6f7cb0eb511$export$2250ccecd1e040fd(value);
            else clone[key] = value;
        }
    });
    return clone;
};
// Using ts-ignore everywhere urked me
const $f2aac6f7cb0eb511$var$getValueOfObject = (obj, key)=>{
    // @ts-ignore This is an object
    return obj[key];
};

});


parcelRegister("b88ir", function(module, exports) {

$parcel$export(module.exports, "default", () => $81a6e08f94d5a44c$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $hRleJ = parcelRequire("hRleJ");

var $8TuVU = parcelRequire("8TuVU");
class $81a6e08f94d5a44c$export$2e2bcd8739ae039 {
    constructor(){
        (0, $5zQU9.default)(this, "handleOriginParameters", (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $hRleJ.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture and remove params from URL
            const capturedURLParams = (0, $8TuVU.default)(isCaptureParam, historyReplaceFn);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            return extractedOriginID;
        });
        this._originStore = {};
    }
}

});
parcelRegister("8TuVU", function(module, exports) {

$parcel$export(module.exports, "defaultHistoryReplaceFn", () => $679b746c124ff0b9$export$600dd5bf1b049f11);
$parcel$export(module.exports, "default", () => $679b746c124ff0b9$export$2e2bcd8739ae039);

var $4ea7H = parcelRequire("4ea7H");

var $eaJEm = parcelRequire("eaJEm");
const $679b746c124ff0b9$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);
const $679b746c124ff0b9$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $679b746c124ff0b9$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $4ea7H.parseUrl)(removedFragmentURL);
    const captureParams = (0, $eaJEm.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $eaJEm.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $4ea7H.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var $679b746c124ff0b9$export$2e2bcd8739ae039 = $679b746c124ff0b9$var$urlParamExtractor;

});
parcelRegister("4ea7H", function(module, exports) {

$parcel$export(module.exports, "extract", () => $3140527761568622$export$f9380c9a627682d3, (v) => $3140527761568622$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $3140527761568622$export$98e6a39c04603d36, (v) => $3140527761568622$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $3140527761568622$export$fac44ee5b035f737, (v) => $3140527761568622$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $3140527761568622$export$7a5253c0f62e0150, (v) => $3140527761568622$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $3140527761568622$export$a8c1621ea79325d3, (v) => $3140527761568622$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $3140527761568622$export$357523c63a2253b9, (v) => $3140527761568622$export$357523c63a2253b9 = v);
$parcel$export(module.exports, "exclude", () => $3140527761568622$export$44c361b8ec72ef7f, (v) => $3140527761568622$export$44c361b8ec72ef7f = v);
var $3140527761568622$export$f9380c9a627682d3;
var $3140527761568622$export$98e6a39c04603d36;
var $3140527761568622$export$fac44ee5b035f737;
var $3140527761568622$export$7a5253c0f62e0150;
var $3140527761568622$export$a8c1621ea79325d3;
var $3140527761568622$export$357523c63a2253b9;
var $3140527761568622$export$44c361b8ec72ef7f;
'use strict';

var $hXDaG = parcelRequire("hXDaG");

var $bJEvY = parcelRequire("bJEvY");

var $9CHQr = parcelRequire("9CHQr");

var $aARfw = parcelRequire("aARfw");
const $3140527761568622$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $3140527761568622$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $3140527761568622$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3140527761568622$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $3140527761568622$var$encode(key, options),
                            '[',
                            $3140527761568622$var$encode(index, options),
                            ']=',
                            $3140527761568622$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3140527761568622$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $3140527761568622$var$encode(key, options),
                            '[]=',
                            $3140527761568622$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3140527761568622$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $3140527761568622$var$encode(key, options),
                            ':list=',
                            $3140527761568622$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $3140527761568622$var$encode(key, options),
                                keyValueSep,
                                $3140527761568622$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $3140527761568622$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $3140527761568622$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $3140527761568622$var$encode(key, options),
                            '=',
                            $3140527761568622$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $3140527761568622$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $3140527761568622$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $3140527761568622$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$3140527761568622$var$decode(item, options)) : value === null ? value : $3140527761568622$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $3140527761568622$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$3140527761568622$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $3140527761568622$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $3140527761568622$var$encode(value, options) {
    if (options.encode) return options.strict ? $hXDaG(value) : encodeURIComponent(value);
    return value;
}
function $3140527761568622$var$decode(value, options) {
    if (options.decode) return $bJEvY(value);
    return value;
}
function $3140527761568622$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $3140527761568622$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $3140527761568622$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $3140527761568622$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $3140527761568622$var$extract(input) {
    input = $3140527761568622$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $3140527761568622$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $3140527761568622$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $3140527761568622$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $3140527761568622$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $9CHQr(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $3140527761568622$var$decode(value, options);
        formatter($3140527761568622$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $3140527761568622$var$parseValue(value[k], options);
        else ret[key] = $3140527761568622$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $3140527761568622$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$3140527761568622$export$f9380c9a627682d3 = $3140527761568622$var$extract;
$3140527761568622$export$98e6a39c04603d36 = $3140527761568622$var$parse;
$3140527761568622$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $3140527761568622$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $3140527761568622$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $3140527761568622$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $3140527761568622$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $3140527761568622$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $3140527761568622$var$encode(key, options) + '=' + $3140527761568622$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$3140527761568622$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $9CHQr(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $3140527761568622$var$parse($3140527761568622$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $3140527761568622$var$decode(hash, options)
    } : {});
};
$3140527761568622$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$3140527761568622$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $3140527761568622$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $3140527761568622$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $3140527761568622$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $3140527761568622$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $3140527761568622$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$3140527761568622$var$encodeFragmentIdentifier] ? $3140527761568622$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$3140527761568622$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$3140527761568622$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $3140527761568622$export$7a5253c0f62e0150(input, options);
    return $3140527761568622$export$a8c1621ea79325d3({
        url: url,
        query: $aARfw(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$3140527761568622$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $3140527761568622$export$357523c63a2253b9(input, exclusionFilter, options);
};

});



parcelRegister("hrLBB", function(module, exports) {

$parcel$export(module.exports, "selectHost", () => $cb39e2b9b59d0a38$export$18c0b81944902eae);

var $hRleJ = parcelRequire("hRleJ");
const $cb39e2b9b59d0a38$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $cb39e2b9b59d0a38$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $cb39e2b9b59d0a38$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $cb39e2b9b59d0a38$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $cb39e2b9b59d0a38$var$FEDRAMP_SANDBOX_HOST = 'as.atlassian-fex.com/api/v1';
const $cb39e2b9b59d0a38$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $cb39e2b9b59d0a38$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $cb39e2b9b59d0a38$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $cb39e2b9b59d0a38$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $cb39e2b9b59d0a38$var$STARGATE_FEDRAMP_SANDBOX_HOST = 'api-private.atlassian-fex.com/gasv3/api/v1';
const $cb39e2b9b59d0a38$var$STARGATE_PROXY_PATH = '/gateway/api/gasv3/api/v1';
const $cb39e2b9b59d0a38$var$handleFedRampStagingSandboxDirect = (envOverride)=>{
    if (envOverride && envOverride === (0, $hRleJ.envOverrides).FEDRAMP_MODERATE_SANDBOX) return $cb39e2b9b59d0a38$var$FEDRAMP_SANDBOX_HOST;
    return $cb39e2b9b59d0a38$var$FEDRAMP_STAGING_HOST;
};
const $cb39e2b9b59d0a38$var$handleFedRampStagingSandboxStargate = (envOverride)=>{
    if (envOverride && envOverride === (0, $hRleJ.envOverrides).FEDRAMP_MODERATE_SANDBOX) return $cb39e2b9b59d0a38$var$STARGATE_FEDRAMP_SANDBOX_HOST;
    return $cb39e2b9b59d0a38$var$STARGATE_FEDRAMP_STAGING_HOST;
};
const $cb39e2b9b59d0a38$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $hRleJ.envType).LOCAL || env === (0, $hRleJ.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $hRleJ.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $hRleJ.envType).PROD ? $cb39e2b9b59d0a38$var$FEDRAMP_PROD_HOST : $cb39e2b9b59d0a38$var$handleFedRampStagingSandboxDirect(envOverride);
    if (useLegacyUrl) return env === (0, $hRleJ.envType).PROD ? $cb39e2b9b59d0a38$var$STARGATE_FEDRAMP_PROD_HOST : $cb39e2b9b59d0a38$var$handleFedRampStagingSandboxStargate(envOverride);
    /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */ return window.location.host + $cb39e2b9b59d0a38$var$STARGATE_PROXY_PATH;
};
const $cb39e2b9b59d0a38$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $hRleJ.envType).PROD ? $cb39e2b9b59d0a38$var$PROD_HOST : $cb39e2b9b59d0a38$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $hRleJ.envType).PROD ? $cb39e2b9b59d0a38$var$STARGATE_PROD_HOST : $cb39e2b9b59d0a38$var$STARGATE_STAGING_HOST;
    /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */ return window.location.host + $cb39e2b9b59d0a38$var$STARGATE_PROXY_PATH;
};
function $cb39e2b9b59d0a38$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, envOverride: envOverride }) {
    if (perimeter === (0, $hRleJ.perimeterType).FEDRAMP_MODERATE) return $cb39e2b9b59d0a38$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $cb39e2b9b59d0a38$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}

});

parcelRegister("1t0DP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1118ff41266ccfb6$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $empVP = parcelRequire("empVP");
const $1118ff41266ccfb6$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $1118ff41266ccfb6$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $1118ff41266ccfb6$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $1118ff41266ccfb6$export$285f6bddd927a06d = 1800000; // 30 minutes
const $1118ff41266ccfb6$export$a92e915d70316eb2 = 5000; // 5 seconds
const $1118ff41266ccfb6$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $1118ff41266ccfb6$export$5702a91a6f42969f = ()=>{};
class $1118ff41266ccfb6$export$2e2bcd8739ae039 {
    constructor(options = {}){
        (0, $5zQU9.default)(this, "_generateNewSessionId", ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($1118ff41266ccfb6$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        });
        (0, $5zQU9.default)(this, "_updateSessionExpiry", ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($1118ff41266ccfb6$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, $5zQU9.default)(this, "_debouncedUpdateSessionExpiry", (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) return _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        });
        this._sessionExpiryTime = options.sessionExpiryTime || $1118ff41266ccfb6$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $1118ff41266ccfb6$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $1118ff41266ccfb6$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $1118ff41266ccfb6$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $empVP.default)();
    }
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($1118ff41266ccfb6$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($1118ff41266ccfb6$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$1118ff41266ccfb6$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
}

});

parcelRegister("cxp5h", function(module, exports) {

$parcel$export(module.exports, "default", () => $920c064577f26532$export$2e2bcd8739ae039);

var $6PZgF = parcelRequire("6PZgF");

var $asdds = parcelRequire("asdds");
class $920c064577f26532$export$2e2bcd8739ae039 extends (0, $asdds.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $6PZgF.default);
        } catch (err) {
            storageToUse = (0, $6PZgF.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("kzV7m", function(module, exports) {

$parcel$export(module.exports, "default", () => $efb361e857efe6b0$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $dFBS3 = parcelRequire("dFBS3");

var $cxp5h = parcelRequire("cxp5h");
const $efb361e857efe6b0$var$STORAGE_KEY = 'tab.id';
class $efb361e857efe6b0$export$2e2bcd8739ae039 {
    constructor(){
        (0, $5zQU9.default)(this, "_generateNewTabId", ()=>{
            const newTabId = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
            this._safeSessionStorage.setItem($efb361e857efe6b0$var$STORAGE_KEY, newTabId);
            return newTabId;
        });
        this._safeSessionStorage = new (0, $cxp5h.default)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($efb361e857efe6b0$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
}

});

parcelRegister("6L92I", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ebe25976ea107e0$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $4ea7H = parcelRequire("4ea7H");

var $dFBS3 = parcelRequire("dFBS3");

var $hRleJ = parcelRequire("hRleJ");

var $eaJEm = parcelRequire("eaJEm");

var $cxp5h = parcelRequire("cxp5h");

var $8TuVU = parcelRequire("8TuVU");
function $4ebe25976ea107e0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4ebe25976ea107e0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4ebe25976ea107e0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4ebe25976ea107e0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $4ebe25976ea107e0$var$STORAGE_KEY = 'taskSessions';
const $4ebe25976ea107e0$var$INIT_KEY = 'taskSessionsInit';
const $4ebe25976ea107e0$var$AWC_PARAM_PREFIX = 'awc.';
const $4ebe25976ea107e0$var$TASK_SESSION_RELOAD_TIME = 3000;
class $4ebe25976ea107e0$export$2e2bcd8739ae039 {
    constructor(){
        (0, $5zQU9.default)(this, "_taskSessionsNotRecentlyInitialised", (currentTimestamp)=>this._safeSessionStorage.getItem($4ebe25976ea107e0$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($4ebe25976ea107e0$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($4ebe25976ea107e0$var$INIT_KEY) || '0', 10) < currentTimestamp - $4ebe25976ea107e0$var$TASK_SESSION_RELOAD_TIME);
        (0, $5zQU9.default)(this, "_removeTaskSessionPrefix", (_, taskSessionName)=>taskSessionName.split($4ebe25976ea107e0$var$AWC_PARAM_PREFIX)[1]);
        (0, $5zQU9.default)(this, "_isTaskSessionQueryParam", (_, taskSessionName)=>taskSessionName.startsWith($4ebe25976ea107e0$var$AWC_PARAM_PREFIX));
        (0, $5zQU9.default)(this, "getAllTaskSessions", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($4ebe25976ea107e0$var$STORAGE_KEY) || '');
            } catch (e) {
                return {};
            }
        });
        (0, $5zQU9.default)(this, "_writeToSessionStorage", (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($4ebe25976ea107e0$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch (e) {}
        });
        (0, $5zQU9.default)(this, "_appendTaskSessions", (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        });
        (0, $5zQU9.default)(this, "_safelyRemoveKey", (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        });
        (0, $5zQU9.default)(this, "createTaskSession", (taskSessionName)=>{
            const taskSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        });
        (0, $5zQU9.default)(this, "createTaskSessionWithProvidedId", (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        });
        (0, $5zQU9.default)(this, "completeTaskSession", (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        });
        (0, $5zQU9.default)(this, "formatTaskSessionQueryString", ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $4ea7H.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $eaJEm.pick)(currentState, includedTaskSessions) : (0, $eaJEm.omit)(currentState, Object.values((0, $hRleJ.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = $4ebe25976ea107e0$var$_objectSpread($4ebe25976ea107e0$var$_objectSpread({}, (0, $eaJEm.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$4ebe25976ea107e0$var$AWC_PARAM_PREFIX + taskSessionName)), query);
            return `${url}?${(0, $4ea7H.stringify)(queryWithTaskSessions)}`;
        });
        (0, $5zQU9.default)(this, "stripQueryParameters", ()=>{
            const extractedTaskSessions = (0, $eaJEm.mapKeys)((0, $8TuVU.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        });
        const _currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $cxp5h.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($4ebe25976ea107e0$var$INIT_KEY, _currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}

});

parcelRegister("8Pilt", function(module, exports) {

$parcel$export(module.exports, "default", () => $66d1512172415ca7$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $M2DFp = parcelRequire("M2DFp");

var $eSBJq = parcelRequire("eSBJq");
const $66d1512172415ca7$var$MAX_CACHE_SIZE = 100;
const $66d1512172415ca7$var$COOKIE_NAME = (0, $eSBJq.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $66d1512172415ca7$var$DEBUG_TAG = 'synthetic';
const $66d1512172415ca7$var$getDebugCookie = ()=>{
    try {
        return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($M2DFp))).get($66d1512172415ca7$var$COOKIE_NAME) || 'false');
    } catch (error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($M2DFp))).remove($66d1512172415ca7$var$COOKIE_NAME);
    }
    return false;
};
class $66d1512172415ca7$var$TestingCache {
    constructor(){
        (0, $5zQU9.default)(this, "_bind", ()=>{
            if (typeof window === 'undefined' || window.testAnalytics) return;
            window.testAnalytics = {
                eventCache: [],
                events: ()=>window.testAnalytics.eventCache,
                clear: ()=>{
                    window.testAnalytics.eventCache = [];
                    try {
                        localStorage.removeItem('awc.ui.viewed.last.sent');
                        localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                        localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                        localStorage.removeItem('awc-local.ui.viewed.last.sent');
                    } catch (_error) {
                    // Ignore errors from localStorage.
                    }
                }
            };
        });
        (0, $5zQU9.default)(this, "_cache", (event)=>{
            if (typeof window === 'undefined') return;
            if (window.testAnalytics.eventCache.length >= $66d1512172415ca7$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
            window.testAnalytics.eventCache.push(event);
        });
        (0, $5zQU9.default)(this, "_shouldCacheEvent", ()=>this._isDebugCookieEnabled);
        (0, $5zQU9.default)(this, "saveEvent", (event)=>{
            if (event && this._shouldCacheEvent()) {
                if (!window.testAnalytics) this._bind();
                if (event.tags instanceof Array) event.tags.push($66d1512172415ca7$var$DEBUG_TAG);
                else event.tags = [
                    $66d1512172415ca7$var$DEBUG_TAG
                ];
                this._cache(event);
            }
        });
        this._isDebugCookieEnabled = $66d1512172415ca7$var$getDebugCookie();
        if (this._isDebugCookieEnabled) this._bind();
    }
}
var $66d1512172415ca7$export$2e2bcd8739ae039 = $66d1512172415ca7$var$TestingCache;

});

parcelRegister("fBPLq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5d276f5dc25bc5d$export$2e2bcd8739ae039);

var $bwPfh = parcelRequire("bwPfh");

var $5zQU9 = parcelRequire("5zQU9");

var $hRleJ = parcelRequire("hRleJ");

var $empVP = parcelRequire("empVP");
const $b5d276f5dc25bc5d$var$_excluded = [
    "embeddedProduct"
];
function $b5d276f5dc25bc5d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b5d276f5dc25bc5d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b5d276f5dc25bc5d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b5d276f5dc25bc5d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $b5d276f5dc25bc5d$var$DEFAULT_DELAY = 2000; // 2 seconds
const $b5d276f5dc25bc5d$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $b5d276f5dc25bc5d$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
class $b5d276f5dc25bc5d$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        (0, $5zQU9.default)(this, "start", ()=>{
            this._startInterval();
            this._bindEventListeners();
        });
        (0, $5zQU9.default)(this, "stop", ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        });
        (0, $5zQU9.default)(this, "resetTimers", ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        });
        (0, $5zQU9.default)(this, "_bindEventListeners", ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        });
        (0, $5zQU9.default)(this, "_unbindEventListeners", ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        });
        (0, $5zQU9.default)(this, "_startInterval", ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleInterval, this._delay);
        });
        (0, $5zQU9.default)(this, "_stopInterval", ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        });
        (0, $5zQU9.default)(this, "_getProductKey", (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        });
        (0, $5zQU9.default)(this, "_getLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        });
        (0, $5zQU9.default)(this, "_parseLocalStorageData", ()=>{
            const data = this._safeLocalStorage.getItem(this._storageKey);
            try {
                return JSON.parse(data || '');
            } catch (error) {
                this._safeLocalStorage.removeItem(this._storageKey);
                return null;
            }
        });
        (0, $5zQU9.default)(this, "_setLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        });
        (0, $5zQU9.default)(this, "_shouldSendEvent", (productKey, tenantIdType, tenantId, userId)=>{
            if (!document.hasFocus()) return false;
            if (tenantIdType !== (0, $hRleJ.tenantType).NONE && !tenantId || !userId) return false;
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            return sinceLastSent > this._throttle;
        });
        (0, $5zQU9.default)(this, "_handleInterval", ()=>{
            const _this$_getContext = this._getContext(), { embeddedProduct: embeddedProduct } = _this$_getContext, context = (0, $bwPfh.default)(_this$_getContext, $b5d276f5dc25bc5d$var$_excluded);
            this._sendEvent(this._product, context);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        });
        (0, $5zQU9.default)(this, "_sendEvent", (product, context, isEmbeddedProduct = false)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            if (this._shouldSendEvent(productKey, tenantIdType, tenantId, userId)) {
                this._setLastSentTimestamp(productKey, tenantId, userId);
                const event = this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes);
                this._onEvent(event);
            }
        });
        (0, $5zQU9.default)(this, "_createEvent", (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes)=>{
            const event = {
                product: product,
                source: 'ui',
                action: 'viewed',
                actionSubject: 'ui',
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = $b5d276f5dc25bc5d$var$_objectSpread($b5d276f5dc25bc5d$var$_objectSpread({}, event.attributes), {}, {
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                });
            }
            if (lastScreenEvent) event.attributes = $b5d276f5dc25bc5d$var$_objectSpread($b5d276f5dc25bc5d$var$_objectSpread({}, event.attributes), {}, {
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            });
            return event;
        });
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $b5d276f5dc25bc5d$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $b5d276f5dc25bc5d$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $b5d276f5dc25bc5d$var$DEFAULT_STORAGE_KEY;
        this._safeLocalStorage = new (0, $empVP.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});

parcelRegister("1ZcVH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1725847bb5325657$export$2e2bcd8739ae039);
function $1725847bb5325657$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("l4WDe", function(module, exports) {

$parcel$export(module.exports, "XIDPromise", () => $f58773bc79bce746$export$fbe53bbbe682bcdd);

var $590Mu = parcelRequire("590Mu");
const $f58773bc79bce746$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $590Mu.createTimeoutXid)()), (0, $590Mu.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $590Mu.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("590Mu", function(module, exports) {

$parcel$export(module.exports, "XID_TIMEOUT", () => $3bee6625f6c64a52$export$545bcbd53afabfa3);
$parcel$export(module.exports, "createTimeoutXid", () => $3bee6625f6c64a52$export$af4087e36d63846);
$parcel$export(module.exports, "createUnknownXid", () => $3bee6625f6c64a52$export$fa341d0c750d705b);

var $akomA = parcelRequire("akomA");
const $3bee6625f6c64a52$export$545bcbd53afabfa3 = 5000;
const $3bee6625f6c64a52$export$af4087e36d63846 = ()=>[
        {
            type: (0, $akomA.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $akomA.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
const $3bee6625f6c64a52$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $akomA.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $akomA.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];

});
parcelRegister("akomA", function(module, exports) {

$parcel$export(module.exports, "XIDItemType", () => $784eaba8c7bffab9$export$92ca0438bcb0d396);
let $784eaba8c7bffab9$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
let $784eaba8c7bffab9$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("30Bax", function(module, exports) {

$parcel$export(module.exports, "canCompress", () => $60e1877f19bb1752$export$ec3662f84d9f778c);
$parcel$export(module.exports, "buildCompressionFunction", () => $60e1877f19bb1752$export$20de0576abb0bcc5);
const $60e1877f19bb1752$export$ec3662f84d9f778c = (event)=>event.actionSubject === 'feature' && event.action === 'exposed' && event.eventType === 'operational' && event.attributes && event.tags && event.tags.includes('measurement') && !event.tags.includes('hasCustomAttributes');
const $60e1877f19bb1752$export$ca25d5d7792a4f37 = (events, batchSize = 50)=>{
    if (!events || events.length <= 0) return [];
    if (batchSize <= 0) throw new Error('Batch size must be greater than 0');
    // Extract evaluations and reduce into a single array
    const flagEvaluations = events.map((currentEvent)=>{
        const { flagKey: flagKey, value: value, reason: reason, ruleId: ruleId, errorKind: errorKind } = currentEvent.attributes;
        return {
            key: flagKey,
            value: value,
            ...reason && {
                reason: reason
            },
            ...ruleId && {
                ruleId: ruleId
            },
            ...errorKind && {
                errorKind: errorKind
            }
        };
    });
    // Batch evaluations into specified batchSize
    return $60e1877f19bb1752$var$createBatches(flagEvaluations, batchSize);
};
const $60e1877f19bb1752$var$createBatches = (array, batchSize)=>{
    let compressedEvaluations = [];
    for(let i = 0; i < array.length; i += batchSize){
        let evaluationBatch = array.slice(i, i + batchSize);
        compressedEvaluations.push({
            actionSubject: 'features',
            action: 'exposed',
            eventType: 'operational',
            attributes: {
                evaluations: evaluationBatch
            },
            tags: [
                'measurement'
            ],
            source: '@atlassian/exposure-events-compressor'
        });
    }
    return compressedEvaluations;
};
const $60e1877f19bb1752$export$20de0576abb0bcc5 = (batchSize)=>(events)=>$60e1877f19bb1752$export$ca25d5d7792a4f37(events, batchSize);

});

parcelRegister("6TYON", function(module, exports) {

$parcel$export(module.exports, "default", () => $50670e5d359964d4$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");

var $5Urw3 = parcelRequire("5Urw3");

var $56rs2 = parcelRequire("56rs2");

var $50oJA = parcelRequire("50oJA");
// This extra bit of typing is required because typing on analytics-next
// doesn't seem to be working properly and we haven't been able to
// come up with a solution for it yet. Also analytics-next is in
// maintenance mode so will need to be replaced anyway.
const $50670e5d359964d4$var$EngagementProviderWithEvents = (0, $2jDha.default)()((0, $50oJA.EngagementProvider));
const $50670e5d359964d4$var$EngagementProviderWithDefaultStore = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50670e5d359964d4$var$EngagementProviderWithEvents, (0, $kU09D.default)({}, props, {
        store: (0, $56rs2.default)(props.config)
    }));
};
var $50670e5d359964d4$export$2e2bcd8739ae039 = (0, $5Urw3.default)($50670e5d359964d4$var$EngagementProviderWithDefaultStore);

});
parcelRegister("5Urw3", function(module, exports) {

$parcel$export(module.exports, "default", () => $44d786d6f117c7e9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $44d786d6f117c7e9$export$2e2bcd8739ae039(Component) {
    const PreventNestedInstancesContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(false);
    return function PreventNestedInstances(props) {
        return(/*#__PURE__*/ // TODO: Replace usage of PreventNestedInstancesContext.Consumer with useContext(PreventNestedInstancesContext)
        (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(PreventNestedInstancesContext.Consumer, null, (shouldPreventInstantiation)=>shouldPreventInstantiation ? props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(PreventNestedInstancesContext.Provider, {
                value: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props))));
    };
}

});

parcelRegister("56rs2", function(module, exports) {

$parcel$export(module.exports, "store", () => $3b72ce87dfd6a7ec$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "default", () => $3b72ce87dfd6a7ec$export$2e2bcd8739ae039);

var $hTLlD = parcelRequire("hTLlD");

var $huRi7 = parcelRequire("huRi7");

var $9bUAF = parcelRequire("9bUAF");

var $3DGOA = parcelRequire("3DGOA");

var $jtW6P = parcelRequire("jtW6P");

var $8zQg9 = parcelRequire("8zQg9");
const $3b72ce87dfd6a7ec$export$36d128238e6b60f5 = {
    messageMapping: new Map(),
    current: null,
    initialized: false,
    initializing: false,
    config: {
        cloudId: '',
        aaid: '',
        locale: '',
        product: '',
        stargateUrl: '',
        orgId: '',
        workspaceId: ''
    }
};
let $3b72ce87dfd6a7ec$var$processMessagesCancellationToken = (0, $9bUAF.createCancellationToken)();
function $3b72ce87dfd6a7ec$export$7a10f46f72407bc5(messageMapping, component) {
    const newMapping = new Map();
    messageMapping.forEach((value, key)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(value.component, component)) newMapping.set(key, value);
    });
    return newMapping;
}
const $3b72ce87dfd6a7ec$export$6f57813fe9f31bf9 = (0, $huRi7.createStore)((state = $3b72ce87dfd6a7ec$export$36d128238e6b60f5, action)=>{
    switch(action.type){
        case 0, $jtW6P.SET_MESSAGE_MAPPING:
            return {
                ...state,
                initialized: true,
                initializing: false,
                messageMapping: action.messageMapping
            };
        case 0, $jtW6P.SET_INITIALIZING:
            return {
                ...state,
                config: action.config,
                initializing: true
            };
        case 0, $jtW6P.SET_CURRENT:
            {
                const { eventMapping: eventMapping } = action;
                const { message: message, component: component } = eventMapping;
                const messageMapping = $3b72ce87dfd6a7ec$export$7a10f46f72407bc5(state.messageMapping, component);
                return {
                    ...state,
                    current: {
                        messageId: message.messageId,
                        variationId: message.variationId,
                        ...component
                    },
                    messageMapping: messageMapping
                };
            }
        case 0, $jtW6P.CLEAR_CURRENT:
            return {
                ...state,
                current: null
            };
        case 0, $jtW6P.RESET_STORE:
            return $3b72ce87dfd6a7ec$export$36d128238e6b60f5;
        default:
            return state;
    }
});
var $3b72ce87dfd6a7ec$export$2e2bcd8739ae039 = (config)=>{
    const state = $3b72ce87dfd6a7ec$export$6f57813fe9f31bf9.getState();
    if (state.initializing || state.initialized) {
        if (state.config.cloudId === config.cloudId) return $3b72ce87dfd6a7ec$export$6f57813fe9f31bf9;
        // CloudId has changed, cancel any in process processMessages request
        $3b72ce87dfd6a7ec$var$processMessagesCancellationToken.isCancelled = true;
        $3b72ce87dfd6a7ec$var$processMessagesCancellationToken = (0, $9bUAF.createCancellationToken)();
        $3b72ce87dfd6a7ec$export$6f57813fe9f31bf9.dispatch((0, $jtW6P.resetStore)());
    }
    const newConfig = {
        ...config
    };
    newConfig.locale = newConfig.locale.replace('_', '-');
    $3b72ce87dfd6a7ec$export$6f57813fe9f31bf9.dispatch((0, $jtW6P.initialize)(newConfig));
    if ((0, $3DGOA.isMessagingEnabled)()) (0, $8zQg9.processMessages)($3b72ce87dfd6a7ec$export$6f57813fe9f31bf9, newConfig, $3b72ce87dfd6a7ec$var$processMessagesCancellationToken);
    return $3b72ce87dfd6a7ec$export$6f57813fe9f31bf9;
};

});
parcelRegister("9bUAF", function(module, exports) {

$parcel$export(module.exports, "createCancellationToken", () => $6b1109d4dd58e2dc$export$eac027797b968991);
function $6b1109d4dd58e2dc$export$eac027797b968991(isCancelled = false) {
    return {
        isCancelled: isCancelled
    };
}

});

parcelRegister("3DGOA", function(module, exports) {

$parcel$export(module.exports, "isMessagingEnabled", () => $2a6639c7128ad23a$export$a77934ac158768dd);

var $dfBCt = parcelRequire("dfBCt");
function $2a6639c7128ad23a$export$a77934ac158768dd() {
    return !(0, $dfBCt.isFedRamp)();
}

});

parcelRegister("jtW6P", function(module, exports) {

$parcel$export(module.exports, "SET_MESSAGE_MAPPING", () => $e2edccfead6ebc34$export$d05fe3e897340c89);
$parcel$export(module.exports, "SET_INITIALIZING", () => $e2edccfead6ebc34$export$eacd3ec165715d8);
$parcel$export(module.exports, "RESET_STORE", () => $e2edccfead6ebc34$export$874c5149d7f0e3b8);
$parcel$export(module.exports, "CLEAR_CURRENT", () => $e2edccfead6ebc34$export$cb5041d68cb18859);
$parcel$export(module.exports, "SET_CURRENT", () => $e2edccfead6ebc34$export$a9319af002a4c677);
$parcel$export(module.exports, "resetStore", () => $e2edccfead6ebc34$export$a20a1205b2a2b7e4);
$parcel$export(module.exports, "initialize", () => $e2edccfead6ebc34$export$2a47f398eeff8b01);
$parcel$export(module.exports, "setMessageMapping", () => $e2edccfead6ebc34$export$375dd0a76fecd4c7);
$parcel$export(module.exports, "setCurrent", () => $e2edccfead6ebc34$export$5f80f094fd31fffd);
$parcel$export(module.exports, "clearCurrent", () => $e2edccfead6ebc34$export$96105f873ade39d7);
const $e2edccfead6ebc34$export$d05fe3e897340c89 = 'SET_MESSAGE_MAPPING';
const $e2edccfead6ebc34$export$eacd3ec165715d8 = 'SET_INITIALIZING';
const $e2edccfead6ebc34$export$874c5149d7f0e3b8 = 'RESET_STORE';
const $e2edccfead6ebc34$export$cb5041d68cb18859 = 'CLEAR_CURRENT';
const $e2edccfead6ebc34$export$a9319af002a4c677 = 'SET_CURRENT';
const $e2edccfead6ebc34$export$a20a1205b2a2b7e4 = ()=>({
        type: $e2edccfead6ebc34$export$874c5149d7f0e3b8
    });
const $e2edccfead6ebc34$export$2a47f398eeff8b01 = (config)=>({
        type: $e2edccfead6ebc34$export$eacd3ec165715d8,
        config: config
    });
const $e2edccfead6ebc34$export$375dd0a76fecd4c7 = (messageMapping)=>({
        type: $e2edccfead6ebc34$export$d05fe3e897340c89,
        messageMapping: messageMapping
    });
function $e2edccfead6ebc34$export$5f80f094fd31fffd(eventMapping) {
    return {
        type: $e2edccfead6ebc34$export$a9319af002a4c677,
        eventMapping: eventMapping
    };
}
function $e2edccfead6ebc34$export$96105f873ade39d7() {
    return {
        type: $e2edccfead6ebc34$export$cb5041d68cb18859
    };
}

});

parcelRegister("8zQg9", function(module, exports) {

$parcel$export(module.exports, "processMessages", () => $63ea21491db01167$export$d2e92820f98a2592);

var $eMQs7 = parcelRequire("eMQs7");

var $jtW6P = parcelRequire("jtW6P");

var $56rs2 = parcelRequire("56rs2");
const $63ea21491db01167$export$a9d4ce3abb5d2365 = (messages)=>{
    const mapping = new Map();
    messages.forEach((message)=>{
        const components = message.components;
        components.forEach((component, index)=>{
            component.triggers.forEach((trigger)=>{
                mapping.set(trigger, {
                    message: message,
                    component: {
                        componentId: index,
                        isLast: index === components.length - 1,
                        ...component
                    }
                });
            });
        });
    });
    return mapping;
};
async function $63ea21491db01167$export$d2e92820f98a2592(engagementStore, config, cancellationToken) {
    if (cancellationToken.isCancelled) return;
    const state = (0, $56rs2.store).getState();
    const { cloudId: cloudId, stargateUrl: stargateUrl, product: product, locale: locale } = config;
    let messages, interval;
    try {
        const results = await (0, $eMQs7.getMessages)(cloudId, stargateUrl, product, locale);
        if (cancellationToken.isCancelled) return;
        messages = results.messages;
        interval = results.interval;
    } catch (e) {
        // TODO: Configure metal to monitor errors here
        // Give up, don't try fetching again
        return;
    }
    // Don't overwrite the messageMapping if there's an active message
    if (state.current === null) {
        const messageMapping = $63ea21491db01167$export$a9d4ce3abb5d2365(messages);
        engagementStore.dispatch((0, $jtW6P.setMessageMapping)(messageMapping));
    }
    if (interval !== 0) setTimeout(()=>{
        $63ea21491db01167$export$d2e92820f98a2592(engagementStore, config, cancellationToken);
    }, interval * 1000);
// TODO: Configure metal to monitor success response here
}

});
parcelRegister("eMQs7", function(module, exports) {

$parcel$export(module.exports, "getMessages", () => $ac3e3c5c710a4176$export$8c20ab16ac9cf14f);
$parcel$export(module.exports, "startMessage", () => $ac3e3c5c710a4176$export$7a77c9a7b182680b);
$parcel$export(module.exports, "stopMessage", () => $ac3e3c5c710a4176$export$159ff839f1f095d2);
$parcel$export(module.exports, "sendUserResponse", () => $ac3e3c5c710a4176$export$e1fd1449cf83c1f5);
$parcel$export(module.exports, "markAsSeenAndFatigued", () => $ac3e3c5c710a4176$export$3683393f780c6905);
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths -- Preventing pre-commit error from being thrown when importing NO_CONTENT from controllers folder*/ 
var $asbhz = parcelRequire("asbhz");

var $9RC8H = parcelRequire("9RC8H");


var $fPMXA = parcelRequire("fPMXA");
const $ac3e3c5c710a4176$export$f4d1b02d312560f5 = '2';
const $ac3e3c5c710a4176$var$inProductMessagesUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse('/engage-targeting/api/v2/user/{cloudId}/in-product-messages{?product,schema,locale}');
async function $ac3e3c5c710a4176$export$8c20ab16ac9cf14f(cloudId, stargateUrl, product, locale) {
    return (0, $fPMXA.stargateFetchRetryOn5xx)(`${stargateUrl}${$ac3e3c5c710a4176$var$inProductMessagesUrlTemplate.expand({
        cloudId: cloudId,
        product: product,
        schema: $ac3e3c5c710a4176$export$f4d1b02d312560f5,
        locale: locale
    })}`).then((0, $fPMXA.errorIfNotOk)).then((r)=>r.json().then((messages)=>({
                messages: messages,
                interval: Number.parseFloat(r.headers.get('POLL-INTERVAL') || '0')
            })));
}
function $ac3e3c5c710a4176$var$handleStartStopMessageResponse(response) {
    return response.status === (0, $7a66036879e6348d$export$3288b14b6745c572);
}
const $ac3e3c5c710a4176$var$startMessageUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse('/engage-targeting/api/v2/user/messages/{messageId}/start');
const $ac3e3c5c710a4176$var$startMessageWithVariationIdUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse('/engage-targeting/api/v2/user/messages/{messageId}/start/{variationId}');
const $ac3e3c5c710a4176$var$stopMessageUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse('/engage-targeting/api/v2/user/messages/{messageId}/stop');
let $ac3e3c5c710a4176$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
//  Adding these types because we are not able to import them properly from @atlassiansox/analytics-web-client
// Initialize the choreographer plugin on module load
// const choreographerPlugin = new EngagekitChoreographerPlugin();
let $ac3e3c5c710a4176$var$choreographerPlugin;
async function $ac3e3c5c710a4176$export$7a77c9a7b182680b(startMessageConfig, options) {
    if (options !== null && options !== void 0 && options.enableChoreographer) return $ac3e3c5c710a4176$var$startMessageWithChoreographer(startMessageConfig, options);
    return $ac3e3c5c710a4176$var$startMessageWithCoordination(startMessageConfig);
}
async function $ac3e3c5c710a4176$export$159ff839f1f095d2(stopMessageConfig, options) {
    if (options !== null && options !== void 0 && options.enableChoreographer) return $ac3e3c5c710a4176$var$stopMessageWithChoreographer(stopMessageConfig, options);
    return $ac3e3c5c710a4176$var$stopMessageWithCoordination(stopMessageConfig);
}
async function $ac3e3c5c710a4176$var$startMessageWithChoreographer(startMessageConfig, options) {
    if (!$ac3e3c5c710a4176$var$choreographerPlugin) {
        var _options$envType;
        $ac3e3c5c710a4176$var$choreographerPlugin = new (0, $9RC8H.EngagekitChoreographerPlugin)((_options$envType = options.envType) !== null && _options$envType !== void 0 ? _options$envType : $ac3e3c5c710a4176$export$56ac8ebc9870b1b9.LOCAL);
    }
    return $ac3e3c5c710a4176$var$choreographerPlugin.startMessageWithPlugin(startMessageConfig.messageId, ()=>$ac3e3c5c710a4176$var$startMessageWithCoordination(startMessageConfig), options.additionalData);
}
async function $ac3e3c5c710a4176$var$stopMessageWithChoreographer(stopMessageConfig, options) {
    if (!$ac3e3c5c710a4176$var$choreographerPlugin) {
        var _options$envType2;
        $ac3e3c5c710a4176$var$choreographerPlugin = new (0, $9RC8H.EngagekitChoreographerPlugin)((_options$envType2 = options.envType) !== null && _options$envType2 !== void 0 ? _options$envType2 : $ac3e3c5c710a4176$export$56ac8ebc9870b1b9.LOCAL);
    }
    return $ac3e3c5c710a4176$var$choreographerPlugin.stopMessageWithPlugin(stopMessageConfig.messageId, ()=>$ac3e3c5c710a4176$var$stopMessageWithCoordination(stopMessageConfig), options.additionalData);
}
async function $ac3e3c5c710a4176$var$startMessageWithCoordination(startMessageConfig) {
    const requestBody = {
        cloudId: startMessageConfig.cloudId,
        orgId: startMessageConfig.orgId,
        workspaceId: startMessageConfig.workspaceId
    };
    return (0, $fPMXA.stargateFetchRetryOn5xx)(startMessageConfig.variationId ? `${startMessageConfig.stargateUrl}${$ac3e3c5c710a4176$var$startMessageWithVariationIdUrlTemplate.expand({
        messageId: startMessageConfig.messageId,
        variationId: startMessageConfig.variationId
    })}` : `${startMessageConfig.stargateUrl}${$ac3e3c5c710a4176$var$startMessageUrlTemplate.expand({
        messageId: startMessageConfig.messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(requestBody),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $fPMXA.pullResponseTextIfNotOk)).then($ac3e3c5c710a4176$var$handleStartStopMessageResponse);
}
async function $ac3e3c5c710a4176$var$stopMessageWithCoordination(stopMessageConfig) {
    const requestBody = {
        cloudId: stopMessageConfig.cloudId,
        orgId: stopMessageConfig.orgId,
        workspaceId: stopMessageConfig.workspaceId
    };
    return (0, $fPMXA.stargateFetchRetryOn5xx)(`${stopMessageConfig.stargateUrl}${$ac3e3c5c710a4176$var$stopMessageUrlTemplate.expand({
        messageId: stopMessageConfig.messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(requestBody),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $fPMXA.pullResponseTextIfNotOk)).then($ac3e3c5c710a4176$var$handleStartStopMessageResponse);
}
const $ac3e3c5c710a4176$var$userResponseUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse('/engage-targeting/api/v2/user/{cloudId}/messages/{messageId}/response');
async function $ac3e3c5c710a4176$export$e1fd1449cf83c1f5(cloudId, stargateUrl, messageId, payload) {
    return (0, $fPMXA.stargateFetchRetryOn5xx)(`${stargateUrl}${$ac3e3c5c710a4176$var$userResponseUrlTemplate.expand({
        cloudId: cloudId,
        messageId: messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(payload),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $fPMXA.pullResponseTextIfNotOk)).then(()=>Promise.resolve());
}
const $ac3e3c5c710a4176$var$markSeenAndFatigueUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse('/engage-targeting/api/v2/user/messages/{messageId}/seen');
async function $ac3e3c5c710a4176$export$3683393f780c6905(seenMessageConfig) {
    const requestBody = {
        cloudId: seenMessageConfig.cloudId,
        orgId: seenMessageConfig.orgId,
        workspaceId: seenMessageConfig.workspaceId
    };
    return (0, $fPMXA.stargateFetchRetryOn5xx)(`${seenMessageConfig.stargateUrl}${$ac3e3c5c710a4176$var$markSeenAndFatigueUrlTemplate.expand({
        messageId: seenMessageConfig.messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(requestBody),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $fPMXA.pullResponseTextIfNotOk)).then(()=>Promise.resolve());
}

});
parcelRegister("9RC8H", function(module, exports) {

$parcel$export(module.exports, "ProductIds", () => $72e6a5f341c7094f$export$7fb117db98868be6);
$parcel$export(module.exports, "EngagekitChoreographerPlugin", () => $72e6a5f341c7094f$export$da23bd36e2d631b);
$parcel$export(module.exports, "choreographerFactory", () => $72e6a5f341c7094f$export$55d2aeb17c4cfbe);

var $jjPOi = parcelRequire("jjPOi");

var $kS1lt = parcelRequire("kS1lt");

var $aYU4Z = parcelRequire("aYU4Z");
var $hRleJ = parcelRequire("hRleJ");

var $eUqFw = parcelRequire("eUqFw");
const $72e6a5f341c7094f$export$d33b097e0a285bc2 = {
    START: "start",
    STOP: "stop"
};
const $72e6a5f341c7094f$export$f6a9504bc1305cf0 = {
    ATTEMPTED: "attempted",
    BLOCKED: "blocked",
    OPTED_OUT: "optedout",
    STARTED: "started",
    STOPPED: "stopped",
    UNREGISTERED: "unregistered"
};
var $72e6a5f341c7094f$export$7fb117db98868be6;
(function(ProductIds) {
    ProductIds["CONFLUENCE"] = "confluence";
    ProductIds["ENGAGEKIT"] = "Engagekit";
    ProductIds["INTERCOM"] = "intercom";
    ProductIds["JIRA"] = "jira";
    ProductIds["PENDO"] = "pendo";
})($72e6a5f341c7094f$export$7fb117db98868be6 || ($72e6a5f341c7094f$export$7fb117db98868be6 = {}));
// This timeout is used for any long-running messages that are either stuck for some reason, or that the user has yet to clear, to ensure that messaging doesn't stay blocked indefinitely
const $72e6a5f341c7094f$var$$050d2fc04d46c1a4$var$CHOREOGRAPHER_MESSAGE_TTL = 300000; // 5 minute TTL for messages
// Lazily instantiate this the first time it's requested
let $72e6a5f341c7094f$var$$050d2fc04d46c1a4$var$singleton;
class $72e6a5f341c7094f$export$236158f15971c92e {
    /**
	 * Static method to create and/or return a singleton of the choreographer API.
	 *
	 * @returns Shared instance of choreographer API.
	 */ static getInstance() {
        if (!$72e6a5f341c7094f$var$$050d2fc04d46c1a4$var$singleton) $72e6a5f341c7094f$var$$050d2fc04d46c1a4$var$singleton = new this();
        return $72e6a5f341c7094f$var$$050d2fc04d46c1a4$var$singleton;
    }
    stopCurrentMessage() {
        if (this.state.currentMessage) this.stopMessage(this.state.currentMessage.productId, this.state.currentMessage.messageId, this.state.currentMessage.analyticsClient, this.state.currentMessage.metricsData).then(()=>{
            // Manually clear the message TTL and reenable plugins here just in case the unregistered plugin's message denied the
            // stop request. We may still get a collision on-screen, but we're considering the message forcibly stopped at this
            // point, so need to allow new requests.
            this.clearMessageTtl();
            this.enablePlugins();
        });
    }
    /**
	 * Pushes all data associated with a startMessage request onto an internal queue, to potentially be processed at a later time.
	 * If a pending message request opts out (or otherwise fails to start), this data will be used to reinitiate the startMessage
	 * request for this message request instance. Returns a Promise that the caller can await as normal, and which will eventually
	 * either be resolved as 'blocked' if any prior pending message is started, or will be resolved with its eventual outcome when
	 * its startMessage request is processed.
	 *
	 * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
	 * @param messageId Unique identifier for the messageId that triggered this message timeout.
	 * @param analyticsClient The analytics client to be used for logging/metrics.
	 * @param metricsData Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance to prevent from being disabled when this request starts.
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
	 */ queueMessage(productId, messageId, analyticsClient, metricsData, plugin) {
        return new Promise((resolve)=>{
            this.state.messageQueue.push({
                productId: productId,
                messageId: messageId,
                analyticsClient: analyticsClient,
                metricsData: metricsData,
                plugin: plugin,
                resolve: resolve
            });
        });
    }
    /**
	 * Responsible for pulling a previously queued message request that was received while a message request was already in flight.
	 * Shift the first message off the top of the queue, and use the stored resolve function to kickstart another pass through the
	 * startMessage function, ultimately resolving with the final disposition of the request. Set the internal state for shouldQueueMessages
	 * to false if we're restarting a startMessage request, so that this doesn't get immediately thrown back into the queue. If it
	 * makes it through to its start callback being fired, that code will turn the shouldQueueMessages state back on.
	 */ processQueuedMessage() {
        const queuedMessage = this.state.messageQueue.shift();
        // Disable the shouldQueueMessages state here. If we have a queued message, it will turn the shouldQueueMessages state back on when it
        // hits the call to its message's startCallback function. Otherwise, the queue is now empty, and we let things process normally.
        this.state.shouldQueueMessages = false;
        if (queuedMessage) queuedMessage.resolve(this.startMessage(queuedMessage.productId, queuedMessage.messageId, queuedMessage.analyticsClient, queuedMessage.metricsData, queuedMessage.plugin));
    }
    /**
	 * Responsible for flushing out any queued messages and resolving their Promises as "blocked". We don't officially consider a
	 * message as "blocked" until one of the prior calls has signaled a valid "started" state. This way, any async callbacks that
	 * are in flight can allow additional messages to queue up, and if they eventually opt out, we can move on to the next message
	 * in the queue and see if it will signal success. Only when we get a successful start to we consider all queued up messages to
	 * be "blocked". Run a loop to shift each of them off of the array and resolve them as blocked, until the array is empty.
	 */ destroyMessageQueue() {
        this.state.shouldQueueMessages = false;
        while(this.state.messageQueue.length > 0){
            const { analyticsClient: analyticsClient, messageId: messageId, metricsData: metricsData, productId: productId, resolve: resolve } = this.state.messageQueue.shift();
            const attributes = (0, $kS1lt._)((0, $jjPOi._)({}, metricsData), {
                productId: productId,
                messageId: messageId
            });
            this.sendOperationalEvent($72e6a5f341c7094f$export$f6a9504bc1305cf0.BLOCKED, "messageStart", messageId, attributes, analyticsClient);
            resolve($72e6a5f341c7094f$export$f6a9504bc1305cf0.BLOCKED);
        }
    }
    /**
	 * Sets a timeout to auto-expire any messaging that stays open for too long, to prevent messaging from being blocked indefinitely.
	 *
	 * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
	 * @param messageId Unique identifier for the messageId that triggered this message timeout.
	 * @param AnalyticsClient The analytics client to be used for logging/metrics.
	 * @param metricsData Additional data from plugin to be sent for metrics logging.
	 */ setMessageTtl(productId, messageId, analyticsClient, metricsData) {
        this.state.currentMessage = {
            productId: productId,
            messageId: messageId,
            analyticsClient: analyticsClient,
            metricsData: metricsData
        };
        this.state.messageTtl = setTimeout(()=>{
            if (this.isCurrentMessage(productId, messageId)) this.stopCurrentMessage();
        }, $72e6a5f341c7094f$var$$050d2fc04d46c1a4$var$CHOREOGRAPHER_MESSAGE_TTL);
    }
    /**
	 * Checks to see if the requesting productId/messageId pair matches the data for the currently-displayed message.
	 *
	 * @param productId Unique identifier for the product being checked for a current message match.
	 * @param messageId Unique identifier for the messageId being checked for a current message match.
	 * @param AnalyticsClient The analytics client to be used for logging/metrics.
	 * @param metricsData Additional data from plugin to be sent for metrics logging.
	 */ isCurrentMessage(productId, messageId) {
        return this.state.currentMessage && this.state.currentMessage.productId === productId && this.state.currentMessage.messageId === messageId;
    }
    /**
	 * Clears the timeout that was established for the currently-displayed message.
	 */ clearMessageTtl() {
        this.state.currentMessage = null;
        if (this.state.messageTtl) clearTimeout(this.state.messageTtl);
    }
    /**
	 * Disables all plugins that are currently registered with the choreographer, called when a startMessage call is being dispatched.
	 *
	 * @param [exceptFor] An optional plugin instance to exclude from the items being disabled, e.g. the plugin responsible for the current startMessage call.
	 */ disablePlugins(exceptFor) {
        this.state.isDisabled = true;
        [
            ...this.state.plugins.values()
        ].forEach((p)=>{
            if (p !== exceptFor) p.disable();
        });
    }
    /**
	 * Enables all plugins that are currently registered with the choreographer, called when a matching stopMessage call is successful.
	 */ enablePlugins() {
        [
            ...this.state.plugins.values()
        ].forEach((p)=>p.enable());
        this.state.isDisabled = false;
    }
    /**
	 * A callback used to remove a plugin from the list of subscribers for the choreographer service.
	 *
	 * @param productId A unique string representing the plugin to be unregistered from the choreographer API.
	 */ unregisterPlugin(productId) {
        var _this_state_currentMessage;
        // If we're unregistering this productId's plugin, and the currentMessage is from this productId, we need to stop it to clear the choreographer
        if (((_this_state_currentMessage = this.state.currentMessage) === null || _this_state_currentMessage === void 0 ? void 0 : _this_state_currentMessage.productId) === productId) this.stopCurrentMessage();
        this.state.messages.delete(productId);
        this.state.plugins.delete(productId);
    }
    /**
	 * Determines whether any message is currently being displayed, by checking its own status and optionally, asking each registered plugin for its individual status.
	 *
	 * @returns A value reflecting whether a message is currently being displayed on screen.
	 */ isDisplayingMessage() {
        return !!this.state.currentMessage || [
            ...this.state.plugins.values()
        ].reduce((isDisplayingMessage, p)=>{
            return isDisplayingMessage || p.isDisplayingMessage();
        }, false);
    }
    /**
	 * This function is intended for test cleanup purposes only, *not* to be called by external callers.
	 *
	 * @ignore
	 * @param productId Unique identifier for the product whose messages are being requested
	 * @returns A Map of IMessage objects, keyed by unique messageId strings.
	 */ getMessages(productId) {
        var _this_state_messages_get;
        return (_this_state_messages_get = this.state.messages.get(productId)) !== null && _this_state_messages_get !== void 0 ? _this_state_messages_get : new Map();
    }
    /**
	 * Requests to start a message via the choreographer service, ensuring only a single message instance at a time on the screen.
	 * A successful request will block any other message attempts until such time as the matching stopMessage request is received,
	 * or a message TTL timeout has expired.
	 *
	 * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
	 * @param messageId Unique identifier for the messageId that triggered this message timeout.
	 * @param analyticsClient The analytics client to be used for logging/metrics.
	 * @param metricsData Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance to prevent from being disabled when this request starts.
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
	 */ async startMessage(productId, messageId, analyticsClient, metricsData = {}, plugin) {
        const attributes = (0, $kS1lt._)((0, $jjPOi._)({}, metricsData), {
            productId: productId,
            messageId: messageId
        });
        const messageStart = "messageStart";
        this.sendOperationalEvent($72e6a5f341c7094f$export$f6a9504bc1305cf0.ATTEMPTED, messageStart, messageId, attributes, analyticsClient);
        if (!this.hasMessageRecord(productId, messageId)) {
            // Bail early here, before even checking if we're in a queueing situation, or blocked, or anything else
            this.sendOperationalEvent($72e6a5f341c7094f$export$f6a9504bc1305cf0.UNREGISTERED, messageStart, messageId, attributes, analyticsClient);
            return $72e6a5f341c7094f$export$f6a9504bc1305cf0.UNREGISTERED;
        }
        // If we're currently queueing messages, push this one onto the queue and return the new Promise
        if (this.state.shouldQueueMessages) return this.queueMessage(productId, messageId, analyticsClient, metricsData, plugin);
        if (this.state.isDisabled || this.isDisplayingMessage()) {
            this.sendOperationalEvent($72e6a5f341c7094f$export$f6a9504bc1305cf0.BLOCKED, messageStart, messageId, attributes, analyticsClient);
            return $72e6a5f341c7094f$export$f6a9504bc1305cf0.BLOCKED;
        }
        const message = this.ensureMessageRecord(productId, messageId);
        this.state.shouldQueueMessages = true;
        var _ref;
        const didStart = (_ref = await message.start()) !== null && _ref !== void 0 ? _ref : true;
        if (didStart) {
            this.disablePlugins(plugin);
            this.sendOperationalEvent($72e6a5f341c7094f$export$f6a9504bc1305cf0.STARTED, messageStart, messageId, attributes, analyticsClient);
            this.setMessageTtl(productId, messageId, analyticsClient, metricsData);
            // Successfully started the message, flush the queue and mark any pending requests as "blocked"
            this.destroyMessageQueue();
            return $72e6a5f341c7094f$export$f6a9504bc1305cf0.STARTED;
        }
        // Check to see if we have any pending requests in the message queue and attempt to start the next one in line
        this.processQueuedMessage();
        this.sendOperationalEvent($72e6a5f341c7094f$export$f6a9504bc1305cf0.OPTED_OUT, messageStart, messageId, attributes, analyticsClient);
        return $72e6a5f341c7094f$export$f6a9504bc1305cf0.OPTED_OUT;
    }
    /**
	 * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
	 *
	 * @param productId Unique identifier for the product making the current stopMessage request.
	 * @param messageId Unique identifier for the messageId to be stopped.
	 * @param analyticsClient The analytics client to be used for logging/metrics.
	 * @param metricsData Additional data from plugin to be sent for metrics logging.
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
	 */ async stopMessage(productId, messageId, analyticsClient, metricsData = {}) {
        const attributes = (0, $kS1lt._)((0, $jjPOi._)({}, metricsData), {
            productId: productId,
            messageId: messageId
        });
        const messageStop = "messageStop";
        this.sendOperationalEvent($72e6a5f341c7094f$export$f6a9504bc1305cf0.ATTEMPTED, messageStop, messageId, attributes, analyticsClient);
        if (!this.hasMessageRecord(productId, messageId)) {
            this.sendOperationalEvent($72e6a5f341c7094f$export$f6a9504bc1305cf0.UNREGISTERED, messageStop, messageId, attributes, analyticsClient);
            return $72e6a5f341c7094f$export$f6a9504bc1305cf0.UNREGISTERED;
        }
        const message = this.ensureMessageRecord(productId, messageId);
        var _ref;
        const didStop = (_ref = await message.stop()) !== null && _ref !== void 0 ? _ref : true;
        if (didStop) {
            this.sendOperationalEvent($72e6a5f341c7094f$export$f6a9504bc1305cf0.STOPPED, messageStop, messageId, attributes, analyticsClient);
            // Only clear the message TTL and reenable plugins if we're stopping the *current* message
            if (this.isCurrentMessage(productId, messageId)) {
                this.clearMessageTtl();
                this.enablePlugins();
            }
            return $72e6a5f341c7094f$export$f6a9504bc1305cf0.STOPPED;
        }
        this.sendOperationalEvent($72e6a5f341c7094f$export$f6a9504bc1305cf0.OPTED_OUT, messageStop, messageId, attributes, analyticsClient);
        return $72e6a5f341c7094f$export$f6a9504bc1305cf0.OPTED_OUT;
    }
    /**
	 * Registers a plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
	 *
	 * @param productId Unique identifier to register as the product owner of this plugin.
	 * @param plugin A plugin instance to be registered with the choreographer instance.
	 * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
	 */ registerPlugin(productId, plugin) {
        if (this.state.plugins.has(productId)) throw new Error(`Choreographer plugin already registered for ${productId}!`);
        this.state.plugins = this.state.plugins.set(productId, plugin);
        if (this.state.isDisabled) plugin.disable();
        return ()=>{
            this.unregisterPlugin(productId);
        };
    }
    /**
	 * Validates that a message record is present and ready to be retrieved and/or manipulated.
	 * Creates the message instance if it doesn't yet exist, initializing both start and stop callbacks to noop functions.
	 *
	 * @param productId Unique identifier to retrieve map of IMessage objects.
	 * @param messageId Unique identifier for the messageId to be retrieved.
	 * @returns IMessage object for the requested productId/messageId combination.
	 */ ensureMessageRecord(productId, messageId) {
        let productMessages = this.state.messages.get(productId);
        if (!productMessages) {
            productMessages = new Map();
            this.state.messages.set(productId, productMessages);
        }
        let message = productMessages.get(messageId);
        if (!message) {
            message = {
                [$72e6a5f341c7094f$export$d33b097e0a285bc2.START]: ()=>{},
                [$72e6a5f341c7094f$export$d33b097e0a285bc2.STOP]: ()=>{}
            };
            productMessages.set(messageId, message);
        }
        return message;
    }
    /**
	 * Checks for the existance of a message record for a given productId/messageId combination.
	 *
	 * @param productId Unique identifier to check for a map of IMessage objects.
	 * @param messageId Unique identifier to check for within the map of productId IMessage objects.
	 * @returns Boolean indicating whether or not an IMessage record exists for the requested productId/messageId combination.
	 */ hasMessageRecord(productId, messageId) {
        var _this_state_messages_get_has, _this_state_messages_get;
        return !!((_this_state_messages_get = this.state.messages.get(productId)) === null || _this_state_messages_get === void 0 ? void 0 : (_this_state_messages_get_has = _this_state_messages_get.has) === null || _this_state_messages_get_has === void 0 ? void 0 : _this_state_messages_get_has.call(_this_state_messages_get, messageId));
    }
    /**
	 * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for this message subscription.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
	 * @param options An object containing start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
	 */ on(productId, messageId, options = {}) {
        const message = (0, $jjPOi._)({}, this.ensureMessageRecord(productId, messageId), options);
        this.state.messages.get(productId).set(messageId, message);
    }
    /**
	 * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for this message subscription.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
	 * @param startCallback A callback to be invoked upon successful requests to startMessage.
	 */ onStart(productId, messageId, startCallback) {
        this.on(productId, messageId, {
            start: startCallback
        });
    }
    /**
	 * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for this message subscription.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
	 * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
	 */ onStop(productId, messageId, stopCallback) {
        this.on(productId, messageId, {
            stop: stopCallback
        });
    }
    /**
	 * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for unsubscribing this message.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for unsubscribing this message.
	 */ off(productId, messageId) {
        var _this_state_messages_get_delete, _this_state_messages_get;
        (_this_state_messages_get = this.state.messages.get(productId)) === null || _this_state_messages_get === void 0 || (_this_state_messages_get_delete = _this_state_messages_get.delete) === null || _this_state_messages_get_delete === void 0 || _this_state_messages_get_delete.call(_this_state_messages_get, messageId);
    }
    /**
	 * Send operational event to the Analytics web client for logging/metrics.
	 *
	 * @param action Past tense verb describing the action.
	 * @param actionSubject Component type involved in the action.
	 * @param actionSubjectId Unique instance of the component.
	 * @param metricsData Additional data from plugin to be sent with event for metrics logging.
	 */ sendOperationalEvent(action, actionSubject, actionSubjectId, metricsData, analyticsClient) {
        analyticsClient.sendOperationalEvent({
            source: "choreographer",
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: metricsData,
            tags: [
                "postOffice"
            ]
        });
    }
    constructor(){
        this.state = {
            currentMessage: null,
            isDisabled: false,
            messages: new Map(),
            messageQueue: [],
            messageTtl: null,
            plugins: new Map(),
            shouldQueueMessages: false
        };
    }
}
class $72e6a5f341c7094f$var$$4a746911eb0f0d11$export$71324a662782c710 {
    /**
	 * This function wraps a passed start or stop callback in an extra layer responsible for setting the internal
	 * state of the isDisplayingMessage bit. This is necessary because the core Choreographer module also provides
	 * a timeout mechanism by which a message will be forcefully stopped, but that only invokes the registered stop
	 * callback itself, which is responsible for setting state at the local consuming layer. In the case of a timeout
	 * being triggered for a plugin's requested startMessage attempt, the local consuming layer would, in theory toggle
	 * display state off and report that back to the Choreographer, but the plugin would have no knowledge of that,
	 * and would continue internally reporting that a message was being displayed. By decorating our start and stop
	 * callbacks before registering them with the Choreographer, we can guarantee that when those callbacks are
	 * invoked, the state is set appropriately, within the plugin, without the Choreographer needing to reach inside
	 * the plugin to handle that itself, breaking the rules of encapsulation.
	 *
	 * @param isDisplayingMessage The state to set the internal isDisplayingMessage boolean to upon a successful start or stop message callback request.
	 * @param callback The start or stop callback to be decorated.
	 * @returns The ultimate result of the original callback, or undefined.
	 */ decorateWithMessageDisplayStatus(isDisplayingMessage, callback) {
        return async (...args)=>{
            if (callback) {
                var _ref;
                const result = (_ref = await (callback === null || callback === void 0 ? void 0 : callback(...args))) !== null && _ref !== void 0 ? _ref : true;
                if (result) this.state.isDisplayingMessage = isDisplayingMessage;
                return result;
            }
            this.state.isDisplayingMessage = isDisplayingMessage;
            return;
        };
    }
    /**
	 * Public method to clean up this plugin instance, which will handle unregistering it from the choreographer API.
	 */ destroy() {
        this.state.unregisterPlugin();
    }
    /**
	 * Determines whether this plugin is currently displaying a message on the screen. By default, is a simple boolean
	 * toggle that gets flipped back and forth, but it could also be a function that checks the DOM for a given message
	 * container to be present, or checks with some external API to tell it whether a message is being displayed, or
	 * anything else. The logic is up to the consumer to implement, if something custom is desired.
	 *
	 * @returns A boolean that represents whether this plugin is currently displaying a message on the screen.
	 */ isDisplayingMessage() {
        return this.state.isDisplayingMessage;
    }
    /**
	 * Disables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
	 * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
	 * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
	 */ disable() {
        this.state.isDisabled = true;
    }
    /**
	 * Enables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
	 * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
	 * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
	 */ enable() {
        this.state.isDisabled = false;
    }
    /**
	 * Makes a request to start a message through the choreographer API. Will immediately return false if this plugin
	 * is currently in a disabled state, and will otherwise return the ultimate result of the startMessage request.
	 *
	 * @param messageId The messageId for the message to be started through the choreographer API.
	 * @param additionalData An object containing additional metadata to be sent along with the message start request
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
	 */ async startMessage(messageId, additionalData = {}) {
        return $72e6a5f341c7094f$export$236158f15971c92e.getInstance().startMessage(this.state.productId, messageId, this.analyticsClient, (0, $jjPOi._)({}, this.state.metaMetricsData, additionalData), this);
    }
    /**
	 * Makes a request to stop a message through the choreographer API. Will return the ultimate result of the stopMessage request.
	 *
	 * @param messageId The messageId for the message to be stopped through the choreographer API.
	 * @param additionalData An object containing additional metadata to be sent along with the message stop request
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
	 */ async stopMessage(messageId, additionalData = {}) {
        return $72e6a5f341c7094f$export$236158f15971c92e.getInstance().stopMessage(this.state.productId, messageId, this.analyticsClient, (0, $jjPOi._)({}, this.state.metaMetricsData, additionalData));
    }
    /**
	 * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
	 * @param options An object containing start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
	 */ on(messageId, options) {
        return $72e6a5f341c7094f$export$236158f15971c92e.getInstance().on(this.state.productId, messageId, {
            start: this.decorateWithMessageDisplayStatus(true, options.start),
            stop: this.decorateWithMessageDisplayStatus(false, options.stop)
        });
    }
    /**
	 * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
	 * @param startCallback A callback to be invoked upon successful requests to startMessage.
	 */ onStart(messageId, startCallback) {
        return $72e6a5f341c7094f$export$236158f15971c92e.getInstance().onStart(this.state.productId, messageId, this.decorateWithMessageDisplayStatus(true, startCallback));
    }
    /**
	 * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
	 * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
	 */ onStop(messageId, stopCallback) {
        return $72e6a5f341c7094f$export$236158f15971c92e.getInstance().onStop(this.state.productId, messageId, this.decorateWithMessageDisplayStatus(false, stopCallback));
    }
    /**
	 * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for unsubscribing this message subscription.
	 */ off(messageId) {
        return $72e6a5f341c7094f$export$236158f15971c92e.getInstance().off(this.state.productId, messageId);
    }
    /**
	 * Registers this plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
	 *
	 * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
	 * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
	 */ registerPlugin(productId) {
        return $72e6a5f341c7094f$export$236158f15971c92e.getInstance().registerPlugin(productId, this);
    }
    /**
	 * Creates a new instance of the Analytics Web Client for a plugin to use for sending analytics events.
	 *
	 * @param env environment type used to create the analytics client
	 * @returns AnalyticsWebClient instance
	 */ createAnalyticsClient(env) {
        const analyticsClient = new (0, $aYU4Z.default)({
            env: env,
            product: "postOffice",
            origin: (0, $hRleJ.originType).WEB
        });
        return analyticsClient;
    }
    /**
	 * Instantiates a plugin to be used with the main choreographer API. Requires a productId string
	 * to be used for segmenting registered messageIds in other parts of the API, which ensures uniqueness
	 * between individual products for tracking purposes.
	 *
	 * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
	 * @param env The environment type for the product, to be used for analytics events.
	 * @param metaMetricsData An object containing additional metadata to be sent along with every message request.
	 * @returns A new instance of this plugin to use for integrating a 1P or 3P product with the choreographer API.
	 */ constructor(productId, env, metaMetricsData = {}){
        this.state = {
            isDisabled: false,
            isDisplayingMessage: false,
            metaMetricsData: metaMetricsData,
            productId: productId,
            unregisterPlugin: ()=>{}
        };
        this.analyticsClient = this.createAnalyticsClient(env);
        this.state.unregisterPlugin = this.registerPlugin(productId);
    }
}
class $72e6a5f341c7094f$export$da23bd36e2d631b extends $72e6a5f341c7094f$var$$4a746911eb0f0d11$export$71324a662782c710 {
    async startMessageWithPlugin(messageId, callback, additionalData = {}) {
        // Do a just-in-time message start subscription with our callback to stargate
        this.onStart(messageId, callback);
        /**
		 * Dispatch the request to start the message, and return the response, which will
		 * either be 'started' if successful, and anything else if unsuccessful. Convert
		 * that value with a boolean check, because the consumer only cares about true/false.
		 */ const result = await this.startMessage(messageId, additionalData);
        return result === $72e6a5f341c7094f$export$f6a9504bc1305cf0.STARTED;
    }
    async stopMessageWithPlugin(messageId, callback, additionalData = {}) {
        // Do a just-in-time message stop subscription with our callback to stargate
        this.onStop(messageId, callback);
        /**
		 * Dispatch the request to stop the message, and return the response, which will
		 * either be 'stopped' if successful, and anything else if unsuccessful. Convert
		 * that value with a boolean check, because the consumer only cares about true/false.
		 */ const result = await this.stopMessage(messageId, additionalData);
        return result === $72e6a5f341c7094f$export$f6a9504bc1305cf0.STOPPED;
    }
    constructor(env, metaMetricsData = {}){
        super($72e6a5f341c7094f$export$7fb117db98868be6.ENGAGEKIT, env, metaMetricsData);
    }
}
class $72e6a5f341c7094f$export$44bee9c9373d59fb extends $72e6a5f341c7094f$var$$4a746911eb0f0d11$export$71324a662782c710 {
    constructor(product, env, metaMetricsData = {}){
        super(product, env, metaMetricsData);
    }
}
function $72e6a5f341c7094f$export$55d2aeb17c4cfbe(productId, env, metaMetricsData = {}) {
    // Instantiate our plugin instance, passing the productId through for segmenting any messageId's from any other plugins
    const plugin = new $72e6a5f341c7094f$export$44bee9c9373d59fb(productId, env, metaMetricsData);
    /**
	 * React hook that provides startMessage and stopMessage functions that call through the plugin API with the provided messageId, for easy assignment to React event handlers.
	 *
	 * @param messageId The messageId to be provided to the choreographer API whenever the startMessage and stopMessage callbacks are invoked.
	 * @param startCallback A callback to be used to set local state that determines whether a message should be shown, e.g. a callback to a useState setter, or that dispatches to a reducer function.
	 * @param stopCallback A callback to be used to set local state that determines whether a message should be hidden, e.g. a callback to a useState setter, or that dispatches to a reducer function.
	 * @returns An object with startMessage and stopMessage callbacks, which contain references to the messageId to be passed to the choreographer API, so that the consumer no longer needs to specify that at call time.
	 */ function useChoreographer(messageId, { [$72e6a5f341c7094f$export$d33b097e0a285bc2.START]: startCallback, [$72e6a5f341c7094f$export$d33b097e0a285bc2.STOP]: stopCallback } = {}) {
        const isMessageStarted = (0, $eUqFw.useRef)(false);
        const startRef = (0, $eUqFw.useRef)(startCallback);
        const stopRef = (0, $eUqFw.useRef)(stopCallback);
        // Stable function reference that invokes the plugin's startMessage function, for use in components.
        const startMessage = (0, $eUqFw.useCallback)((...args)=>{
            plugin.onStart(messageId, ()=>startMessageCallback(...args));
            return plugin.startMessage(messageId);
        }, [
            messageId
        ]);
        // Callback that uses a ref to track any changes in the received startCallback parameter, so the caller doesn't have to worry about memoization
        const startMessageCallback = (0, $eUqFw.useCallback)(async (...args)=>{
            var _startRef_current;
            var _ref;
            const didMessageStart = (_ref = await ((_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.call(startRef, ...args))) !== null && _ref !== void 0 ? _ref : true;
            isMessageStarted.current = didMessageStart;
            return didMessageStart;
        }, [
            isMessageStarted
        ]);
        // Stable function reference that invokes the plugin's stopMessage function, for use in components.
        const stopMessage = (0, $eUqFw.useCallback)((...args)=>{
            plugin.onStop(messageId, ()=>stopMessageCallback(...args));
            return plugin.stopMessage(messageId);
        }, [
            messageId
        ]);
        // Callback that uses a ref to track any changes in the received stopCallback parameter, so the caller doesn't have to worry about memoization
        const stopMessageCallback = (0, $eUqFw.useCallback)(async (...args)=>{
            var _stopRef_current;
            var _ref;
            const didMessageStop = (_ref = await ((_stopRef_current = stopRef.current) === null || _stopRef_current === void 0 ? void 0 : _stopRef_current.call(stopRef, ...args))) !== null && _ref !== void 0 ? _ref : true;
            isMessageStarted.current = !didMessageStop;
            return didMessageStop;
        }, [
            isMessageStarted
        ]);
        // Stable function reference that invokes whichever start or stop handler is appropriate for the message's current display state.
        // Tracking this state with a ref allows us to know the current display state in real-time, so that potentially subsequent calls
        // can be made to toggle its state, without requiring tracking a useState value and requiring rerenders to update the callback
        // with the latest display state, and without generating false blocked messages from cached/outdated toggleMessage references.
        const toggleMessage = (0, $eUqFw.useCallback)(()=>{
            return isMessageStarted.current ? stopMessage() : startMessage();
        }, [
            isMessageStarted,
            startMessage,
            stopMessage
        ]);
        (0, $eUqFw.useEffect)(()=>{
            startRef.current = startCallback;
            stopRef.current = stopCallback;
        }, [
            startCallback,
            stopCallback
        ]);
        (0, $eUqFw.useEffect)(()=>{
            plugin.on(messageId, {
                start: async ()=>{
                    return await startMessage() === $72e6a5f341c7094f$export$f6a9504bc1305cf0.STARTED;
                },
                stop: async ()=>{
                    return await stopMessage() === $72e6a5f341c7094f$export$f6a9504bc1305cf0.STOPPED;
                }
            });
            return ()=>{
                // If unsubscribing, fire the stopMessageCallback one last time to ensure the component can clear the local state responsible for displaying its message
                plugin.stopMessage(messageId);
                plugin.off(messageId);
            };
        }, [
            messageId
        ]);
        // Return the wrapped startMessage and stopMessage functions to the consumer, which will route their requests through the choreographer API with the messageId proxied straight through on behalf of the caller
        return (0, $eUqFw.useMemo)(()=>({
                startMessage: startMessage,
                stopMessage: stopMessage,
                toggleMessage: toggleMessage
            }), [
            startMessage,
            stopMessage,
            toggleMessage
        ]);
    }
    // Return these items from the factory function for use within React products
    return {
        plugin: plugin,
        useChoreographer: useChoreographer
    };
}

});

const $7a66036879e6348d$export$3288b14b6745c572 = 204;
const $7a66036879e6348d$export$c09e7ea0fc79f34f = 409;
const $7a66036879e6348d$export$974c37534b0191b1 = 503;

parcelRegister("fPMXA", function(module, exports) {

$parcel$export(module.exports, "errorIfNotOk", () => $b87198e44175d9d5$export$4adbd37839ed7718);
$parcel$export(module.exports, "pullResponseTextIfNotOk", () => $b87198e44175d9d5$export$2ba4cde277adb6b1);
$parcel$export(module.exports, "stargateFetch", () => $b87198e44175d9d5$export$317bcea84a3bea48);
$parcel$export(module.exports, "stargateFetchRetryOn5xx", () => $b87198e44175d9d5$export$2d9a5db60a4c50cd);
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */ 

var $ibNDJ = parcelRequire("ibNDJ");
const $b87198e44175d9d5$export$3410cacbbaf2b385 = 60;
async function $b87198e44175d9d5$export$4adbd37839ed7718(response) {
    if (!response.ok) // We use the response body for two reasons:
    // 1. To ensure that we consume the response body, so that it gets reported on in Chrome DevTools
    // 2. It could have some useful information relevant to the error
    throw Error(`${response.status}: ${await response.text()}`);
    return response;
}
async function $b87198e44175d9d5$export$2ba4cde277adb6b1(response) {
    if (!response.ok) await response.text();
    return response;
}
function $b87198e44175d9d5$var$basicStargateRetryCondition(response) {
    const failureCategory = response.headers.get('X-Failure-Category');
    const failureCategoryIsThrottled = !!failureCategory && failureCategory.toLowerCase() === 'throttled';
    return response.status === (0, $7a66036879e6348d$export$974c37534b0191b1) && failureCategoryIsThrottled;
}
function $b87198e44175d9d5$export$317bcea84a3bea48(input, reqOptions, retryCondition = $b87198e44175d9d5$var$basicStargateRetryCondition) {
    return $b87198e44175d9d5$var$fetchWithRetry(input, retryCondition, $b87198e44175d9d5$export$d63a365100d81d24(reqOptions));
}
function $b87198e44175d9d5$export$2d9a5db60a4c50cd(input, reqOptions) {
    return $b87198e44175d9d5$export$317bcea84a3bea48(input, reqOptions, (response)=>response.status >= 500 && response.status <= 599);
}
function $b87198e44175d9d5$export$d63a365100d81d24(reqOptions) {
    return {
        ...reqOptions,
        credentials: (0, $ibNDJ.default).includes(location.host) ? 'include' : 'same-origin'
    };
}
function $b87198e44175d9d5$var$handleFetchResultAndRetryIfNeeded(fetchResult, retryCondition, retry) {
    return fetchResult.then((r)=>retryCondition(r) ? retry() : Promise.resolve(r)).catch(retry);
}
function $b87198e44175d9d5$var$fetchWithRetry(input, retryCondition, reqOptions) {
    return $b87198e44175d9d5$var$handleFetchResultAndRetryIfNeeded(fetch(input, reqOptions), retryCondition, ()=>$b87198e44175d9d5$var$retryFetchWithBackoff(input, retryCondition, reqOptions));
}
function $b87198e44175d9d5$var$retryFetchWithBackoff(input, retryCondition, reqOptions, waitTimeMinutes = 0) {
    return $b87198e44175d9d5$var$handleFetchResultAndRetryIfNeeded($b87198e44175d9d5$var$fetchAfter(input, waitTimeMinutes, reqOptions), retryCondition, ()=>$b87198e44175d9d5$var$retryFetchWithBackoff(input, retryCondition, reqOptions, Math.min(waitTimeMinutes === 0 ? 1 : waitTimeMinutes * 2, $b87198e44175d9d5$export$3410cacbbaf2b385)));
}
const $b87198e44175d9d5$export$1e8d24b3235d31db = 5000;
function $b87198e44175d9d5$var$fetchAfter(input, waitTimeMinutes, reqOptions) {
    const staggerDelay = Math.round(Math.random() * $b87198e44175d9d5$export$1e8d24b3235d31db);
    const delay = waitTimeMinutes ? waitTimeMinutes * 60000 + staggerDelay : 0;
    return new Promise((resolve, reject)=>{
        setTimeout(()=>{
            fetch(input, reqOptions).then(resolve).catch(reject);
        }, delay);
    });
}

});
parcelRegister("ibNDJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3dfc27d7ea13c5a$export$2e2bcd8739ae039);
var $d3dfc27d7ea13c5a$export$2e2bcd8739ae039 = [
    // Bitbucket Pipelines domains (is an iframe and require CORS)
    'bitbucket-pipelines.dev.public.atl-paas.net',
    'bitbucket-pipelines.staging.public.atl-paas.net',
    'bitbucket-pipelines.prod.public.atl-paas.net'
];

});





parcelRegister("50oJA", function(module, exports) {

$parcel$export(module.exports, "EngagementProvider", () => $3a502389dc76b7ce$export$83b8ae7ce7b4d59c);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $046kq = parcelRequire("046kq");

var $6l6Xk = parcelRequire("6l6Xk");

var $1Qivz = parcelRequire("1Qivz");

var $1Zvbf = parcelRequire("1Zvbf");

var $64G28 = parcelRequire("64G28");
var $jYVKV = parcelRequire("jYVKV");

var $eMQs7 = parcelRequire("eMQs7");

var $hHcrN = parcelRequire("hHcrN");

var $9LRfM = parcelRequire("9LRfM");

var $aY2VY = parcelRequire("aY2VY");

var $3DGOA = parcelRequire("3DGOA");

var $jtW6P = parcelRequire("jtW6P");

var $chBKx = parcelRequire("chBKx");
const $3a502389dc76b7ce$var$MAX_EVENT_QUEUE_SIZE = 100;
const $3a502389dc76b7ce$var$EK_LOADED_EVENT = 'engagement.inproduct.loaded';
const $3a502389dc76b7ce$export$5306bd00631dbf8c = 'ep.analyticEvent';
function $3a502389dc76b7ce$var$collapseEventToPayload(event) {
    const payload = {
        ...event.payload,
        context: {}
    };
    Object.assign(payload.context, ...event.context);
    return payload;
}
function $3a502389dc76b7ce$var$findMatchingTrigger(messageMapping, payload) {
    return Array.from(messageMapping.keys()).find((trigger)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($046kq)))(payload, trigger);
    });
}
function $3a502389dc76b7ce$var$fireExposureEvent(attributes, clientOrPromise) {
    const analyticsEvent = new (0, $64G28.default)({
        payload: {
            action: 'exposed',
            actionSubject: 'feature',
            actionSubjectId: attributes.flagKey,
            source: 'engagement-platform',
            attributes: attributes
        }
    });
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendTrackEvent(analyticsEvent.payload);
    });
}
function $3a502389dc76b7ce$var$getExposureAttributes(messageId, cohort, additionalProps) {
    return {
        reason: 'RULE_MATCH',
        ruleId: 'engagement.inproduct',
        flagKey: `engagement.inproduct.${messageId}`,
        value: cohort,
        ...additionalProps
    };
}
function $3a502389dc76b7ce$var$getBaseAttributes(messageId, variationId, componentId, locale) {
    return {
        messageId: messageId,
        variationId: variationId,
        componentIndex: componentId,
        locale: locale
    };
}
async function $3a502389dc76b7ce$export$473a2bbbfd90c87b(eventMapping, config, store, clientOrPromise, coordinationOptions) {
    const { locale: locale } = config;
    const { message: message, component: component } = eventMapping;
    if (message.holdout) {
        await (0, $eMQs7.startMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        await (0, $eMQs7.stopMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        $3a502389dc76b7ce$var$fireExposureEvent($3a502389dc76b7ce$var$getExposureAttributes(message.messageId, 'holdout', {
            locale: locale
        }), clientOrPromise);
        return;
    }
    if (component.componentId === 0) {
        const success = await (0, $eMQs7.startMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        if (success) {
            $3a502389dc76b7ce$var$fireExposureEvent($3a502389dc76b7ce$var$getExposureAttributes(message.messageId, message.variationId, {
                locale: locale
            }), clientOrPromise);
            store.dispatch((0, $jtW6P.setCurrent)(eventMapping));
        }
    } else {
        $3a502389dc76b7ce$var$fireExposureEvent($3a502389dc76b7ce$var$getExposureAttributes(message.messageId, message.variationId, {
            locale: locale
        }), clientOrPromise);
        store.dispatch((0, $jtW6P.setCurrent)(eventMapping));
    }
}
class $3a502389dc76b7ce$export$83b8ae7ce7b4d59c extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        (0, $5zQU9.default)(this, "onStoreChange", (state)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const config = this.getConfig();
            const { locale: locale } = config;
            if (state.initialized) {
                if (!$3a502389dc76b7ce$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider) {
                    this.sendOperationalEventWithClient({
                        action: 'loaded',
                        actionSubject: 'messages',
                        actionSubjectId: undefined,
                        source: 'engagekit',
                        attributes: {
                            locale: locale
                        }
                    });
                    const browserInfo = (0, $9LRfM.getBrowserInfo)();
                    this.onEvent(createAnalyticsEvent({
                        event: $3a502389dc76b7ce$var$EK_LOADED_EVENT,
                        properties: {
                            browser: browserInfo.name,
                            browserVersion: browserInfo.version
                        }
                    }));
                    $3a502389dc76b7ce$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider = true;
                }
                this.analyticsEventQueue.flush(this.onEvent);
                if (this.unsubscribeFromStore) this.unsubscribeFromStore();
            }
        });
        (0, $5zQU9.default)(this, "onEvent", (event)=>{
            const state = this.getState();
            if (!state.initialized) {
                const success = this.analyticsEventQueue.enqueue(event);
                if (!success) this.fireQueueOverflowEvent();
                return;
            }
            const { eventTarget: eventTarget, store: store, analyticsClientInstance: analyticsClientInstance } = this.props;
            const config = this.getConfig();
            const { current: current, messageMapping: messageMapping } = state;
            const payload = $3a502389dc76b7ce$var$collapseEventToPayload(event);
            eventTarget.dispatchEvent((0, $aY2VY.default)({
                eventName: $3a502389dc76b7ce$export$5306bd00631dbf8c,
                canBubble: false,
                cancellable: false,
                detail: payload
            }));
            if (!(0, $3DGOA.isMessagingEnabled)()) return;
            // existing message found
            if (current) return;
            const trigger = $3a502389dc76b7ce$var$findMatchingTrigger(messageMapping, payload);
            // No messages found for trigger
            if (!trigger) return;
            $3a502389dc76b7ce$export$473a2bbbfd90c87b(messageMapping.get(trigger), config, store, analyticsClientInstance, this.props.coordinationOptions);
        });
        (0, $5zQU9.default)(this, "onEngagementEvent", (event)=>{
            const { action: action, clickType: clickType, ekMessageId: ekMessageId, ekVariationId: ekVariationId, ekComponentId: ekComponentId, ekComponentType: ekComponentType, ekIsLast: ekIsLast } = event.payload;
            const config = this.getConfig();
            const { locale: locale } = config;
            const attributes = $3a502389dc76b7ce$var$getBaseAttributes(ekMessageId, ekVariationId, ekComponentId, locale);
            if (action === 'click') {
                this.handleClickEvent(ekMessageId, ekVariationId, ekComponentId);
                attributes.buttonType = clickType;
                this.sendUIEventWithClient({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: `${clickType}Button`,
                    source: `engagement_${ekComponentType}`,
                    attributes: attributes
                });
            } else {
                if (action === 'shown') {
                    attributes.componentType = ekComponentType;
                    this.sendScreenEventWithClient({
                        name: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                }
                if (action === 'hidden') {
                    attributes.isLast = ekIsLast;
                    this.sendUIEventWithClient({
                        action: 'hid',
                        actionSubject: 'component',
                        actionSubjectId: undefined,
                        source: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                }
            }
            this.onEvent(event);
        });
        (0, $5zQU9.default)(this, "subscribeEngagementState", (callback)=>{
            const { store: store } = this.props;
            callback(store.getState());
            return store.subscribe(()=>{
                callback(store.getState());
            });
        });
        const { analyticsClientInstance: _analyticsClientInstance } = this.props;
        this.sendUIEventWithClient = (0, $hHcrN.sendUIEvent).bind(null, _analyticsClientInstance);
        this.sendScreenEventWithClient = (0, $hHcrN.sendScreenEvent).bind(null, _analyticsClientInstance);
        this.sendOperationalEventWithClient = (0, $hHcrN.sendOperationalEvent).bind(null, _analyticsClientInstance);
        this.analyticsEventQueue = new (0, $chBKx.default)($3a502389dc76b7ce$var$MAX_EVENT_QUEUE_SIZE);
        this.unsubscribeFromStore = this.subscribeEngagementState(this.onStoreChange);
        this.fireQueueOverflowEvent = (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(// TODO: create metric for this with Metal
        ()=>{});
    }
    getConfig() {
        const { config: config } = this.getState();
        return config;
    }
    getChildContext() {
        return {
            subscribeEngagementState: this.subscribeEngagementState
        };
    }
    getState() {
        return this.props.store.getState();
    }
    getActiveMessage() {
        return this.getState().current;
    }
    completeMessage(messageId) {
        const config = this.getConfig();
        (0, $eMQs7.stopMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: messageId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, this.props.coordinationOptions);
    }
    handleClickEvent(messageId, variationId, componentId) {
        const activeMessage = this.getActiveMessage();
        // It is important to check that the event we're handling matches the
        // current active message because it is possible for an event to come
        // through for a past message. We don't want to mess up the current
        // message by calling clearCurrent just because the old message is done.
        if (!activeMessage || activeMessage.messageId !== messageId || activeMessage.variationId !== variationId || activeMessage.componentId !== componentId) return;
        if (activeMessage.isLast) this.completeMessage(messageId);
        this.props.store.dispatch((0, $jtW6P.clearCurrent)());
    }
    componentWillUnmount() {
        this.unsubscribeFromStore && this.unsubscribeFromStore();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYVKV.default), {
            channel: "*",
            onEvent: this.onEvent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYVKV.default), {
            channel: "engagement",
            onEvent: this.onEngagementEvent
        }, this.props.children));
    }
}
(0, $5zQU9.default)($3a502389dc76b7ce$export$83b8ae7ce7b4d59c, "childContextTypes", {
    subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
});
(0, $5zQU9.default)($3a502389dc76b7ce$export$83b8ae7ce7b4d59c, "defaultProps", {
    eventTarget: (0, (/*@__PURE__*/$parcel$interopDefault($1Zvbf)))
});
/*
 * We use this flag for ensuring that we only fire the engagement.inproduct.loaded event once. This is an interim solution
 * until we can more holistically rethink our code architecture to eliminate duplicate behaviour across EngagementProviders.
 */ (0, $5zQU9.default)($3a502389dc76b7ce$export$83b8ae7ce7b4d59c, "hasInitializedAtLeastOneEngagementProvider", false);

});
parcelRegister("hHcrN", function(module, exports) {

$parcel$export(module.exports, "sendScreenEvent", () => $ce201b936507312c$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendUIEvent", () => $ce201b936507312c$export$1aecf263098db667);
$parcel$export(module.exports, "sendOperationalEvent", () => $ce201b936507312c$export$e5f89b51c6d4e36b);
function $ce201b936507312c$export$22a3b1671f38a193(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendScreenEvent(payload);
    });
}
function $ce201b936507312c$export$1aecf263098db667(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendUIEvent(payload);
    });
}
function $ce201b936507312c$export$e5f89b51c6d4e36b(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendOperationalEvent(payload);
    });
}

});

parcelRegister("9LRfM", function(module, exports) {

$parcel$export(module.exports, "getBrowserInfo", () => $71d1cfdff44d149d$export$6c724a6ffa2dc3e1);
const $71d1cfdff44d149d$var$browserMatchers = [
    {
        name: 'IE',
        pattern: /Trident\/.*; rv:([^;)]+)/
    },
    {
        name: 'Chrome',
        pattern: /Chrome\/([^ )]+)/
    },
    {
        name: 'Firefox',
        pattern: /Firefox\/([^ )]+)/
    }
];
const $71d1cfdff44d149d$export$cda2203640e08931 = {
    name: 'unknown',
    version: 'unknown'
};
function $71d1cfdff44d149d$export$6c724a6ffa2dc3e1(userAgent) {
    if (!window.navigator) return $71d1cfdff44d149d$export$cda2203640e08931;
    if (!userAgent) userAgent = window.navigator.userAgent;
    for (const matcher of $71d1cfdff44d149d$var$browserMatchers){
        const versionMatch = userAgent.match(matcher.pattern);
        if (versionMatch) return {
            name: matcher.name,
            version: versionMatch[1]
        };
    }
    return $71d1cfdff44d149d$export$cda2203640e08931;
}

});

parcelRegister("aY2VY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fc1c8a37a2fe2ad$export$2e2bcd8739ae039);
// @ts-nocheck
const $7fc1c8a37a2fe2ad$var$createCustomEvent = ({ eventName: eventName, canBubble: canBubble, cancellable: cancellable, detail: detail })=>{
    const customEvent = document.createEvent('CustomEvent');
    customEvent.initCustomEvent(eventName, canBubble, cancellable, detail);
    return customEvent;
};
var $7fc1c8a37a2fe2ad$export$2e2bcd8739ae039 = $7fc1c8a37a2fe2ad$var$createCustomEvent;

});

parcelRegister("chBKx", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f145ad601520e72$export$2e2bcd8739ae039);
class $8f145ad601520e72$export$2e2bcd8739ae039 {
    constructor(maxSize){
        this.queue = [];
        this.maxSize = maxSize;
    }
    enqueue(item) {
        if (this.queue.length === this.maxSize) return false;
        this.queue.push(item);
        return true;
    }
    flush(callback) {
        this.queue.forEach(callback);
        this.queue = [];
    }
    getSize() {
        return this.queue.length;
    }
}

});



parcelRegister("9BA6k", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fe392a8ba42865b$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $cJt2B = parcelRequire("cJt2B");

var $49KuO = parcelRequire("49KuO");
function $6fe392a8ba42865b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6fe392a8ba42865b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6fe392a8ba42865b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6fe392a8ba42865b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $6fe392a8ba42865b$var$DEFAULT_TIMING = {
    initialPollInterval: 5000,
    idleTimeout: 30000,
    multiplierCallback: (x)=>x + x
};
class $6fe392a8ba42865b$export$2e2bcd8739ae039 {
    /**
   * Callback for sending a 'track' analytics event. This callback should either be the
   * 'sendTrackEvent' method on the AnalyticsWebClient, or a method that eventually delegates to it.
   * The data for the dwell event will be passed to this method for sending.
   *
   * @callback trackCallback
   * @param {Object} eventData - the base event data that will be added to the track event.
   */ /**
   * Creates and initialises the DwellTimeHelper.
   *
   * @param {trackCallback} trackCallback - the track callback responsible for actually sending
   * the event.
   * @param {Object} eventData - the base data that will be added to the track event.
   * Additional dwell time attributes will be appended to this data. Note that you don't need to
   * include the 'action' property, as this will be added automatically.
   * @param {?string} searchSessionId - a unique identifier for the related search session.
   * @param {?Object} timingOptions - for the purpose of debugging, you can override the default
   * timing used for measuring dwell time. The following values are possible:
   * - initialPollInterval: how long to wait before the first dwell milestone event
   * is fired (in seconds). Default = 5.
   * - pollBackoffRate: how much to multiply the last poll interval by on each dwell milestone.
   * event. Default = 2.
   * - idleTimeout: how long to wait for no user activity before pausing
   * the dwell timer (in seconds). Default = 30s.
   */ constructor(trackCallback, _eventData, _searchSessionId, timingOptions){
        /**
     * Starts the dwell timer. This method should be called upon the initial page load.
     */ (0, $5zQU9.default)(this, "start", ()=>{
            this.browserInteractionTime.startTimer();
            this.browserInteractionTime.addTimeIntervalEllapsedCallback({
                callback: (timeInMilliseconds)=>this._sendDwellEvent(this._eventData, this._searchSessionId, timeInMilliseconds, false),
                timeInMilliseconds: this._timing.initialPollInterval,
                multiplier: this._timing.multiplierCallback
            });
            if (typeof window !== 'undefined') window.addEventListener('beforeunload', this._onBeforeUnload);
        });
        /**
     * Stops the dwell timer and sends the final dwell event. Call this method if you wish to
     * finalise a dwell measurement without starting a new one. When switching to a new page in a
     * single-page app, use newPage instead.
     */ (0, $5zQU9.default)(this, "stop", ()=>{
            if (this.browserInteractionTime.isRunning()) this._sendDwellEvent(this._eventData, this._searchSessionId, this.browserInteractionTime.getTimeInMilliseconds(), true);
            this.browserInteractionTime.stopTimer();
        });
        /**
     * Send the final dwell event and reinitialise the dwell timer for a new page.
     * This method should be called whenever a new page is switched to in a single-page app context.
     *
     * @param {Object} eventData - the base data that will be added to the track event.
     * @param {?string} searchSessionId - the new search session ID.
     */ (0, $5zQU9.default)(this, "newPage", (eventData, searchSessionId)=>{
            (0, $49KuO.validateDwellBaseEvent)(eventData);
            this.stop();
            this.browserInteractionTime.reset();
            this.setEventData(eventData);
            this.setSearchSessionId(searchSessionId);
            this.start();
        });
        (0, $5zQU9.default)(this, "setEventData", (eventData)=>{
            this._eventData = eventData;
        });
        (0, $5zQU9.default)(this, "getEventData", ()=>this._eventData);
        (0, $5zQU9.default)(this, "setSearchSessionId", (searchSessionId)=>{
            this._searchSessionId = searchSessionId;
        });
        (0, $5zQU9.default)(this, "getSearchSessionId", ()=>this._searchSessionId);
        (0, $5zQU9.default)(this, "destroy", ()=>{
            this.browserInteractionTime.destroy();
            if (typeof window !== 'undefined') window.removeEventListener('beforeunload', this._onBeforeUnload);
        });
        (0, $5zQU9.default)(this, "_onBeforeUnload", ()=>{
            this.stop();
            this.destroy();
        });
        (0, $5zQU9.default)(this, "_sendDwellEvent", (eventData, searchSessionId, timeInMilliseconds, isFinalDwellEvent)=>{
            const dwellAttributes = {
                dwellTime: timeInMilliseconds,
                searchReferrer: searchSessionId,
                finalDwellEvent: isFinalDwellEvent
            };
            this._trackCallback({
                action: 'dwelled',
                actionSubject: eventData.actionSubject,
                actionSubjectId: eventData.actionSubjectId,
                source: eventData.source,
                containerType: eventData.containerType,
                containerId: eventData.containerId,
                objectType: eventData.objectType,
                objectId: eventData.objectId,
                attributes: $6fe392a8ba42865b$var$_objectSpread($6fe392a8ba42865b$var$_objectSpread({}, dwellAttributes), eventData.attributes),
                tags: eventData.tags
            });
        });
        if (!trackCallback) throw new Error('trackCallback is required for DwellTimeHelper');
        (0, $49KuO.validateDwellBaseEvent)(_eventData);
        this._trackCallback = trackCallback;
        this._eventData = _eventData;
        this._searchSessionId = _searchSessionId;
        this._timing = $6fe392a8ba42865b$var$_objectSpread($6fe392a8ba42865b$var$_objectSpread({}, $6fe392a8ba42865b$var$DEFAULT_TIMING), timingOptions);
        this.browserInteractionTime = new (0, $cJt2B.default)({
            idleTimeoutMs: this._timing.idleTimeout,
            checkCallbacksIntervalMs: 500
        });
    }
}

});

parcelRegister("5HTho", function(module, exports) {

$parcel$export(module.exports, "default", () => $427bd93f3fbf5030$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $6rgVQ = parcelRequire("6rgVQ");

var $49KuO = parcelRequire("49KuO");
function $427bd93f3fbf5030$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $427bd93f3fbf5030$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $427bd93f3fbf5030$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $427bd93f3fbf5030$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $427bd93f3fbf5030$var$DEFAULT_TIMING = {
    initialPollInterval: 5,
    pollBackoffRate: 2,
    idleTimeout: 30
};
class $427bd93f3fbf5030$export$2e2bcd8739ae039 {
    /**
   * Callback for sending a 'track' analytics event. This callback should either be the
   * 'sendTrackEvent' method on the AnalyticsWebClient, or a method that eventually delegates to it.
   * The data for the dwell event will be passed to this method for sending.
   *
   * @callback trackCallback
   * @param {Object} eventData - the base event data that will be added to the track event.
   */ /**
   * Creates and initialises the DwellTimeHelper.
   *
   * @param {trackCallback} trackCallback - the track callback responsible for actually sending
   * the event.
   * @param {Object} eventData - the base data that will be added to the track event.
   * Additional dwell time attributes will be appended to this data. Note that you don't need to
   * include the 'action' property, as this will be added automatically.
   * @param {?string} searchSessionId - a unique identifier for the related search session.
   * @param {?Object} timingOptions - for the purpose of debugging, you can override the default
   * timing used for measuring dwell time. The following values are possible:
   * - initialPollInterval: how long to wait before the first dwell milestone event
   * is fired (in seconds). Default = 5.
   * - pollBackoffRate: how much to multiply the last poll interval by on each dwell milestone.
   * event. Default = 2.
   * - idleTimeout: how long to wait for no user activity before pausing
   * the dwell timer (in seconds). Default = 30s.
   */ constructor(trackCallback, _eventData, _searchSessionId, timingOptions){
        (0, $5zQU9.default)(this, "timeMeInitialized", false);
        /**
     * Starts the dwell timer. This method should be called upon the initial page load.
     */ (0, $5zQU9.default)(this, "start", ()=>{
            if (this.timeMeInitialized) throw new Error('DwellTimeHelper should only be initialised once per page load.');
            this.timeMeInitialized = true;
            this._initDwellTimeCounterAndPolling();
            if (typeof window !== 'undefined') window.addEventListener('beforeunload', ()=>{
                this.stop();
            });
        });
        /**
     * Stops the dwell timer and sends the final dwell event. Call this method if you wish to
     * finalise a dwell measurement without starting a new one. When switching to a new page in a
     * single-page app, use newPage instead.
     */ (0, $5zQU9.default)(this, "stop", ()=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($6rgVQ))).isUserCurrentlyOnPage) this._sendDwellEvent(this._eventData, this._searchSessionId, true);
            (0, (/*@__PURE__*/$parcel$interopDefault($6rgVQ))).stopAllTimers();
            (0, (/*@__PURE__*/$parcel$interopDefault($6rgVQ))).resetAllRecordedPageTimes();
            (0, (/*@__PURE__*/$parcel$interopDefault($6rgVQ))).timeElapsedCallbacks = [];
            this.timeMeInitialized = false;
        });
        /**
     * Send the final dwell event and reinitialise the dwell timer for a new page.
     * This method should be called whenever a new page is switched to in a single-page app context.
     *
     * @param {Object} eventData - the base data that will be added to the track event.
     * @param {?string} searchSessionId - the new search session ID.
     */ (0, $5zQU9.default)(this, "newPage", (eventData, searchSessionId)=>{
            (0, $49KuO.validateDwellBaseEvent)(eventData);
            this.stop();
            this._eventData = eventData;
            this._searchSessionId = searchSessionId;
            this._initDwellTimeCounterAndPolling();
        });
        (0, $5zQU9.default)(this, "_initDwellTimeCounterAndPolling", ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($6rgVQ))).initialize({
                idleTimeoutInSeconds: this._timing.idleTimeout
            });
            this._pollDwellTime(this._timing.initialPollInterval, this._searchSessionId, this._eventData);
        });
        (0, $5zQU9.default)(this, "_pollDwellTime", (pollTime, searchSessionId, eventData)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($6rgVQ))).callAfterTimeElapsedInSeconds(pollTime, ()=>{
                this._sendDwellEvent(eventData, searchSessionId, false);
                this._pollDwellTime(pollTime * this._timing.pollBackoffRate, searchSessionId, eventData);
            });
        });
        (0, $5zQU9.default)(this, "_sendDwellEvent", (eventData, searchSessionId, isFinalDwellEvent)=>{
            const dwellAttributes = {
                dwellTime: (0, (/*@__PURE__*/$parcel$interopDefault($6rgVQ))).getTimeOnCurrentPageInMilliseconds(),
                searchReferrer: searchSessionId,
                finalDwellEvent: isFinalDwellEvent
            };
            this._trackCallback({
                action: 'dwelled',
                actionSubject: eventData.actionSubject,
                actionSubjectId: eventData.actionSubjectId,
                source: eventData.source,
                containerType: eventData.containerType,
                containerId: eventData.containerId,
                containers: eventData.containers,
                objectType: eventData.objectType,
                objectId: eventData.objectId,
                attributes: $427bd93f3fbf5030$var$_objectSpread($427bd93f3fbf5030$var$_objectSpread({}, dwellAttributes), eventData.attributes),
                tags: eventData.tags
            });
        });
        if (!trackCallback) throw new Error('trackCallback is required for DwellTimeHelper');
        (0, $49KuO.validateDwellBaseEvent)(_eventData);
        this._trackCallback = trackCallback;
        this._eventData = _eventData;
        this._searchSessionId = _searchSessionId;
        this._timing = $427bd93f3fbf5030$var$_objectSpread($427bd93f3fbf5030$var$_objectSpread({}, $427bd93f3fbf5030$var$DEFAULT_TIMING), timingOptions);
    }
}

});

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $6bb2437d634f2335$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

const $deed61a8dba991fd$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $deed61a8dba991fd$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $deed61a8dba991fd$export$13f57c02915787b3 = 'atlaskit-portal';

const $7f8b23c982f78b1d$export$ed5835cc67e87f72 = 'akPortalMount';
const $7f8b23c982f78b1d$export$80816bd900e5bd00 = 'akPortalUnmount';

const $d58b680a02f4d6a4$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $d58b680a02f4d6a4$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $d58b680a02f4d6a4$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';

// same types defined in analytics-web-client but avoid creating dependency with that
const $662e33bb7444ae33$export$a1562d08625f5d7e = 'ui';
const $662e33bb7444ae33$export$947dac6c72b26f81 = 'track';
const $662e33bb7444ae33$export$f1d537d508d2945a = 'screen';
const $662e33bb7444ae33$export$12346a674644c156 = 'operational';
const $662e33bb7444ae33$export$b055de0e665cb20c = 'unknown';

const $b4cc463b68660864$export$d6830277b06edd6 = 'normal';
const $b4cc463b68660864$export$4f8f13a66ae77bdd = '--color';
const $b4cc463b68660864$export$e9244ec13bd422b5 = '--bg-color';
const $b4cc463b68660864$export$97e78d9745006c11 = '--bg-color-hover';
const $b4cc463b68660864$export$291d63757828f290 = '--bg-color-active';


$parcel$global.rlb("2Lfdl")
//# sourceMappingURL=shared~vendor~atlassian~ar.32caea00.js.map
